/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: any;
  /** A representation of a Firmware version can be Android or Scaler */
  ConfigFirmwareVersion: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. Known issues: if used as inline value in the field argument, it will not be converted to a Date object. */
  DateTime: string;
  /** A representation of a Firmware version can be Android or Scaler */
  FirmwareVersion: string;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). (Note: inline JSON field arguments may remain plain JS objects, not automatically coerced.) */
  JSON: any;
};

export type ActivateMultiClaimCodeInput = {
  /** The identifier of the display. */
  claimCodeName: Scalars['String'];
  /** The mute state that will be given to the display. */
  expiry: Scalars['Int'];
  /** The groups that will be associated to the displays. */
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  /** ID of the claim code */
  id: Scalars['String'];
  /** The prefix fot alias that will be given to the display. */
  prefix?: InputMaybe<Scalars['String']>;
  /** The site that will be associated to the display. */
  siteId?: InputMaybe<Scalars['ID']>;
};

/** The audited admin action. */
export enum ActivityLogAction {
  AccessRequestApprove = 'ACCESS_REQUEST_APPROVE',
  AccessRequestCreate = 'ACCESS_REQUEST_CREATE',
  AccessRequestReject = 'ACCESS_REQUEST_REJECT',
  AccessRequestRevoke = 'ACCESS_REQUEST_REVOKE',
  ApiKeyCreate = 'API_KEY_CREATE',
  ApiKeyRevoke = 'API_KEY_REVOKE',
  ClaimCodeActivate = 'CLAIM_CODE_ACTIVATE',
  ClaimCodeDelete = 'CLAIM_CODE_DELETE',
  ClaimCodeGenerate = 'CLAIM_CODE_GENERATE',
  ConfigurationAssign = 'CONFIGURATION_ASSIGN',
  ConfigurationAutoRestartUpdate = 'CONFIGURATION_AUTO_RESTART_UPDATE',
  ConfigurationBatteryPowerManagementUpdate = 'CONFIGURATION_BATTERY_POWER_MANAGEMENT_UPDATE',
  ConfigurationBookmarksUpdate = 'CONFIGURATION_BOOKMARKS_UPDATE',
  ConfigurationBrightnessUpdate = 'CONFIGURATION_BRIGHTNESS_UPDATE',
  ConfigurationBurnInRefreshUpdate = 'CONFIGURATION_BURN_IN_REFRESH_UPDATE',
  ConfigurationClone = 'CONFIGURATION_CLONE',
  ConfigurationContentSourceUpdate = 'CONFIGURATION_CONTENT_SOURCE_UPDATE',
  ConfigurationControlLockUpdate = 'CONFIGURATION_CONTROL_LOCK_UPDATE',
  ConfigurationCreate = 'CONFIGURATION_CREATE',
  ConfigurationDefaultContentSourceUpdate = 'CONFIGURATION_DEFAULT_CONTENT_SOURCE_UPDATE',
  ConfigurationDelete = 'CONFIGURATION_DELETE',
  ConfigurationDraftCreate = 'CONFIGURATION_DRAFT_CREATE',
  ConfigurationFirmwareUpdate = 'CONFIGURATION_FIRMWARE_UPDATE',
  ConfigurationGroupAdd = 'CONFIGURATION_GROUP_ADD',
  ConfigurationGroupRemove = 'CONFIGURATION_GROUP_REMOVE',
  ConfigurationLedStripColorUpdate = 'CONFIGURATION_LED_STRIP_COLOR_UPDATE',
  ConfigurationOrientationUpdate = 'CONFIGURATION_ORIENTATION_UPDATE',
  ConfigurationPortsLockUpdate = 'CONFIGURATION_PORTS_LOCK_UPDATE',
  ConfigurationPowerScheduleUpdate = 'CONFIGURATION_POWER_SCHEDULE_UPDATE',
  ConfigurationPowerUpdate = 'CONFIGURATION_POWER_UPDATE',
  ConfigurationPublish = 'CONFIGURATION_PUBLISH',
  ConfigurationRename = 'CONFIGURATION_RENAME',
  ConfigurationScheduleUpdate = 'CONFIGURATION_SCHEDULE_UPDATE',
  ConfigurationSignalDetectionUpdate = 'CONFIGURATION_SIGNAL_DETECTION_UPDATE',
  ConfigurationSiteUpdate = 'CONFIGURATION_SITE_UPDATE',
  ConfigurationSync = 'CONFIGURATION_SYNC',
  ConfigurationTimeZoneUpdate = 'CONFIGURATION_TIME_ZONE_UPDATE',
  ConfigurationUnassign = 'CONFIGURATION_UNASSIGN',
  ConfigurationVolumeLimitUpdate = 'CONFIGURATION_VOLUME_LIMIT_UPDATE',
  ConfigurationVolumeMuteUpdate = 'CONFIGURATION_VOLUME_MUTE_UPDATE',
  ConfigurationVolumeUpdate = 'CONFIGURATION_VOLUME_UPDATE',
  CustomerCreate = 'CUSTOMER_CREATE',
  CustomerDefaultConfigurationUpdate = 'CUSTOMER_DEFAULT_CONFIGURATION_UPDATE',
  CustomerDelete = 'CUSTOMER_DELETE',
  CustomerNotificationEmailUpdate = 'CUSTOMER_NOTIFICATION_EMAIL_UPDATE',
  CustomerNotificationSettingsUpdate = 'CUSTOMER_NOTIFICATION_SETTINGS_UPDATE',
  CustomerNotificationStatusUpdate = 'CUSTOMER_NOTIFICATION_STATUS_UPDATE',
  CustomerUpdate = 'CUSTOMER_UPDATE',
  DisplayAgentReleaseChannelUpdate = 'DISPLAY_AGENT_RELEASE_CHANNEL_UPDATE',
  DisplayAlertResolve = 'DISPLAY_ALERT_RESOLVE',
  DisplayAliasUpdate = 'DISPLAY_ALIAS_UPDATE',
  DisplayAppInstall = 'DISPLAY_APP_INSTALL',
  DisplayAppUninstall = 'DISPLAY_APP_UNINSTALL',
  DisplayAutoRestartUpdate = 'DISPLAY_AUTO_RESTART_UPDATE',
  DisplayBatteryPowerManagementUpdate = 'DISPLAY_BATTERY_POWER_MANAGEMENT_UPDATE',
  DisplayBookmarksUpdate = 'DISPLAY_BOOKMARKS_UPDATE',
  DisplayBrightnessUpdate = 'DISPLAY_BRIGHTNESS_UPDATE',
  DisplayBurnInRefreshUpdate = 'DISPLAY_BURN_IN_REFRESH_UPDATE',
  DisplayClaim = 'DISPLAY_CLAIM',
  DisplayContentSourceUpdate = 'DISPLAY_CONTENT_SOURCE_UPDATE',
  DisplayControlLockUpdate = 'DISPLAY_CONTROL_LOCK_UPDATE',
  DisplayDataClear = 'DISPLAY_DATA_CLEAR',
  DisplayDefaultContentSourceUpdate = 'DISPLAY_DEFAULT_CONTENT_SOURCE_UPDATE',
  DisplayFirmwareUpdate = 'DISPLAY_FIRMWARE_UPDATE',
  DisplayGroupAdd = 'DISPLAY_GROUP_ADD',
  DisplayGroupRemove = 'DISPLAY_GROUP_REMOVE',
  DisplayJobAbort = 'DISPLAY_JOB_ABORT',
  DisplayLedStripColorUpdate = 'DISPLAY_LED_STRIP_COLOR_UPDATE',
  DisplayLogsDelete = 'DISPLAY_LOGS_DELETE',
  DisplayLogsEnable = 'DISPLAY_LOGS_ENABLE',
  DisplayLogsStop = 'DISPLAY_LOGS_STOP',
  DisplayOrientationUpdate = 'DISPLAY_ORIENTATION_UPDATE',
  DisplayPlaylistUpdate = 'DISPLAY_PLAYLIST_UPDATE',
  DisplayPortsLockUpdate = 'DISPLAY_PORTS_LOCK_UPDATE',
  DisplayPowerScheduleUpdate = 'DISPLAY_POWER_SCHEDULE_UPDATE',
  DisplayPowerUpdate = 'DISPLAY_POWER_UPDATE',
  DisplayReboot = 'DISPLAY_REBOOT',
  DisplayRecommendedPowerSettingsApply = 'DISPLAY_RECOMMENDED_POWER_SETTINGS_APPLY',
  DisplayRecommendedSettingsApply = 'DISPLAY_RECOMMENDED_SETTINGS_APPLY',
  DisplayScheduleUpdate = 'DISPLAY_SCHEDULE_UPDATE',
  DisplayScreenshotCapture = 'DISPLAY_SCREENSHOT_CAPTURE',
  DisplaySignalDetectionUpdate = 'DISPLAY_SIGNAL_DETECTION_UPDATE',
  DisplaySiteUpdate = 'DISPLAY_SITE_UPDATE',
  DisplayTimeZoneUpdate = 'DISPLAY_TIME_ZONE_UPDATE',
  DisplayUnclaim = 'DISPLAY_UNCLAIM',
  DisplayVolumeLimitUpdate = 'DISPLAY_VOLUME_LIMIT_UPDATE',
  DisplayVolumeMuteUpdate = 'DISPLAY_VOLUME_MUTE_UPDATE',
  DisplayVolumeUpdate = 'DISPLAY_VOLUME_UPDATE',
  GroupCreate = 'GROUP_CREATE',
  MediaUpdate = 'MEDIA_UPDATE',
  MediaUpload = 'MEDIA_UPLOAD',
  OrganizationUpdate = 'ORGANIZATION_UPDATE',
  PlaylistCreate = 'PLAYLIST_CREATE',
  PlaylistDelete = 'PLAYLIST_DELETE',
  PlaylistDuplicate = 'PLAYLIST_DUPLICATE',
  PlaylistRemoveDisplays = 'PLAYLIST_REMOVE_DISPLAYS',
  PlaylistSyncDisplays = 'PLAYLIST_SYNC_DISPLAYS',
  PlaylistUpdate = 'PLAYLIST_UPDATE',
  PowerScheduleCreate = 'POWER_SCHEDULE_CREATE',
  PowerScheduleDelete = 'POWER_SCHEDULE_DELETE',
  PowerScheduleRemoveDisplays = 'POWER_SCHEDULE_REMOVE_DISPLAYS',
  PowerScheduleSyncDisplays = 'POWER_SCHEDULE_SYNC_DISPLAYS',
  PowerScheduleUpdate = 'POWER_SCHEDULE_UPDATE',
  ScheduleCreate = 'SCHEDULE_CREATE',
  ScheduleDelete = 'SCHEDULE_DELETE',
  ScheduleDuplicate = 'SCHEDULE_DUPLICATE',
  ScheduleRemoveDisplays = 'SCHEDULE_REMOVE_DISPLAYS',
  ScheduleSyncDisplays = 'SCHEDULE_SYNC_DISPLAYS',
  ScheduleUpdate = 'SCHEDULE_UPDATE',
  SiteCreate = 'SITE_CREATE',
  SiteDelete = 'SITE_DELETE',
  SiteUpdate = 'SITE_UPDATE',
  SsoDomainCreate = 'SSO_DOMAIN_CREATE',
  SsoDomainDelete = 'SSO_DOMAIN_DELETE',
  SsoProviderPublish = 'SSO_PROVIDER_PUBLISH',
  SsoProviderUpdate = 'SSO_PROVIDER_UPDATE',
  SsoRevalidate = 'SSO_REVALIDATE',
  SubscriptionUpdate = 'SUBSCRIPTION_UPDATE',
  UserCreate = 'USER_CREATE',
  UserRemove = 'USER_REMOVE',
  UserUpdate = 'USER_UPDATE',
  ZtePair = 'ZTE_PAIR',
  ZteUnpair = 'ZTE_UNPAIR'
}

/** One entry of the Admin-mode Activity Logs audit trail, one field per column of the table. Every participant is stored as an id; the reader resolves the names it displays. */
export type ActivityLogDocument = {
  __typename?: 'ActivityLogDocument';
  /** The access request this action was performed under. */
  accessRequestId: Scalars['String'];
  action: ActivityLogAction;
  /** The admin's current name, resolved from actorUserId. Null once that user is deleted. */
  actorName?: Maybe<Scalars['String']>;
  /** The admin's own organization, not the one they acted in. */
  actorOrganizationId: Scalars['String'];
  /** The id of the admin who performed the action. */
  actorUserId: Scalars['String'];
  /** The unique identifier of the entry. */
  id: Scalars['ID'];
  /** The ids of the entities acted upon: one for a single action, every entity for a bulk action. */
  objectIds: Array<Scalars['String']>;
  /** The current name of each entity in objectIds, in the same order: alias or serial number for a display, full name for a user, title or name otherwise. An entry is null once that entity is deleted, or for a kind with no name lookup. */
  objectNames: Array<Maybe<Scalars['String']>>;
  /** The kind of entity acted upon; every id in objectIds is of this kind. */
  objectType: ActivityLogObjectType;
  /** When the audited action was performed. */
  startTime: Scalars['DateTime'];
  /** The customer the acted-upon entity belongs to. Null for organization-level actions. */
  targetCustomerId?: Maybe<Scalars['String']>;
  /** The name of the customer, resolved from targetCustomerId. Null for organization-level actions and for a deleted customer. */
  targetCustomerName?: Maybe<Scalars['String']>;
  /** The organization the admin was elevated into. */
  targetOrganizationId: Scalars['String'];
  /** The name of the organization the admin was elevated into, resolved from targetOrganizationId. Null once that organization is deleted. */
  targetOrganizationName?: Maybe<Scalars['String']>;
};

/** The kind of entity an audited action was performed on. */
export enum ActivityLogObjectType {
  AccessRequest = 'ACCESS_REQUEST',
  ApiKey = 'API_KEY',
  ClaimCode = 'CLAIM_CODE',
  Configuration = 'CONFIGURATION',
  Customer = 'CUSTOMER',
  Display = 'DISPLAY',
  Group = 'GROUP',
  Media = 'MEDIA',
  Organization = 'ORGANIZATION',
  Playlist = 'PLAYLIST',
  PowerSchedule = 'POWER_SCHEDULE',
  Schedule = 'SCHEDULE',
  Site = 'SITE',
  Sso = 'SSO',
  Subscription = 'SUBSCRIPTION',
  User = 'USER',
  Zte = 'ZTE'
}

export type ActivityLogsPayload = {
  __typename?: 'ActivityLogsPayload';
  /** The page of audit trail entries, newest first. */
  activityLogs: Array<ActivityLogDocument>;
  /** The total number of entries matching the filter, across all pages. */
  totalCount: Scalars['Int'];
};

export type AgentReleaseChannel = {
  __typename?: 'AgentReleaseChannel';
  /** The newly desired release channel for the display. Cleared when successful, failed or timed out. */
  desired?: Maybe<ReleaseChannel>;
  /** The last reported agent release channel of the displays. */
  reported: ReleaseChannel;
};

export type AllBookmarksState = {
  __typename?: 'AllBookmarksState';
  /** The newly desired bookmarks state. Cleared when successful, failed or timed out. */
  desired?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The last configured bookmarks. Beware that changes made through remote will not be reflected. */
  reported?: Maybe<Array<Scalars['String']>>;
};

/** The Android component of display firmware. */
export type Android = {
  __typename?: 'Android';
  /** Updates available to the Android component of the firmware. */
  availableUpdates: Array<Scalars['String']>;
  /** The latest job for android firmware update, includes planned job */
  latestJob?: Maybe<AndroidUpdateJob>;
  version: Scalars['FirmwareVersion'];
};

export type AndroidUpdateAborted = AndroidUpdateJob & {
  __typename?: 'AndroidUpdateAborted';
  /** The date at which the job has been aborted. */
  abortedAt: Scalars['DateTime'];
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The date at which the job is planned. In case the job is invoked immediately, the value is equal to createdAt. */
  plannedAt: Scalars['DateTime'];
  /** The version of the Android component to which the job will update. */
  targetVersion: Scalars['FirmwareVersion'];
};

export type AndroidUpdateCompleted = AndroidUpdateJob & {
  __typename?: 'AndroidUpdateCompleted';
  /** The date at which the job is completed. */
  completedAt: Scalars['DateTime'];
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The date at which the job is planned. In case the job is invoked immediately, the value is equal to createdAt. */
  plannedAt: Scalars['DateTime'];
  /** The version of the Android component to which the job will update. */
  targetVersion: Scalars['FirmwareVersion'];
};

export type AndroidUpdateDownloading = AndroidUpdateJob & {
  __typename?: 'AndroidUpdateDownloading';
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The percentage downloaded of the next Android version. */
  downloadProgress: Scalars['Float'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The date at which the job is planned. In case the job is invoked immediately, the value is equal to createdAt. */
  plannedAt: Scalars['DateTime'];
  /** The version of the Android component to which the job will update. */
  targetVersion: Scalars['FirmwareVersion'];
};

export type AndroidUpdateInstalling = AndroidUpdateJob & {
  __typename?: 'AndroidUpdateInstalling';
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The date at which the job is planned. In case the job is invoked immediately, the value is equal to createdAt. */
  plannedAt: Scalars['DateTime'];
  /** The version of the Android component to which the job will update. */
  targetVersion: Scalars['FirmwareVersion'];
};

export type AndroidUpdateJob = {
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The date at which the job is planned. In case the job is invoked immediately, the value is equal to createdAt. */
  plannedAt: Scalars['DateTime'];
  /** The version of the Android component to which the job will update. */
  targetVersion: Scalars['FirmwareVersion'];
};

export type AndroidUpdatePlanned = AndroidUpdateJob & {
  __typename?: 'AndroidUpdatePlanned';
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The date at which the job is planned. In case the job is invoked immediately, the value is equal to createdAt. */
  plannedAt: Scalars['DateTime'];
  /** The version of the Android component to which the job will update. */
  targetVersion: Scalars['FirmwareVersion'];
};

export type AndroidUpdateRejected = AndroidUpdateJob & {
  __typename?: 'AndroidUpdateRejected';
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The date at which the job is planned. In case the job is invoked immediately, the value is equal to createdAt. */
  plannedAt: Scalars['DateTime'];
  /** The date at which the job is rejected. */
  rejectedAt: Scalars['DateTime'];
  /** The reason code for rejection. */
  rejectionCode: Scalars['String'];
  /** The version of the Android component to which the job will update. */
  targetVersion: Scalars['FirmwareVersion'];
};

export type ApiKey = {
  __typename?: 'ApiKey';
  /** The alias of the API key. */
  alias: Scalars['String'];
  /** The timestamp at which the API key was created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the API key. */
  id: Scalars['ID'];
};

export type ApiKeyCreateInput = {
  /** The alias which will be given to the API key. */
  alias: Scalars['String'];
};

export type ApiKeyCreatePayload = {
  __typename?: 'ApiKeyCreatePayload';
  /** The metadata of the API key that was created. */
  apiKey: ApiKey;
  /** The API key which can be used to authenticate yourself programmatically. You should store this, as you won't be able to access it again. */
  apiKeyValue: Scalars['String'];
};

export type ApiKeyRevokeInput = {
  /** The identifier of the API key. */
  apiKeyId: Scalars['String'];
};

export type ApiKeyRevokePayload = {
  __typename?: 'ApiKeyRevokePayload';
  /** The ID of API key that was revoked. */
  apiKeyId: Scalars['ID'];
};

export type AppContentSource = {
  __typename?: 'AppContentSource';
  /** The activities of the app. */
  activityList?: Maybe<Array<Scalars['String']>>;
  /** The id of the application. */
  applicationId: Scalars['String'];
  /** Whether or not the app can be set as a boot on source. */
  isBootable?: Maybe<Scalars['Boolean']>;
  /** The name of the app. */
  label?: Maybe<Scalars['String']>;
  /** Selected Activity of the app. */
  selectedActivity?: Maybe<Scalars['String']>;
};

export type AppInstallation = {
  /** The identifier of the application. */
  applicationId: Scalars['ID'];
  /** The identifier of installation. */
  id: Scalars['ID'];
};

export type AppInstallationFailed = AppInstallation & {
  __typename?: 'AppInstallationFailed';
  /** The identifier of the application. */
  applicationId: Scalars['ID'];
  /** A message describing why the installation failed. */
  errorMessage: Scalars['String'];
  /** The identifier of installation. */
  id: Scalars['ID'];
};

export type AppInstallationInstallPending = AppInstallation & {
  __typename?: 'AppInstallationInstallPending';
  /** The identifier of the application. */
  applicationId: Scalars['ID'];
  /** The identifier of installation. */
  id: Scalars['ID'];
  /** The date at which the installation is planned. */
  plannedAt: Scalars['DateTime'];
};

export type AppInstallationInstalled = AppInstallation & {
  __typename?: 'AppInstallationInstalled';
  /** The identifier of the application. */
  applicationId: Scalars['ID'];
  /** The identifier of installation. */
  id: Scalars['ID'];
  /** The version code of the application. */
  versionCode: Scalars['String'];
  /** The version of the application. */
  versionName: Scalars['String'];
};

export type AppInstallationInstalling = AppInstallation & {
  __typename?: 'AppInstallationInstalling';
  /** The identifier of the application. */
  applicationId: Scalars['ID'];
  /** A percentage amount that indicates the download progress. */
  downloadProgress: Scalars['Float'];
  /** The identifier of installation. */
  id: Scalars['ID'];
  /** A flag that indicates is the app is currently being installed. */
  isInstalling: Scalars['Boolean'];
  /** The version code of the application. */
  versionCode: Scalars['String'];
  /** The version of the application. */
  versionName: Scalars['String'];
};

export type AppInstallationUninstallPending = AppInstallation & {
  __typename?: 'AppInstallationUninstallPending';
  /** The identifier of the application. */
  applicationId: Scalars['ID'];
  /** The identifier of installation. */
  id: Scalars['ID'];
  /** The date at which the installation is planned. */
  plannedAt: Scalars['DateTime'];
  /** The version code of the application. */
  versionCode: Scalars['String'];
  /** The version of the application. */
  versionName: Scalars['String'];
};

export type AppInstallationUninstalling = AppInstallation & {
  __typename?: 'AppInstallationUninstalling';
  /** The identifier of the application. */
  applicationId: Scalars['ID'];
  /** The identifier of installation. */
  id: Scalars['ID'];
  /** The version code of the application. */
  versionCode: Scalars['String'];
  /** The version of the application. */
  versionName: Scalars['String'];
};

export type AppInstallationUpdating = AppInstallation & {
  __typename?: 'AppInstallationUpdating';
  /** The identifier of the application. */
  applicationId: Scalars['ID'];
  /** The current version code of the application. */
  currentVersionCode: Scalars['String'];
  /** The current version of the application. */
  currentVersionName: Scalars['String'];
  /** A percentage amount that indicates the download progress. */
  downloadProgress: Scalars['Float'];
  /** The identifier of installation. */
  id: Scalars['ID'];
  /** A flag that indicates is the app is currently being installed. */
  isInstalling: Scalars['Boolean'];
  /** The next version code of the application. */
  nextVersionCode: Scalars['String'];
  /** The next version of the application. */
  nextVersionName: Scalars['String'];
};

export type AppUninstallationFailed = AppInstallation & {
  __typename?: 'AppUninstallationFailed';
  /** The identifier of the application. */
  applicationId: Scalars['ID'];
  /** A message describing why the installation failed. */
  errorMessage: Scalars['String'];
  /** The identifier of installation. */
  id: Scalars['ID'];
};

export type AutoRestart = {
  __typename?: 'AutoRestart';
  /** Enable or disable auto udpate feature */
  switch: Scalars['String'];
  /** Time at which device will do auto Reboot */
  time?: Maybe<Scalars['String']>;
};

export type AutoRestartState = {
  __typename?: 'AutoRestartState';
  /** The newly desired auto restart state of the display. with ON/OFF */
  desired?: Maybe<AutoRestart>;
  /** The last reported auto restart state of the display. */
  reported: AutoRestart;
};

export type Battery = {
  __typename?: 'Battery';
  /** The battery charge level (0-100). */
  level: Scalars['Int'];
  /** The power management state: ON or OFF. */
  powerManagement: Scalars['String'];
  /** The current power source: AC or BATTERY. */
  powerSource: Scalars['String'];
  /** Whether the battery is present. */
  present: Scalars['Boolean'];
};

export type BatteryDesired = {
  __typename?: 'BatteryDesired';
  /** The desired power management state: ON or OFF. */
  powerManagement: Scalars['String'];
};

export enum BatteryPowerManagement {
  Off = 'OFF',
  On = 'ON'
}

export type BatteryState = {
  __typename?: 'BatteryState';
  /** The pending desired power management state. */
  desired?: Maybe<BatteryDesired>;
  /** The last reported battery state of the display. */
  reported: Battery;
  /** The date at which the battery state was last reported. */
  reportedAt?: Maybe<Scalars['DateTime']>;
};

export type BatteryThreshold = {
  __typename?: 'BatteryThreshold';
  /** Minimum critical battery threshold value */
  min: Scalars['Float'];
  /** Warning battery threshold value */
  minWarning: Scalars['Float'];
};

export type BookmarkContentSource = {
  __typename?: 'BookmarkContentSource';
  /** The index of the bookmark. */
  index: Scalars['Int'];
};

export type Bookmarks = {
  __typename?: 'Bookmarks';
  all: AllBookmarksState;
};

export type BrightnessState = {
  __typename?: 'BrightnessState';
  /** The newly desired brightness level of the display. Ranging from 0 to 100. Cleared when successful, failed or timed out. */
  desired?: Maybe<Scalars['Int']>;
  /** The last reported brightness level of the display. */
  reported: Scalars['Int'];
};

export type BrightnessV2State = {
  __typename?: 'BrightnessV2State';
  /** The desired auto-brightness state */
  desired?: Maybe<BrightnessV2Value>;
  /** The last reported auto-brightness state */
  reported: BrightnessV2Value;
};

export type BrightnessV2Value = {
  __typename?: 'BrightnessV2Value';
  /** Whether auto-brightness is enabled */
  autoBrightness?: Maybe<Scalars['Boolean']>;
  /** The brightnessV2 value */
  value: Scalars['Int'];
};

export type BurnInRefreshSettings = {
  __typename?: 'BurnInRefreshSettings';
  /** Daily refresh start time in HH:MM format (24h) */
  time: Scalars['String'];
};

export type BurnInRefreshSettingsState = {
  __typename?: 'BurnInRefreshSettingsState';
  /** The newly desired burn-in refresh state of the display. */
  desired?: Maybe<BurnInRefreshSettings>;
  /** The last reported burn-in refresh state of the display. */
  reported: BurnInRefreshSettings;
};

export type ChangePasswordStatus = {
  __typename?: 'ChangePasswordStatus';
  /** True if password reset email sent successfully. */
  status: Scalars['Boolean'];
};

export type ClaimableDisplay = {
  __typename?: 'ClaimableDisplay';
  /** The model of the display. */
  commercialTypeNumber: Scalars['String'];
  id: Scalars['ID'];
  /** The type of the platform. */
  platformType: Scalars['String'];
  /** The serial number of the display. */
  serialNumber: Scalars['String'];
};

export type CloneConfigurationPayload = {
  __typename?: 'CloneConfigurationPayload';
  /** Configuration created. */
  configuration: ConfigurationModel;
};

export type ConfigAllBookmarksState = {
  __typename?: 'ConfigAllBookmarksState';
  /** The last configured bookmarks. Beware that changes made through remote will not be reflected. */
  reported?: Maybe<Array<Scalars['String']>>;
};

/** The Android component of firmware that is set in configuration. */
export type ConfigAndroid = {
  __typename?: 'ConfigAndroid';
  version: Scalars['FirmwareVersion'];
};

export type ConfigAppContentSource = {
  __typename?: 'ConfigAppContentSource';
  /** The activities of the app. */
  activityList?: Maybe<Array<Scalars['String']>>;
  /** The id of the application. */
  applicationId: Scalars['String'];
  /** Whether or not the app can be set as a boot on source. */
  isBootable?: Maybe<Scalars['Boolean']>;
  /** The name of the app. */
  label?: Maybe<Scalars['String']>;
  /** Selected Activity of the app. */
  selectedActivity?: Maybe<Scalars['String']>;
};

export type ConfigAppsGrouped = {
  __typename?: 'ConfigAppsGrouped';
  assignedApps: Array<ConfigurationApps>;
  unassignedApps: Array<ConfigurationApps>;
};

export type ConfigAutoRestart = {
  __typename?: 'ConfigAutoRestart';
  /** Enable or disable auto udpate feature */
  switch: Scalars['String'];
  /** Time at which device will do auto Reboot */
  time?: Maybe<Scalars['String']>;
};

export type ConfigAutoRestartState = {
  __typename?: 'ConfigAutoRestartState';
  /** The auto restart state of the configuration. */
  reported: ConfigAutoRestart;
};

export type ConfigBattery = {
  __typename?: 'ConfigBattery';
  /** The power management state: ON or OFF. */
  powerManagement: Scalars['String'];
};

export type ConfigBatteryState = {
  __typename?: 'ConfigBatteryState';
  /** The battery state of the configuration. */
  reported: ConfigBattery;
};

export type ConfigBookmarkContentSource = {
  __typename?: 'ConfigBookmarkContentSource';
  /** The index of the bookmark. */
  index: Scalars['Int'];
};

export type ConfigBookmarks = {
  __typename?: 'ConfigBookmarks';
  all: ConfigAllBookmarksState;
};

export type ConfigBrightnessState = {
  __typename?: 'ConfigBrightnessState';
  /** The brightness level set in configuration. */
  reported: Scalars['Int'];
};

export type ConfigBrightnessV2State = {
  __typename?: 'ConfigBrightnessV2State';
  /** Whether auto-brightness is enabled */
  autoBrightness?: Maybe<Scalars['Boolean']>;
  /** The brightness value */
  value: Scalars['Int'];
};

export type ConfigBurnInRefresh = {
  __typename?: 'ConfigBurnInRefresh';
  /** Daily refresh start time in HH:MM format (24h) */
  time: Scalars['String'];
};

export type ConfigBurnInRefreshState = {
  __typename?: 'ConfigBurnInRefreshState';
  /** The burn-in refresh state of the configuration. */
  reported: ConfigBurnInRefresh;
};

export type ConfigContentSource = ConfigAppContentSource | ConfigBookmarkContentSource | ConfigInputContentSource | ConfigPlaylistContentSource;

export type ConfigContentSourceAppInputs = {
  activityList?: InputMaybe<Array<Scalars['String']>>;
  applicationId: Scalars['String'];
  isBootable?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  selectedActivity?: InputMaybe<Scalars['String']>;
};

export type ConfigContentSourceSettings = {
  __typename?: 'ConfigContentSourceSettings';
  /** A list with available content sources. */
  available?: Maybe<Array<ConfigContentSource>>;
  /** The current input source. */
  current?: Maybe<ConfigContentSourceState>;
  /** The default input source set in configuration. */
  default?: Maybe<ConfigContentSourceState>;
};

export type ConfigContentSourceState = {
  __typename?: 'ConfigContentSourceState';
  /** The input source set in configuration. */
  reported: ConfigContentSource;
};

export enum ConfigControlLockState {
  Locked = 'LOCKED',
  PowerOnly = 'POWER_ONLY',
  Unlocked = 'UNLOCKED',
  VolumeOnly = 'VOLUME_ONLY'
}

export type ConfigControlState = {
  __typename?: 'ConfigControlState';
  /** The state of the control set in configuration. */
  reported: ConfigControlLockState;
  /** The supported values for the control state of the display. */
  supportedValues: Array<ConfigControlLockState>;
};

export type ConfigCurrentPlaylist = {
  __typename?: 'ConfigCurrentPlaylist';
  /** The description of the current playlist */
  description?: Maybe<Scalars['String']>;
  /** The identifier of the current playlist. */
  id: Scalars['ID'];
  /** A flag that indicates if the current playlist is out of sync with the actual playlist configuration. */
  isOutOfSync: Scalars['Boolean'];
  /** A flag that indicates if the current playlist has been modified on the configuration. */
  isTampered: Scalars['Boolean'];
  /** The total size of the current playlist. */
  size: Scalars['BigInt'];
  /** The title of the current playlist. */
  title: Scalars['String'];
};

export type ConfigDeviceSdk = {
  __typename?: 'ConfigDeviceSdk';
  /** The device sdk type. */
  sdk: Scalars['String'];
  /** The device sdk version. */
  version: Scalars['String'];
};

export type ConfigFirmware = {
  __typename?: 'ConfigFirmware';
  /** The Android component of the firmware. */
  android: ConfigAndroid;
  /** The Scaler component of the firmware. */
  scaler?: Maybe<ConfigScaler>;
};

export type ConfigInputContentSource = {
  __typename?: 'ConfigInputContentSource';
  /** The display input source. */
  source: Scalars['String'];
};

export enum ConfigLedStripColor {
  Blue = 'BLUE',
  Cyan = 'CYAN',
  Green = 'GREEN',
  Magenta = 'MAGENTA',
  Red = 'RED',
  Unspecified = 'UNSPECIFIED',
  White = 'WHITE',
  Yellow = 'YELLOW'
}

export type ConfigLedStripColorState = {
  __typename?: 'ConfigLedStripColorState';
  /** The color of the LED strip set in configuration. */
  reported: ConfigLedStripColor;
};

export enum ConfigOrientation {
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT',
  PortraitAnticlock = 'PORTRAIT_ANTICLOCK'
}

export type ConfigOrientationState = {
  __typename?: 'ConfigOrientationState';
  /** The orientation set in configuration. */
  reported: ConfigOrientation;
  /** The supported values for the orientation state of the display. */
  supportedValues: Array<ConfigOrientation>;
};

export type ConfigPlaylist = {
  __typename?: 'ConfigPlaylist';
  /** The current playlist set in configuration. */
  current?: Maybe<ConfigCurrentPlaylist>;
};

export type ConfigPlaylistContentSource = {
  __typename?: 'ConfigPlaylistContentSource';
  /** The id of the playlist. */
  playlistId: Scalars['ID'];
};

export enum ConfigPortsControlLockState {
  Locked = 'LOCKED',
  Unlocked = 'UNLOCKED'
}

export type ConfigPortsControlState = {
  __typename?: 'ConfigPortsControlState';
  /** The state of the ports control set in configuration. */
  reported: ConfigPortsControlLockState;
  /** The supported values for the control state of the display. */
  supportedValues: Array<ConfigPortsControlLockState>;
};

export enum ConfigPower {
  On = 'ON',
  Standby = 'STANDBY'
}

export type ConfigPowerSchedule = {
  __typename?: 'ConfigPowerSchedule';
  /** The power schedule set in configuration. */
  schedule?: Maybe<PowerSchedule>;
};

export type ConfigPowerSettings = {
  __typename?: 'ConfigPowerSettings';
  /** Indicates whether the power settings are recommended by WAVE. */
  recommended: Scalars['Boolean'];
  /** Indicates whether the signal detection is supported and its state. */
  signalDetection?: Maybe<Scalars['Boolean']>;
  /** A list of warnings in case the settings are not recommended. */
  warnings: Array<ConfigSettingWarning>;
};

export type ConfigPowerSettingsState = {
  __typename?: 'ConfigPowerSettingsState';
  /** The power settings set in configuration. */
  reported: ConfigPowerSettings;
};

export type ConfigPowerState = {
  __typename?: 'ConfigPowerState';
  /** The power set in configuration. */
  reported: ConfigPower;
  /** The date at which the power was last reported. */
  reportedAt: Scalars['DateTime'];
};

export type ConfigRecommendedSettings = {
  __typename?: 'ConfigRecommendedSettings';
  /** Indicates whether the settings are recommended by WAVE. */
  recommended: Scalars['Boolean'];
  /** A list of warnings in case the settings are not recommended. */
  warnings: Array<ConfigSettingWarning>;
};

export type ConfigRecommendedSettingsState = {
  __typename?: 'ConfigRecommendedSettingsState';
  /** The recommended settings set in configuration. */
  reported: ConfigRecommendedSettings;
};

export type ConfigScaler = {
  __typename?: 'ConfigScaler';
  /** The version of the Scaler component of the firmware. */
  version: Scalars['FirmwareVersion'];
};

export type ConfigSchedule = {
  __typename?: 'ConfigSchedule';
  /** The schedule set in configuration. */
  schedule?: Maybe<Schedule>;
};

export type ConfigSettingWarning = {
  __typename?: 'ConfigSettingWarning';
  /** A unique code identifying the warning. */
  code: Scalars['String'];
  /** The full description of the warning. */
  description: Scalars['String'];
  /** The severity of the warning. */
  severity: ConfigSettingWarningSeverity;
};

export enum ConfigSettingWarningSeverity {
  High = 'HIGH',
  Low = 'LOW',
  Moderate = 'MODERATE'
}

export type ConfigSignalDetectionState = {
  __typename?: 'ConfigSignalDetectionState';
  /** The last reported signal detection state of the display. */
  reported: Scalars['Boolean'];
};

export type ConfigStatistics = {
  __typename?: 'ConfigStatistics';
  assignedDisplays: Scalars['Int'];
  inSyncDisplays: Scalars['Int'];
  outOfSyncDisplays: Scalars['Int'];
  syncingDisplays: Scalars['Int'];
};

export type ConfigTimeZoneState = {
  __typename?: 'ConfigTimeZoneState';
  /** The last configured time zone. */
  reported: Scalars['String'];
  /** The supported values for the time zones set in configuration. */
  supportedValues: Array<Scalars['String']>;
};

export type ConfigVolume = {
  __typename?: 'ConfigVolume';
  /** Indicates whether the configuration has volume setting muted or not. */
  isMuted?: Maybe<ConfigVolumeMuteState>;
  /** The volume level set in configuration */
  level?: Maybe<ConfigVolumeLevelState>;
  /** The volume limits set in configuration */
  limits?: Maybe<ConfigVolumeLimitState>;
};

export type ConfigVolumeLevelState = {
  __typename?: 'ConfigVolumeLevelState';
  /** The volume level set in configuration */
  reported: Scalars['Int'];
};

export type ConfigVolumeLimit = {
  __typename?: 'ConfigVolumeLimit';
  /** The volume limit set in configuration */
  reported: Scalars['Int'];
};

export type ConfigVolumeLimitState = {
  __typename?: 'ConfigVolumeLimitState';
  /** The maximum volume limit set in configuration, `null` if the configuration doesn't support a maximum limit. */
  max?: Maybe<VolumeLimit>;
  /** The minimum volume limit set in configuration, `null` if the configuration doesn't support a minimum limit. */
  min?: Maybe<VolumeLimit>;
};

export type ConfigVolumeMuteState = {
  __typename?: 'ConfigVolumeMuteState';
  /** The mute state set in configuration. */
  reported: Scalars['Boolean'];
};

export type ConfigurationAddGroupInput = {
  /** The identifier of the configuration. */
  configurationId: Scalars['ID'];
  /** The group which will be added to the configuration. */
  groupId: Scalars['ID'];
};

export type ConfigurationApps = {
  __typename?: 'ConfigurationApps';
  /** The installable app versions for this app. */
  appVersions?: Maybe<Array<Scalars['String']>>;
  /** The url of the app icon of this app */
  iconUrl?: Maybe<Scalars['String']>;
  /** The identifier of this app */
  id: Scalars['ID'];
  /** The app assigned for this configuration. */
  isBootableValue: Scalars['Boolean'];
  /** The name of this app. */
  name: Scalars['String'];
};

export type ConfigurationDeleteGroupInput = {
  /** The identifier of the configuration. */
  configurationId: Scalars['ID'];
  /** The group which will be removed from the configuration. */
  groupId: Scalars['ID'];
};

export type ConfigurationFilters = {
  /** status of the configuration. */
  status?: InputMaybe<Array<ConfigurationStatus>>;
};

export type ConfigurationModel = {
  __typename?: 'ConfigurationModel';
  /** The autoRestart state of the configuration, enable or disable state. */
  autoRestart?: Maybe<ConfigAutoRestartState>;
  /** The battery power management state of the configuration. */
  battery?: Maybe<ConfigBatteryState>;
  /** The bookmarks set in configuration. */
  bookmarks: ConfigBookmarks;
  /** The brightness state set in configuration. Ranging from 0 to 100. */
  brightness?: Maybe<ConfigBrightnessState>;
  /** The autobrightness state in configuration */
  brightnessV2?: Maybe<ConfigBrightnessV2State>;
  /** The burn-in refresh schedule for Tableau platform configurations. */
  burnInRefresh?: Maybe<ConfigBurnInRefreshState>;
  /** The commercial type number assigned to configuration. */
  commercialTypeNumber?: Maybe<Scalars['String']>;
  /** Apps that are available to the configuration. */
  configApps?: Maybe<ConfigAppsGrouped>;
  /** Statistics about displays assigned to this configuration. */
  configStatistics: ConfigStatistics;
  /** The content source set in configuration */
  contentSource?: Maybe<ConfigContentSourceSettings>;
  /** The timestamp at which the configuration was created. */
  createdAt: Scalars['DateTime'];
  /** The ID of the customer associated with this document. */
  customerId: Scalars['String'];
  /** Description of the configuration. */
  description?: Maybe<Scalars['String']>;
  /** sdk version and type of display */
  deviceSdk?: Maybe<ConfigDeviceSdk>;
  /** The draft of the configuration. */
  draft?: Maybe<ConfigurationModel>;
  /** The firmware version set in configuration. */
  firmware?: Maybe<ConfigFirmware>;
  /** Group ids that the display belong to. */
  groupIds?: Maybe<Array<Scalars['String']>>;
  /** The groups set in configuration. */
  groups: Array<Group>;
  /** The unique identifier for the configuration. */
  id: Scalars['ID'];
  /** The infra-red control state set in configuration. */
  infraRedControl?: Maybe<ConfigControlState>;
  /** The keyboard control state set in configuration. */
  keyboardControl?: Maybe<ConfigControlState>;
  /** The color of the LED strip set in configuration. */
  ledStripColor?: Maybe<ConfigLedStripColorState>;
  /** The name of the configuration. */
  name: Scalars['String'];
  /** The orientation set in configuration. */
  orientation?: Maybe<ConfigOrientationState>;
  /** platform for the configuration. */
  platform: Scalars['String'];
  /** The playlist associated with the configuration. */
  playlist?: Maybe<ConfigPlaylist>;
  /** The playlist type supported by the configuration. */
  playlistType?: Maybe<PlaylistType>;
  /** The ports control state set in configuration. */
  portsControl?: Maybe<ConfigPortsControlState>;
  /** The power set in configuration. */
  power?: Maybe<ConfigPowerState>;
  /** The power schedule set in configuration. */
  powerSchedule?: Maybe<ConfigPowerSchedule>;
  /**
   * The power settings set in configuration.
   * @deprecated Use recommendedSettings instead.
   */
  powerSettings?: Maybe<ConfigPowerSettingsState>;
  /** The associated profile information. */
  profile: Profile;
  /** The ID of the user who published the configuration. */
  publisherUserName?: Maybe<Scalars['String']>;
  /** The recommended settings set in configuration. */
  recommendedSettings?: Maybe<ConfigRecommendedSettingsState>;
  /** The schedule set in configuration. */
  schedule?: Maybe<ConfigSchedule>;
  /** Indicates if displays with this configuration should update to the latest firmware. */
  shouldUpdateToLatestFirmware?: Maybe<Scalars['Boolean']>;
  /** The signal detection state of the display. */
  signalDetection?: Maybe<ConfigSignalDetectionState>;
  /** The site associated to the configuration. */
  site?: Maybe<Site>;
  /** Site id for the configuration. */
  siteId?: Maybe<Scalars['String']>;
  /** Current state of the configuration. */
  state: ConfigurationStatus;
  /** The supported firmwares for configuration platform. */
  supportedFirmwares: Array<Scalars['String']>;
  /** Indicates if this platform supports setting an app as the default boot source. */
  supportsBootableContentSourceApps?: Maybe<Scalars['Boolean']>;
  /** The time zone set in configuration. */
  timeZone?: Maybe<ConfigTimeZoneState>;
  /** Timezone for the display. */
  timezone: Scalars['String'];
  /** The timestamp at which the configuration was published. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Configuration version. */
  version: Scalars['Float'];
  /** The volume state set in configuration */
  volume?: Maybe<ConfigVolume>;
};

export type ConfigurationNameExistsInput = {
  /** Check if the configuration name already exists */
  configurationName: Scalars['String'];
  /** The customer to which the configuration is added to */
  customerId: Scalars['ID'];
};

export type ConfigurationRenameInput = {
  /** The identifier of the configuration. */
  configurationId: Scalars['ID'];
  /** The name for the configuration. */
  name: Scalars['String'];
};

export enum ConfigurationStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Readytopublish = 'READYTOPUBLISH',
  Template = 'TEMPLATE',
  Unpublished = 'UNPUBLISHED'
}

export enum ConfigurationSyncStatus {
  Failed = 'FAILED',
  OutOfSync = 'OUT_OF_SYNC',
  Synced = 'SYNCED',
  Syncing = 'SYNCING'
}

export type ConfigurationUpdateAndroidFirmwareInput = {
  /** The id of configuration to update. */
  configurationId: Scalars['String'];
  /** The version to which the Android component of the firmware will be updated. */
  targetVersion: Scalars['FirmwareVersion'];
};

export type ConfigurationUpdateAutoRestartInput = {
  /** The identifier of the configuration. */
  configurationId: Scalars['ID'];
  /** To enable auto restart feature in configuration. */
  switch: SwitchType;
  /** The time at which configuration auto reboot. */
  time?: InputMaybe<Scalars['String']>;
};

export type ConfigurationUpdateBatteryPowerManagementInput = {
  /** The identifier of the configuration. */
  configurationId: Scalars['ID'];
  /** The power management state to set: ON or OFF. */
  powerManagement: BatteryPowerManagement;
};

export type ConfigurationUpdateBookmarksAllInput = {
  /** The bookmarks that will be given to the configuration. */
  bookmarks: Array<Scalars['String']>;
  /** The identifier of the configuration. */
  configurationId: Scalars['ID'];
};

export type ConfigurationUpdateBrightnessInput = {
  /** The brightness value that will be applied to the configurations */
  brightness: Scalars['Int'];
  /** The configuration id to update. */
  configurationId: Scalars['String'];
};

export type ConfigurationUpdateBrightnessV2Input = {
  /** Whether auto-brightness should be enabled */
  autoBrightness?: InputMaybe<Scalars['Boolean']>;
  /** The configuration id to update. */
  configurationId: Scalars['String'];
  /** The brightness value  */
  value: Scalars['Int'];
};

export type ConfigurationUpdateBurnInRefreshInput = {
  /** The identifier of the configuration. */
  configurationId: Scalars['ID'];
  /** Daily refresh start time in HH:MM format (24h). Tableau platform only. */
  time: Scalars['String'];
};

export type ConfigurationUpdateContentSourceAppsInput = {
  /** The contentSourceApps that will be given to the configuration. */
  configContentSourceApps: Array<ConfigContentSourceAppInputs>;
  /** The identifier of the configuration. */
  configurationId: Scalars['ID'];
};

export type ConfigurationUpdateDefaultAppContentSourceInput = {
  /** The id of the application. */
  applicationId: Scalars['String'];
  /** The configuration to update */
  configurationId: Scalars['String'];
  /** The label of the application. */
  label?: InputMaybe<Scalars['String']>;
};

export type ConfigurationUpdateDefaultBookmarkContentSourceInput = {
  /** The configuration to update */
  configurationId: Scalars['String'];
  /** The index of the bookmark. */
  index: Scalars['Int'];
};

export type ConfigurationUpdateDefaultInputContentSourceInput = {
  /** The configuration to update */
  configurationId: Scalars['String'];
  /** The input source. */
  source: Scalars['String'];
};

export type ConfigurationUpdateDefaultPlaylistContentSourceInput = {
  /** The configuration to update */
  configurationId: Scalars['String'];
  /** The id of the playlist. */
  playlistId: Scalars['String'];
};

export type ConfigurationUpdateInfraRedControlInput = {
  /** The configuration to update. */
  configurationId: Scalars['String'];
  /** The state of the infra-red controls. */
  controlState: ConfigControlLockState;
};

export type ConfigurationUpdateKeyboardControlInput = {
  /** The configuration to update. */
  configurationId: Scalars['String'];
  /** The state of the keyboard controls. */
  controlState: ConfigControlLockState;
};

export type ConfigurationUpdateLedStripColorInput = {
  /** The configuration id to update */
  configurationId: Scalars['String'];
  /** The ledStripColor state that will be given to the configuration. */
  ledStripColor: ConfigLedStripColor;
};

export type ConfigurationUpdateOrientationInput = {
  /** The identifier of the configuration. */
  id: Scalars['ID'];
  /** The orientation state that will be given to the configuration. */
  orientation: ConfigOrientation;
};

export type ConfigurationUpdatePlaylistContentSourceInput = {
  /** The configuration to update */
  configurationId: Scalars['ID'];
  /** The id of the playlist. */
  playlistId?: InputMaybe<Scalars['String']>;
};

export type ConfigurationUpdatePortsControlInput = {
  /** The configuration to update. */
  configurationId: Scalars['String'];
  /** The state of the ports. */
  portsControlState: ConfigPortsControlLockState;
};

export type ConfigurationUpdatePowerInput = {
  /** The identifier of the configuration. */
  configurationId: Scalars['ID'];
  /** The power state that will be given to the configuration. */
  power: ConfigPower;
};

export type ConfigurationUpdatePowerScheduleInput = {
  /** The configuration to update */
  configurationId: Scalars['ID'];
  /** The id of the power schedule. */
  powerScheduleId?: InputMaybe<Scalars['String']>;
};

export type ConfigurationUpdateScheduleInput = {
  /** The configuration to update */
  configurationId: Scalars['ID'];
  /** The id of the schedule. Leave empty to remove it from the configuration. */
  scheduleId?: InputMaybe<Scalars['String']>;
};

export type ConfigurationUpdateSignalDetectionInput = {
  /** The identifier of the configuration. */
  configurationId: Scalars['ID'];
  /** Whether the signal detection should be enabled or not. */
  enable: Scalars['Boolean'];
};

export type ConfigurationUpdateSiteInput = {
  /** The identifier of the configuration. */
  configuraionId: Scalars['ID'];
  /** The site that will be associated with the configuration. */
  siteId?: InputMaybe<Scalars['ID']>;
};

export type ConfigurationUpdateTimeZoneInput = {
  /** The identifier of the configuration. */
  configurationId: Scalars['String'];
  /** The canonical time zone that will be configured on the configuration. */
  timeZone: Scalars['String'];
};

export type ConfigurationUpdateVolumeLevelInput = {
  /** The identifier of the configuration. */
  configurationId: Scalars['ID'];
  /** The volume level that will be given to the configuration. */
  level: Scalars['Int'];
};

export type ConfigurationUpdateVolumeLimitMaxInput = {
  /** The identifier of the configuration. */
  configurationId: Scalars['ID'];
  /** The new volume maximum limit */
  max: Scalars['Int'];
};

export type ConfigurationUpdateVolumeLimitMinInput = {
  /** The identifier of the configuration. */
  configurationId: Scalars['ID'];
  /** The new volume minimum limit */
  min: Scalars['Int'];
};

export type ConfigurationUpdateVolumeMuteInput = {
  /** The identifier of the configuration. */
  configurationId: Scalars['ID'];
  /** The mute state that will be assign to the configuration. */
  mute: Scalars['Boolean'];
};

export type ContentSource = AppContentSource | BookmarkContentSource | InputContentSource | PlaylistContentSource;

export type ContentSourceInputV2 = {
  __typename?: 'ContentSourceInputV2';
  /** The input name. */
  input: Scalars['String'];
  /** The target device (GUEST/HOST/BOTH). */
  target: Scalars['String'];
};

export type ContentSourceSettings = {
  __typename?: 'ContentSourceSettings';
  /** A list with available content sources. */
  available?: Maybe<Array<ContentSource>>;
  /** The current input source. */
  current?: Maybe<ContentSourceState>;
  /** The default input source of the display. */
  default?: Maybe<ContentSourceState>;
};

export type ContentSourceState = {
  __typename?: 'ContentSourceState';
  /** The newly desired input source of the display. Cleared when successful, failed or timed out. */
  desired?: Maybe<ContentSource>;
  /** The last reported input source of the display. */
  reported: ContentSource;
};

export type ContentSourceStatistics = {
  __typename?: 'ContentSourceStatistics';
  disconnected: Scalars['Int'];
  sources: Array<SourceRecord>;
  standby: Scalars['Int'];
};

export enum ControlLockState {
  Locked = 'LOCKED',
  PowerOnly = 'POWER_ONLY',
  Unlocked = 'UNLOCKED',
  VolumeOnly = 'VOLUME_ONLY'
}

export type ControlState = {
  __typename?: 'ControlState';
  /** The newly desired state of the control for the display. Cleared when successful, failed or timed out. */
  desired?: Maybe<ControlLockState>;
  /** The last reported state of the control for the display. */
  reported: ControlLockState;
  /** The supported values for the control state of the display. */
  supportedValues: Array<ControlLockState>;
};

export type CreateConfigurationInput = {
  /** Description of the configuration. */
  description?: InputMaybe<Scalars['String']>;
  /** The display for profile update. */
  displayId: Scalars['ID'];
  /** Name of the configuration. */
  name: Scalars['String'];
};

export type CurrentUser = {
  __typename?: 'CurrentUser';
  /** A list of the current user's personal api keys */
  apiKeys: Array<ApiKey>;
  /** The email address of the current user. */
  email: Scalars['String'];
  /** The identifier of the current user. */
  id: Scalars['ID'];
  /** The preferred authentication connection of the current user. */
  preferredConnection: Scalars['String'];
};

export type Customer = {
  __typename?: 'Customer';
  /** List of configurations assigned to at least one display. */
  assignedConfigurations: Array<ConfigurationModel>;
  /** The avatar's URL of the customer. */
  avatarUrl?: Maybe<Scalars['String']>;
  /**
   * The configurations associated with the customer.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, Guest, Installer, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configuration?: Maybe<ConfigurationModel>;
  /** The configurations associated with the customer. */
  configurations: Array<ConfigurationModel>;
  /** Default configurations for the customer. */
  customerDefaultConfigurations?: Maybe<DefaultConfiguration>;
  /** Find a display associated to the customer. */
  display: Display;
  /** Display alerts associated with this customer. */
  displayAlerts: Array<DisplayAlert>;
  /** Amount of displays the customer has claimed. */
  displayCount: Scalars['Int'];
  /** Current unique firmware versions for displays associated with this customer. */
  displayFirmwareVersions: Array<Scalars['String']>;
  /** Usage statistics for all displays associated with this customer. */
  displayUsage?: Maybe<UsageStatistics>;
  /** Displays associated with the customer. */
  displays: Array<Display>;
  /** Groups associated with this customer. */
  groups: Array<Group>;
  /** A human- and URL-friendly identifier of the customer. */
  handle: Scalars['String'];
  /** The identifier of the customer. */
  id: Scalars['ID'];
  /** Available input sources for the customer. */
  inputSources: Array<Scalars['String']>;
  /** The multicodes associated with the customer. */
  multiClaimCodes: Array<MultiClaimCodeDocument>;
  /** Default configurations for the multiclaim. */
  multiClaimDefaultConfigurations?: Maybe<Array<DefaultConfiguration>>;
  /** The name of the customer. */
  name: Scalars['String'];
  /** Notification of the customer is linked to. */
  notification?: Maybe<NotificationSettingsModel>;
  /** The playlists associated with the customer. */
  playlists: Array<Playlist>;
  /** The power schedules associated with the customer. */
  powerSchedules: Array<PowerSchedule>;
  /** The schedules associated with the customer. */
  schedules: Array<Schedule>;
  /** Sites associated with this customer. */
  sites: Array<Site>;
  /** Supported platforms for the customer. */
  supportedPlatforms: Array<Scalars['String']>;
  /** The template configurations. */
  templateConfigurations: Array<ConfigurationModel>;
  /** Total number of displays associated with the customer. If filter.configurationIds is provided, only counts those displays. */
  totalDisplaysCount: Scalars['Int'];
  /** Total number of displays associated to customer after filters are applied. */
  totalFilteredDisplaysCount: Scalars['Int'];
  /** Total number of multiClaimCodes associated to customer after filters are applied. */
  totalFilteredMultiClaimCount: Scalars['Int'];
  /** All users associated with this customer. */
  users: Array<User>;
  /** Warnings associated with this customer. */
  warningList: Array<Warning>;
  /**
   * Wave Subscription the customer is linked to.
   * @deprecated Use waveSubscriptions instead.
   */
  waveSubscription?: Maybe<WaveSubscription>;
  /** Wave Subscription Usage by Customer. */
  waveSubscriptionUsage?: Maybe<Scalars['Int']>;
  /** Wave Subscriptions the customer is linked to. */
  waveSubscriptions?: Maybe<Array<WaveSubscription>>;
};


export type CustomerConfigurationArgs = {
  id: Scalars['ID'];
};


export type CustomerConfigurationsArgs = {
  filter?: InputMaybe<ConfigurationFilters>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type CustomerDisplayArgs = {
  id: Scalars['ID'];
};


export type CustomerDisplaysArgs = {
  filter?: InputMaybe<DisplayFilters>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type CustomerMultiClaimCodesArgs = {
  filter?: InputMaybe<MultiClaimFilters>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type CustomerPlaylistsArgs = {
  displayId?: InputMaybe<Scalars['ID']>;
};


export type CustomerTotalDisplaysCountArgs = {
  filter?: InputMaybe<DisplayFilters>;
};


export type CustomerTotalFilteredDisplaysCountArgs = {
  filter?: InputMaybe<DisplayFilters>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type CustomerTotalFilteredMultiClaimCountArgs = {
  filter?: InputMaybe<MultiClaimFilters>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type CustomerCreateInput = {
  /** The avatar URL of the customer. */
  avatarUrl?: InputMaybe<Scalars['String']>;
  /** A human- and URL-friendly identifier of the customer. */
  handle: Scalars['String'];
  /** The name of the customer. */
  name: Scalars['String'];
  /** The subscription to link the customer to. */
  subscriptionId?: InputMaybe<Scalars['String']>;
  /** A list of user ids that are associated with this customer. */
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CustomerCreateInputV2 = {
  /** The avatar URL of the customer. */
  avatarUrl?: InputMaybe<Scalars['String']>;
  /** A human- and URL-friendly identifier of the customer. */
  handle: Scalars['String'];
  /** The name of the customer. */
  name: Scalars['String'];
  /** The subscriptions to link the customer to. */
  subscriptionIds: Array<Scalars['String']>;
  /** A list of user ids that are associated with this customer. */
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CustomerDeleteInput = {
  /** The identifier of the customer. */
  customerId: Scalars['ID'];
};

export type CustomerDeletePayload = {
  __typename?: 'CustomerDeletePayload';
  /** The identifier of the customer that was deleted. */
  customerId: Scalars['ID'];
};

export type CustomerDeletePreCheckResult = {
  __typename?: 'CustomerDeletePreCheckResult';
  /** Codes for conditions that block deletion: HAS_CLAIMED_DISPLAYS, HAS_ZTE_ENROLMENTS. */
  blockingReasons: Array<Scalars['String']>;
  /** Items that will be automatically deleted: PLAYLISTS, POWER_SCHEDULES, MULTICLAIM_CODES, SITES, CONFIGURATIONS, NOTIFICATION_SETTINGS. */
  deletableItems: Array<Scalars['String']>;
};

export type CustomerUpdateInput = {
  /** The avatar URL of the customer. */
  avatarUrl?: InputMaybe<Scalars['String']>;
  /** The identifier of the customer. */
  customerId: Scalars['ID'];
  /** A human- and URL-friendly identifier of the customer. */
  handle: Scalars['String'];
  /** The new name of the customer. */
  name: Scalars['String'];
  /** The subscription to link the customer to. */
  subscriptionId?: InputMaybe<Scalars['String']>;
  /** A list of userIds that are associated with this customer. With a Lite Wave subscription, all users will automatically be added to the customer. */
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CustomerUpdateInputNew = {
  /** The avatar URL of the customer. */
  avatarUrl?: InputMaybe<Scalars['String']>;
  /** The identifier of the customer. */
  customerId: Scalars['ID'];
  /** A human- and URL-friendly identifier of the customer. */
  handle: Scalars['String'];
  /** The new name of the customer. */
  name: Scalars['String'];
  /** The subscriptions to link the customer to. */
  subscriptionIds: Array<Scalars['String']>;
  /** A list of userIds that are associated with this customer. With a Lite Wave subscription, all users will automatically be added to the customer. */
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export enum Day {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DefaultConfiguration = {
  __typename?: 'DefaultConfiguration';
  /** The timestamp at which the default configuration was created. */
  createdAt: Scalars['DateTime'];
  /** The ID of the customer associated with this document. */
  customerId: Scalars['String'];
  /** A list of platform and configuration ID pairs associated with this default configuration. */
  defaultConfigurations: Array<DefaultConfigurationMap>;
  /** The unique identifier for the default configuration. */
  id: Scalars['ID'];
  /** The ID of the multi-claim associated with this document. */
  multiClaimId?: Maybe<Scalars['String']>;
  /** Type of the default configuration. */
  type: DefaultConfigurationType;
  /** The timestamp at which the default configuration was updated. */
  updatedAt: Scalars['DateTime'];
};

export type DefaultConfigurationMap = {
  __typename?: 'DefaultConfigurationMap';
  /** The ID of the configuration. */
  configurationId: Scalars['String'];
  /** The platform associated with this document. */
  platform: Scalars['String'];
};

export type DefaultConfigurationMapInput = {
  /** The ID of the configuration. */
  configurationId: Scalars['String'];
  /** The platform associated with this document. */
  platform: Scalars['String'];
};

export enum DefaultConfigurationState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum DefaultConfigurationType {
  Customer = 'CUSTOMER',
  Multiclaim = 'MULTICLAIM'
}

export type DeleteConfigurationsInput = {
  /** ID of the configuration */
  id: Scalars['String'];
};

export type DeleteMultiClaimCodeInput = {
  /** ID of the claim code */
  id: Scalars['String'];
};

export type DeviceSdk = {
  __typename?: 'DeviceSdk';
  /** The device sdk type. */
  sdk: Scalars['String'];
  /** The device sdk version. */
  version: Scalars['String'];
};

export type Display = {
  __typename?: 'Display';
  /** The agent release channel of the display. */
  agentReleaseChannel?: Maybe<AgentReleaseChannel>;
  /** The agent's version running on the display */
  agentVersion?: Maybe<Scalars['String']>;
  /** The alerts associated to the display. */
  alerts: Array<DisplayAlert>;
  /** The alias of the display. */
  alias?: Maybe<Scalars['String']>;
  /** Subscriptions that are available to the display. */
  appSubscriptions: Array<DisplayAppSubscription>;
  /** The autoRestart state of the display, enable or disable state. */
  autoRestart?: Maybe<AutoRestartState>;
  /** The battery information of the display. */
  battery?: Maybe<BatteryState>;
  /** The battery threshold for a display. */
  batteryThreshold?: Maybe<BatteryThreshold>;
  /** The bookmarks of the display. */
  bookmarks: Bookmarks;
  /** The brightness state of the display. Ranging from 0 to 100. */
  brightness?: Maybe<BrightnessState>;
  /** The brightness V2 state of the display */
  brightnessV2?: Maybe<BrightnessV2State>;
  /** The burn-in refresh schedule state of the display. Tableau platform only. */
  burnInRefreshSettings?: Maybe<BurnInRefreshSettingsState>;
  /** The model of the display. */
  commercialTypeNumber: Scalars['String'];
  /**
   * The configuration associated with the display.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, Guest, Installer, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configuration?: Maybe<ConfigurationModel>;
  /**
   * The configuration sync status associated with the display.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, Guest, Installer, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationSyncStatus?: Maybe<ConfigurationSyncStatus>;
  /**
   * The configurations updatedAt status with the display.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, Guest, Installer, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdatedAt?: Maybe<Scalars['String']>;
  /** The content source of the display */
  contentSource?: Maybe<ContentSourceSettings>;
  /** The available content source inputs V2. */
  contentSourceInputsV2?: Maybe<Array<ContentSourceInputV2>>;
  /** The customer to which this display belongs. */
  customer: Customer;
  /** sdk version and type of display */
  deviceSdk?: Maybe<DeviceSdk>;
  /** The firmware version of the display. */
  firmware?: Maybe<Firmware>;
  /** The groups associated to the display. */
  groups: Array<Group>;
  /** Indicates whether the display has an empty shadow state and thus cannot properly interacted with. */
  hasEmptyShadow: Scalars['Boolean'];
  /** Whether the display has sensitive data. This includes bookmarks, screenshots or a job history. */
  hasSensitiveData: Scalars['Boolean'];
  /** The Host information of the display. */
  host?: Maybe<Host>;
  /** The Humidity of the display */
  humidity?: Maybe<Array<Humidity>>;
  /** The identifier of the display. */
  id: Scalars['ID'];
  /** The infra-red control state of the display. */
  infraRedControl?: Maybe<ControlState>;
  /** The keyboard control state of the display. */
  keyboardControl?: Maybe<ControlState>;
  /** The color of the LED strip of the display. */
  ledStripColor?: Maybe<LedStripColorState>;
  /** The luminescence of the display */
  luminescence?: Maybe<Array<Luminescence>>;
  /** The network information of the display. */
  networkInformation: DisplayNetworkInformation;
  /** The display's network interfaces. */
  networkInterfaces?: Maybe<Array<NetworkInterface>>;
  /** The orientation of the display. */
  orientation?: Maybe<OrientationState>;
  /** The platform of the display. */
  platform: DisplayPlatform;
  /** The playlist associated with the display. */
  playlist?: Maybe<DisplayPlaylist>;
  /** The playlist type supported by the display. */
  playlistType?: Maybe<PlaylistType>;
  /** The ports control state of the display. */
  portsControl?: Maybe<PortsControlState>;
  /** The power of the display. */
  power?: Maybe<PowerState>;
  /** The power schedule for the display. */
  powerSchedule?: Maybe<DisplayPowerSchedule>;
  /**
   * The power settings of the display.
   * @deprecated Use recommendedSettings instead.
   */
  powerSettings?: Maybe<PowerSettingsState>;
  /** The presence of the display, whether it is connected or not. */
  presence?: Maybe<DisplayPresence>;
  /** The reboot state of the display. */
  reboot?: Maybe<RebootState>;
  /** The recommended settings of the display. */
  recommendedSettings?: Maybe<RecommendedSettingsState>;
  /** The schedule for the display. */
  schedule?: Maybe<DisplaySchedule>;
  /** A screenshot of the display. */
  screenshot?: Maybe<Screenshot>;
  /** The serial number of the display. */
  serialNumber: Scalars['String'];
  /** The signal detection state of the display. */
  signalDetection?: Maybe<SignalDetectionState>;
  /** The site associated to the display. */
  site?: Maybe<Site>;
  /** The subscription ID associated to the display. */
  subscriptionId?: Maybe<Scalars['String']>;
  /** The trait targets of the display. */
  target?: Maybe<Target>;
  /** The temperature threshold for a display. */
  temperatureThreshold?: Maybe<TemperatureThreshold>;
  /** The timestamp of the last temperature update. */
  temperatureUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** The temperatures of the display */
  temperatures?: Maybe<Array<Temperature>>;
  /** The time zone of the display. */
  timeZone?: Maybe<TimeZoneState>;
  /** The volume state of the display */
  volume?: Maybe<Volume>;
};

export type DisplayAbortJobInput = {
  /** The identifier of the job. */
  jobId: Scalars['ID'];
};

export type DisplayAbortJobPayload = {
  __typename?: 'DisplayAbortJobPayload';
  /** The updated display */
  display: Display;
};

export type DisplayAddGroupInput = {
  /** The identifier of the display. */
  displayId: Scalars['ID'];
  /** The identifier of the group that will be associated to the display. */
  groupId: Scalars['ID'];
};

export type DisplayAlert = {
  __typename?: 'DisplayAlert';
  /** The timestamp at which the alert was created. */
  createdAt: Scalars['DateTime'];
  /** The handle of the customer. */
  customerHandle: Scalars['String'];
  /** The identifier of the display. */
  displayId: Scalars['String'];
  /** The identifier of the alert. */
  id: Scalars['ID'];
  /** The message of the alert. */
  message: Scalars['String'];
  /** The structured message object of the alert. */
  messageObj?: Maybe<DisplayAlertMessageObj>;
};

export type DisplayAlertBulkResolveInput = {
  /** The identifiers of the alerts. */
  displayAlertIds: Array<Scalars['ID']>;
};

export type DisplayAlertBulkResolvePayload = {
  __typename?: 'DisplayAlertBulkResolvePayload';
  /** The identifiers of the displays which were resolved. */
  displayAlertIds: Array<Scalars['ID']>;
};

export type DisplayAlertMessageObj = {
  __typename?: 'DisplayAlertMessageObj';
  keys: Array<Scalars['String']>;
  type: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type DisplayAppSubscription = {
  __typename?: 'DisplayAppSubscription';
  /** The app install for this subscription. */
  appInstallation?: Maybe<AppInstallation>;
  /** The installable app versions for this subscription. */
  appVersions?: Maybe<Array<Scalars['String']>>;
  /** The date that this subscription was created. */
  createdAt: Scalars['DateTime'];
  /** The url of the app icon of this subscription */
  iconUrl?: Maybe<Scalars['String']>;
  /** The identifier of this subscription */
  id: Scalars['ID'];
  /** The name of this subscription. */
  name: Scalars['String'];
  /** The date that this subscription was last updated. */
  updatedAt: Scalars['DateTime'];
  /** The current usage of the subscription. */
  usage: SubscriptionUsage;
};

export type DisplayBulkAddGroupsInput = {
  /** The identifiers of the displays. */
  displayIds: Array<Scalars['ID']>;
  /** The groups that will be associated to the displays. */
  groupIds: Array<Scalars['ID']>;
};

export type DisplayBulkAddGroupsPayload = {
  __typename?: 'DisplayBulkAddGroupsPayload';
  /** The displays which had the new groups associated to them. */
  displays: Array<Display>;
  /** The groups assigned to the displays. */
  groups: Array<Group>;
};

export type DisplayBulkApplyRecommendedPowerSettingsInput = {
  /** The display ids to update */
  displayIds: Array<Scalars['ID']>;
};

export type DisplayBulkApplyRecommendedPowerSettingsPayload = {
  __typename?: 'DisplayBulkApplyRecommendedPowerSettingsPayload';
  /** The changed displays */
  displays: Array<Display>;
};

export type DisplayBulkApplyRecommendedSettingsInput = {
  /** The display ids to update */
  displayIds: Array<Scalars['ID']>;
};

export type DisplayBulkApplyRecommendedSettingsPayload = {
  __typename?: 'DisplayBulkApplyRecommendedSettingsPayload';
  /** The changed displays */
  displays: Array<Display>;
};

export type DisplayBulkAssignConfigurationsInput = {
  /** display ids to assign the configuration */
  displayIds: Array<Scalars['ID']>;
  /** ID of the configuration */
  id: Scalars['String'];
};

export type DisplayBulkClearDataInput = {
  /** The displays to clear. */
  displayIds: Array<Scalars['ID']>;
};

export type DisplayBulkClearDataPayload = {
  __typename?: 'DisplayBulkClearDataPayload';
  /** The changed displays */
  displays: Array<Display>;
};

export type DisplayBulkRebootInput = {
  /** The displays to update. */
  displayIds: Array<Scalars['ID']>;
  /** The timestamp at which this update is planned. Starts immediately if absent. */
  plannedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DisplayBulkRebootPayload = {
  __typename?: 'DisplayBulkRebootPayload';
  /** The changed displays. */
  displays: Array<Display>;
};

export type DisplayBulkRemoveGroupsInput = {
  /** The identifiers of the displays. */
  displayIds: Array<Scalars['ID']>;
  /** The identifiers of the groups that will be removed from the displays. */
  groupIds: Array<Scalars['ID']>;
};

export type DisplayBulkRemoveGroupsPayload = {
  __typename?: 'DisplayBulkRemoveGroupsPayload';
  /** The displays which the associated groups removed. */
  displays: Array<Display>;
  /** The groups removed from the displays. */
  groups: Array<Group>;
};

export type DisplayBulkRequestAppInstallationInput = {
  /** The version of the app that should be installed */
  appVersion?: InputMaybe<Scalars['String']>;
  /** The display IDs for which to create an installation request. */
  displayIds: Array<Scalars['ID']>;
  /** The subscription ID for which to create an installation request. */
  subscriptionId: Scalars['ID'];
};

export type DisplayBulkRequestAppInstallationPayload = {
  __typename?: 'DisplayBulkRequestAppInstallationPayload';
  /** The displays that an app installation was requested for. */
  displays: Array<Display>;
};

export type DisplayBulkSyncConfigurationsInput = {
  /** ID of the configuration */
  id: Scalars['String'];
};

export type DisplayBulkUnassignConfigurationsInput = {
  /** display ids to unassign the configuration */
  displayIds: Array<Scalars['ID']>;
  /** ID of the configuration */
  id: Scalars['String'];
};

export type DisplayBulkUpdateAgentReleaseChannelInput = {
  /** The displays to update. */
  displayIds: Array<Scalars['ID']>;
  /** The state of the keyboard controls. */
  releaseChannel: ReleaseChannel;
};

export type DisplayBulkUpdateAgentReleaseChannelPayload = {
  __typename?: 'DisplayBulkUpdateAgentReleaseChannelPayload';
  /** The changed displays. */
  displays: Array<Display>;
};

export type DisplayBulkUpdateAndroidFirmwareInput = {
  /** The ids of displays to update. */
  displayIds: Array<Scalars['ID']>;
  /** The timestamp at which this update is planned. Starts immediately if absent. */
  plannedAt?: InputMaybe<Scalars['DateTime']>;
  /** The version to which the Android component of the firmware will be updated. */
  targetVersion: Scalars['FirmwareVersion'];
};

export type DisplayBulkUpdateAndroidFirmwarePayload = {
  __typename?: 'DisplayBulkUpdateAndroidFirmwarePayload';
  /** The changed displays */
  displays: Array<Display>;
};

export type DisplayBulkUpdateAppContentSourceInput = {
  /** The activity of the application. */
  activity?: InputMaybe<Scalars['String']>;
  /** The id of the application. */
  applicationId: Scalars['String'];
  /** The displays to update */
  displayIds: Array<Scalars['ID']>;
  /** The label of the application. */
  label?: InputMaybe<Scalars['String']>;
};

export type DisplayBulkUpdateAutoRestartInput = {
  /** The display ids to update. */
  displayIds: Array<Scalars['ID']>;
  /** The enable/disable auto restart feature for all display. */
  switch: SwitchType;
  /** The time at which all the displays should auto reboot. */
  time?: InputMaybe<Scalars['String']>;
};

export type DisplayBulkUpdateAutoRestartPayload = {
  __typename?: 'DisplayBulkUpdateAutoRestartPayload';
  /** The changed displays. */
  displays: Array<Display>;
};

export type DisplayBulkUpdateBatteryPowerManagementInput = {
  /** The display ids to update. */
  displayIds: Array<Scalars['ID']>;
  /** The power management state to set: ON or OFF. */
  powerManagement: BatteryPowerManagement;
};

export type DisplayBulkUpdateBatteryPowerManagementPayload = {
  __typename?: 'DisplayBulkUpdateBatteryPowerManagementPayload';
  /** The changed displays. */
  displays: Array<Display>;
};

export type DisplayBulkUpdateBookmarkContentSourceInput = {
  /** The displays to update */
  displayIds: Array<Scalars['ID']>;
  /** The index of the bookmark. */
  index: Scalars['Int'];
};

export type DisplayBulkUpdateBookmarksAllInput = {
  /** The bookmarks configuration that will be given to the display. */
  bookmarks: Array<Scalars['String']>;
  /** The display ids to update */
  displayIds: Array<Scalars['ID']>;
};

export type DisplayBulkUpdateBookmarksAllPayload = {
  __typename?: 'DisplayBulkUpdateBookmarksAllPayload';
  /** The changed displays */
  displays: Array<Display>;
};

export type DisplayBulkUpdateBrightnessInput = {
  /** The brightness value that will be applied to the displays */
  brightness: Scalars['Int'];
  /** The display ids to update. */
  displayIds: Array<Scalars['ID']>;
};

export type DisplayBulkUpdateBrightnessPayload = {
  __typename?: 'DisplayBulkUpdateBrightnessPayload';
  /** The changed displays. */
  displays: Array<Display>;
};

export type DisplayBulkUpdateBrightnessV2Input = {
  /** The auto brightness value that will be applied to the displays */
  autoBrightness?: InputMaybe<Scalars['Boolean']>;
  /** The brightness value that will be applied to the displays */
  brightness: Scalars['Int'];
  /** The display ids to update. */
  displayIds: Array<Scalars['ID']>;
};

export type DisplayBulkUpdateBrightnessV2Payload = {
  __typename?: 'DisplayBulkUpdateBrightnessV2Payload';
  /** The changed displays. */
  displays: Array<Display>;
};

export type DisplayBulkUpdateBurnInRefreshInput = {
  /** The display ids to update. */
  displayIds: Array<Scalars['ID']>;
  /** Daily refresh start time in HH:MM format (24h). Tableau platform only. */
  time: Scalars['String'];
};

export type DisplayBulkUpdateBurnInRefreshPayload = {
  __typename?: 'DisplayBulkUpdateBurnInRefreshPayload';
  /** The changed displays. */
  displays: Array<Display>;
};

export type DisplayBulkUpdateContentSourcePayload = {
  __typename?: 'DisplayBulkUpdateContentSourcePayload';
  /** The changed displays */
  displays: Array<Display>;
};

export type DisplayBulkUpdateDefaultAppContentSourceInput = {
  /** The id of the application. */
  applicationId: Scalars['String'];
  /** The displays to update */
  displayIds: Array<Scalars['ID']>;
  /** The label of the application. */
  label?: InputMaybe<Scalars['String']>;
};

export type DisplayBulkUpdateDefaultBookmarkContentSourceInput = {
  /** The displays to update */
  displayIds: Array<Scalars['ID']>;
  /** The index of the bookmark. */
  index: Scalars['Int'];
};

export type DisplayBulkUpdateDefaultContentSourcePayload = {
  __typename?: 'DisplayBulkUpdateDefaultContentSourcePayload';
  /** The changed displays */
  displays: Array<Display>;
};

export type DisplayBulkUpdateDefaultInputContentSourceInput = {
  /** The displays to update */
  displayIds: Array<Scalars['ID']>;
  /** The input source. */
  source: Scalars['String'];
};

export type DisplayBulkUpdateDefaultPlaylistContentSourceInput = {
  /** The displays to update */
  displayIds: Array<Scalars['ID']>;
  /** The id of the playlist. */
  playlistId: Scalars['String'];
};

export type DisplayBulkUpdateInfraRedControlInput = {
  /** The state of the infra-red controls. */
  controlState: ControlLockState;
  /** The displays to update. */
  displayIds: Array<Scalars['ID']>;
};

export type DisplayBulkUpdateInfraRedControlPayload = {
  __typename?: 'DisplayBulkUpdateInfraRedControlPayload';
  /** The changed displays. */
  displays: Array<Display>;
};

export type DisplayBulkUpdateInputContentSourceInput = {
  /** The displays to update */
  displayIds: Array<Scalars['ID']>;
  /** The input source. */
  source: Scalars['String'];
};

export type DisplayBulkUpdateKeyboardControlInput = {
  /** The state of the keyboard controls. */
  controlState: ControlLockState;
  /** The displays to update. */
  displayIds: Array<Scalars['ID']>;
};

export type DisplayBulkUpdateKeyboardControlPayload = {
  __typename?: 'DisplayBulkUpdateKeyboardControlPayload';
  /** The changed displays. */
  displays: Array<Display>;
};

export type DisplayBulkUpdateLedStripColorInput = {
  /** The display ids to update */
  displayIds: Array<Scalars['ID']>;
  /** The ledStripColor state that will be given to the display. */
  ledStripColor: LedStripColor;
};

export type DisplayBulkUpdateLedStripColorPayload = {
  __typename?: 'DisplayBulkUpdateLedStripColorPayload';
  /** The changed displays */
  displays: Array<Display>;
};

export type DisplayBulkUpdatePlaylistContentSourceInput = {
  /** The displays to update */
  displayIds: Array<Scalars['ID']>;
  /** The id of the playlist. */
  playlistId: Scalars['String'];
};

export type DisplayBulkUpdatePlaylistInput = {
  /** The display identifier. */
  displayIds: Array<Scalars['ID']>;
  /** The playlist identifier, or null to delete the media. */
  playlistId?: InputMaybe<Scalars['ID']>;
};

export type DisplayBulkUpdatePlaylistPayload = {
  __typename?: 'DisplayBulkUpdatePlaylistPayload';
  /** The changed displays. */
  displays: Array<Display>;
};

export type DisplayBulkUpdatePortsControlInput = {
  /** The displays to update. */
  displayIds: Array<Scalars['ID']>;
  /** The state of the ports. */
  portsControlState: PortsControlLockState;
};

export type DisplayBulkUpdatePortsControlPayload = {
  __typename?: 'DisplayBulkUpdatePortsControlPayload';
  /** The changed displays. */
  displays: Array<Display>;
};

export type DisplayBulkUpdatePowerInput = {
  /** The display ids to update */
  displayIds: Array<Scalars['ID']>;
  /** The power state that will be given to the display. */
  power: Power;
};

export type DisplayBulkUpdatePowerPayload = {
  __typename?: 'DisplayBulkUpdatePowerPayload';
  /** The changed displays */
  displays: Array<Display>;
};

export type DisplayBulkUpdatePowerScheduleInput = {
  /** The displays identifiers. */
  displayIds: Array<Scalars['ID']>;
  /** The power schedule identifier. */
  powerScheduleId?: InputMaybe<Scalars['ID']>;
};

export type DisplayBulkUpdatePowerSchedulePayload = {
  __typename?: 'DisplayBulkUpdatePowerSchedulePayload';
  /** The changed displays. */
  displays: Array<Display>;
};

export type DisplayBulkUpdateScheduleInput = {
  /** The displays identifiers. */
  displayIds: Array<Scalars['ID']>;
  /** The schedule identifier. Leave empty to remove the schedule. */
  scheduleId?: InputMaybe<Scalars['ID']>;
};

export type DisplayBulkUpdateSchedulePayload = {
  __typename?: 'DisplayBulkUpdateSchedulePayload';
  /** The changed displays. */
  displays: Array<Display>;
};

export type DisplayBulkUpdateSignalDetectionInput = {
  /** The display ids to update. */
  displayIds: Array<Scalars['ID']>;
  /** Whether the signal detection should be enabled or not. */
  enable: Scalars['Boolean'];
};

export type DisplayBulkUpdateSignalDetectionPayload = {
  __typename?: 'DisplayBulkUpdateSignalDetectionPayload';
  /** The changed displays. */
  displays: Array<Display>;
};

export type DisplayBulkUpdateSiteInput = {
  /** The identifiers of the displays. */
  displayIds: Array<Scalars['ID']>;
  /** The site that will be associated with the displays. */
  siteId?: InputMaybe<Scalars['ID']>;
};

export type DisplayBulkUpdateSitePayload = {
  __typename?: 'DisplayBulkUpdateSitePayload';
  /** The displays which had their site updated */
  displays: Array<Display>;
  /** The site assigned to the given displays */
  site?: Maybe<Site>;
};

export type DisplayBulkUpdateTimeZoneInput = {
  /** The identifiers of the displays to update */
  displayIds: Array<Scalars['ID']>;
  /** The canonical time zone that will be configured on the display. */
  timeZone: Scalars['String'];
};

export type DisplayBulkUpdateTimeZonePayload = {
  __typename?: 'DisplayBulkUpdateTimeZonePayload';
  /** The changed displays */
  displays: Array<Display>;
};

export type DisplayBulkUpdateVolumeInput = {
  /** The ids of the displays to update. */
  displayIds: Array<Scalars['ID']>;
  /** The volume level that will be applied to the display. */
  level?: InputMaybe<Scalars['Int']>;
  /** The new volume maximum limit. */
  max?: InputMaybe<Scalars['Int']>;
  /** The new volume minimum limit. */
  min?: InputMaybe<Scalars['Int']>;
  /** The mute state that will be given to the displays. */
  mute?: InputMaybe<Scalars['Boolean']>;
};

export type DisplayBulkUpdateVolumePayload = {
  __typename?: 'DisplayBulkUpdateVolumePayload';
  /** The changed displays. */
  displays: Array<Display>;
};

export type DisplayCaptureScreenshotInput = {
  /** The display to capture a screenshot */
  displayId: Scalars['ID'];
};

export type DisplayCapturescreenshotPayload = {
  __typename?: 'DisplayCapturescreenshotPayload';
  /** The display that was captured. */
  display: Display;
};

export type DisplayClaimInput = {
  /** The alias that will be given to the display. */
  alias?: InputMaybe<Scalars['String']>;
  /** The customer to which the display will be claimed. */
  customerId: Scalars['ID'];
  /** The display code acting as a proof of physical access. */
  displayCode: Scalars['ID'];
  /** The identifier of the display. */
  displayId: Scalars['ID'];
  /** The site that will be associated to the display. */
  siteId?: InputMaybe<Scalars['ID']>;
};

export type DisplayClaimPayload = {
  __typename?: 'DisplayClaimPayload';
  /** The customer that was associated to the display. */
  customer: Customer;
  /** The display that was created. */
  display: Display;
};

export type DisplayConfigurationModel = {
  __typename?: 'DisplayConfigurationModel';
  /** The timestamp at which the configuration was created. */
  createdAt: Scalars['DateTime'];
  /** The ID of the customer associated with this document. */
  customerId: Scalars['String'];
  /** Description of the configuration. */
  description?: Maybe<Scalars['String']>;
  /** Group ids that the display belong to. */
  groupIds?: Maybe<Array<Scalars['String']>>;
  /** The unique identifier for the configuration. */
  id: Scalars['ID'];
  /** The name of the configuration. */
  name: Scalars['String'];
  /** platform for the configuration. */
  platform: Scalars['String'];
  /** The associated profile information. */
  profile: Profile;
  /** Site id for the display. */
  siteId?: Maybe<Scalars['String']>;
  /** Timezone for the display. */
  timezone: Scalars['String'];
  /** Configuration version. */
  version: Scalars['Float'];
};

export type DisplayCurrentPlaylist = {
  __typename?: 'DisplayCurrentPlaylist';
  /** The description of the current playlist */
  description?: Maybe<Scalars['String']>;
  /** The identifier of the current playlist. */
  id: Scalars['ID'];
  /** A flag that indicates if the current playlist is out of sync with the actual playlist configuration. */
  isOutOfSync: Scalars['Boolean'];
  /** A flag that indicates if the current playlist has been modified on the display. */
  isTampered: Scalars['Boolean'];
  /** The total size of the current playlist. */
  size: Scalars['BigInt'];
  /** The title of the current playlist. */
  title: Scalars['String'];
};

export type DisplayDeleteGroupInput = {
  /** The identifier of the display. */
  displayId: Scalars['ID'];
  /** The group which will be removed from the display. */
  groupId: Scalars['ID'];
};

export type DisplayFilters = {
  configurationIds?: InputMaybe<Array<Scalars['String']>>;
  firmwares?: InputMaybe<Array<Scalars['String']>>;
  groupIds?: InputMaybe<Array<Scalars['String']>>;
  multiClaimIds?: InputMaybe<Array<Scalars['String']>>;
  playlistIds?: InputMaybe<Array<Scalars['String']>>;
  scheduleIds?: InputMaybe<Array<Scalars['String']>>;
  siteIds?: InputMaybe<Array<Scalars['String']>>;
  status?: InputMaybe<Array<Scalars['String']>>;
  warnings?: InputMaybe<Array<Scalars['String']>>;
};

export type DisplayNetworkInformation = {
  __typename?: 'DisplayNetworkInformation';
  /** The MAC address of the ethernet adapter. */
  ethernetMacAddress: Scalars['String'];
  /** The local IP address of the display. */
  localIPAddress?: Maybe<Scalars['String']>;
  /** The last reported network type. Either "ETHERNET" or "WIFI". */
  networkType?: Maybe<NetworkType>;
  /** The MAC address of the Wi-Fi adapter. */
  wifiMacAddress?: Maybe<Scalars['String']>;
};

export type DisplayPlatform = {
  __typename?: 'DisplayPlatform';
  /** The name of the platform. */
  name: Scalars['String'];
  /** The platform type. */
  type: Scalars['String'];
  /** The version of the platform. */
  version?: Maybe<Scalars['String']>;
};

export type DisplayPlaylist = {
  __typename?: 'DisplayPlaylist';
  /** The current playlist as reported by the display. */
  current?: Maybe<DisplayCurrentPlaylist>;
  /** The playlist that is being synced to the display. */
  sync?: Maybe<DisplayPlaylistSync>;
};

export type DisplayPlaylistSync = {
  /** The description of the playlist that is being synced to the display. */
  description?: Maybe<Scalars['String']>;
  /** The identifier of the playlist that is being synced to the display. */
  id: Scalars['ID'];
  /** The internal identifier for the sync job. */
  jobId: Scalars['String'];
  /** The total size of the playlist that is being synced to the display. */
  size: Scalars['BigInt'];
  /** The title of the playlist that is being synced to the display. */
  title: Scalars['String'];
};

export type DisplayPowerSchedule = {
  __typename?: 'DisplayPowerSchedule';
  /** Whether the schedule is synchronized with the display. */
  isSynced?: Maybe<Scalars['Boolean']>;
  /** The latest job for power schedule update. */
  latestJob?: Maybe<PowerScheduleUpdateJob>;
  /** The power schedule reported from the display. */
  schedule?: Maybe<PowerSchedule>;
};

export type DisplayPresence = {
  __typename?: 'DisplayPresence';
  /** Whether the display is connected. */
  connected: Scalars['Boolean'];
  /** The timestamp on which the display was last connected. */
  timestamp: Scalars['DateTime'];
};

export type DisplayRequestAppInstallationInput = {
  /** The version of the app that should be installed. If not specified the latest available version will be selected. */
  appVersion?: InputMaybe<Scalars['String']>;
  /** The display ID for which to create an installation request. */
  displayId: Scalars['ID'];
  /** The subscription ID for which to create an installation request. */
  subscriptionId: Scalars['ID'];
};

export type DisplayRequestAppInstallationPayload = {
  __typename?: 'DisplayRequestAppInstallationPayload';
  /** The display that an app installation was requested for. */
  display: Display;
};

export type DisplayRequestAppUninstallationInput = {
  /** The display ID for which to create the uninstall request. */
  displayId: Scalars['ID'];
  /** The subscription ID for which to create the uninstall request. */
  subscriptionId: Scalars['ID'];
};

export type DisplayRequestAppUninstallationPayload = {
  __typename?: 'DisplayRequestAppUninstallationPayload';
  /** The display that an app uninstallation was requested for. */
  display: Display;
};

export type DisplayRetryRequestAppInstallationInput = {
  /** The display that the installation should be retried for. */
  displayId: Scalars['ID'];
  /** The subscription ID for which to retry the installation. */
  subscriptionId: Scalars['ID'];
};

export type DisplayRetryRequestAppInstallationPayload = {
  __typename?: 'DisplayRetryRequestAppInstallationPayload';
  /** The display that the app installation was retried for. */
  display: Display;
};

export type DisplayRetryRequestAppUninstallationInput = {
  /** The ID of the display for which to retry delete app installation. */
  displayId: Scalars['ID'];
  /** The ID of the subscription for which to retry delete app installation. */
  subscriptionId: Scalars['ID'];
};

export type DisplayRetryRequestAppUninstallationPayload = {
  __typename?: 'DisplayRetryRequestAppUninstallationPayload';
  /** The display that the deletion of app installation was retried for. */
  display: Display;
};

export type DisplaySchedule = {
  __typename?: 'DisplaySchedule';
  /** Whether the schedule is synchronized with the display. */
  isSynced?: Maybe<Scalars['Boolean']>;
  /** The latest job for schedule update. */
  latestJob?: Maybe<ScheduleUpdateJob>;
  /** The schedule reported from the display. */
  schedule?: Maybe<Schedule>;
  /** Out-of-sync slot warnings for the active schedule. */
  slotWarnings: Array<ScheduleSlotWarning>;
};

export enum DisplayType {
  Protv = 'PROTV',
  Signage = 'SIGNAGE'
}

export type DisplayUnclaimInput = {
  /** The identifier of the display. */
  displayId: Scalars['ID'];
};

export type DisplayUnclaimPayload = {
  __typename?: 'DisplayUnclaimPayload';
  /** The customer from which the display was unclaimed. */
  customer: Customer;
};

export type DisplayUpdateAliasInput = {
  /** The alias which will be given to the display. */
  alias?: InputMaybe<Scalars['ID']>;
  /** The identifier of the display. */
  displayId: Scalars['ID'];
};

export type DisplayUpdateAutoRestartInput = {
  /** The identifier of the display. */
  id: Scalars['ID'];
  /** To enable auto restart feature in display. */
  switch: SwitchType;
  /** The time at which display auto reboot. */
  time?: InputMaybe<Scalars['String']>;
};

export type DisplayUpdateAutoRestartPayload = {
  __typename?: 'DisplayUpdateAutoRestartPayload';
  /** The display that was changed. */
  display: Display;
};

export type DisplayUpdateBookmarksAllInput = {
  /** The bookmarks configuration that will be given to the display. */
  bookmarks: Array<Scalars['String']>;
  /** The identifier of the display. */
  id: Scalars['ID'];
};

export type DisplayUpdateBookmarksAllPayload = {
  __typename?: 'DisplayUpdateBookmarksAllPayload';
  /** The display that was changed. */
  display: Display;
};

export type DisplayUpdateOrientationInput = {
  /** The identifier of the display. */
  id: Scalars['ID'];
  /** The orientation state that will be given to the display. */
  orientation: Orientation;
};

export type DisplayUpdateOrientationPayload = {
  __typename?: 'DisplayUpdateOrientationPayload';
  /** The display that was changed. */
  display: Display;
};

export type DisplayUpdatePlaylistInput = {
  /** The display identifier. */
  displayId: Scalars['ID'];
  /** The playlist identifier, or null to delete the media. */
  playlistId?: InputMaybe<Scalars['ID']>;
};

export type DisplayUpdatePlaylistPayload = {
  __typename?: 'DisplayUpdatePlaylistPayload';
  /** The updated display. */
  display: Display;
};

export type DisplayUpdatePowerInput = {
  /** The identifier of the display. */
  id: Scalars['ID'];
  /** The power state that will be given to the display. */
  power: Power;
};

export type DisplayUpdatePowerPayload = {
  __typename?: 'DisplayUpdatePowerPayload';
  /** The display that was changed. */
  display: Display;
};

export type DisplayUpdateSiteInput = {
  /** The identifier of the display. */
  displayId: Scalars['ID'];
  /** The site that will be associated with the display. */
  siteId?: InputMaybe<Scalars['ID']>;
};

export type DisplayUpdateVolumeLevelInput = {
  /** The identifier of the display. */
  id: Scalars['ID'];
  /** The volume level that will be given to the display. */
  level: Scalars['Int'];
};

export type DisplayUpdateVolumeLevelPayload = {
  __typename?: 'DisplayUpdateVolumeLevelPayload';
  /** The display that was changed. */
  display: Display;
};

export type DisplayUpdateVolumeLimitMaxInput = {
  /** The identifier of the display. */
  id: Scalars['ID'];
  /** The new volume maximum limit */
  max: Scalars['Int'];
};

export type DisplayUpdateVolumeLimitMaxPayload = {
  __typename?: 'DisplayUpdateVolumeLimitMaxPayload';
  /** The display that was changed. */
  display: Display;
};

export type DisplayUpdateVolumeLimitMinInput = {
  /** The identifier of the display. */
  id: Scalars['ID'];
  /** The new volume minimum limit */
  min: Scalars['Int'];
};

export type DisplayUpdateVolumeLimitMinPayload = {
  __typename?: 'DisplayUpdateVolumeLimitMinPayload';
  /** The display that was changed. */
  display: Display;
};

export type DisplayUpdateVolumeMuteInput = {
  /** The identifier of the display. */
  id: Scalars['ID'];
  /** The mute state that will be given to the display. */
  mute: Scalars['Boolean'];
};

export type DisplayUpdateVolumeMutePayload = {
  __typename?: 'DisplayUpdateVolumeMutePayload';
  /** The display that was changed. */
  display: Display;
};

/** Enumeration of domain verification statuses */
export enum DomainVerificationStatus {
  Completed = 'completed',
  Pending = 'pending'
}

export type FileUploadRequestInput = {
  /** The file size of the file to be uploaded. */
  size: Scalars['Int'];
  /** The MIME type of the file to be uploaded. */
  type: Scalars['String'];
};

export type FileUploadRequestPayload = {
  __typename?: 'FileUploadRequestPayload';
  /** The URL to fetch the file. */
  assetUrl: Scalars['String'];
  /** The signed URL to upload the file. */
  uploadUrl: Scalars['String'];
};

export type Firmware = {
  __typename?: 'Firmware';
  /** The Android component of the firmware. */
  android: Android;
  /** The Scaler component of the firmware. */
  scaler?: Maybe<Scaler>;
};

export type FirmwareUpdateAndroidInput = {
  /** The identifier of the display. */
  displayId: Scalars['ID'];
  /** The timestamp at which this update is planned. Starts immediately if absent. */
  plannedAt?: InputMaybe<Scalars['DateTime']>;
  /** The version to which the Android component of the firmware will be updated. */
  targetVersion: Scalars['FirmwareVersion'];
};

export type FirmwareUpdateAndroidPayload = {
  __typename?: 'FirmwareUpdateAndroidPayload';
  /** The display that will be updated. */
  display: Display;
};

export type GenerateMultiClaimCodeInput = {
  /** CustomerId for which the claimCode need to generate */
  customerId: Scalars['String'];
};

export type Group = {
  __typename?: 'Group';
  /** The identifier of the group. */
  id: Scalars['ID'];
  /** The name of the group. */
  name: Scalars['String'];
};

export type GroupCreateInput = {
  /** The customer to which to add the group. */
  customerId: Scalars['ID'];
  /** The name of the group. */
  name: Scalars['String'];
};

export type GroupCreatePayload = {
  __typename?: 'GroupCreatePayload';
  /** The customer associated with the group. */
  customer?: Maybe<Customer>;
  /** The group that was created. */
  group?: Maybe<Group>;
};

export type Host = {
  __typename?: 'Host';
  /** The coupling status of the host. */
  coupledState?: Maybe<Scalars['String']>;
  /** The firmware version of the host. */
  firmwareVersion?: Maybe<Scalars['String']>;
  /** The model name of the host. */
  modelName?: Maybe<Scalars['String']>;
  /** The platform label of the host. */
  platformLabel?: Maybe<Scalars['String']>;
  /** The serial number of the host. */
  serialNumber?: Maybe<Scalars['String']>;
  /** The timestamp when the host information was last updated. */
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type Humidity = {
  __typename?: 'Humidity';
  /** Whether a humidity sensor is present. */
  isSensorPresent: Scalars['Boolean'];
  /** The last time the humidity value was updated. */
  updatedAt?: Maybe<Scalars['String']>;
  /** The value of the humidity sensor. */
  value: Scalars['String'];
};

export type InputContentSource = {
  __typename?: 'InputContentSource';
  /** The display input source. */
  source: Scalars['String'];
};

export enum LedStripColor {
  Blue = 'BLUE',
  Cyan = 'CYAN',
  Green = 'GREEN',
  Magenta = 'MAGENTA',
  Red = 'RED',
  Unspecified = 'UNSPECIFIED',
  White = 'WHITE',
  Yellow = 'YELLOW'
}

export type LedStripColorState = {
  __typename?: 'LedStripColorState';
  /** The newly desired state of the color of the LED strip. Cleared when successful, failed or timed out. */
  desired?: Maybe<LedStripColor>;
  /** The last reported color of the LED strip of the display. */
  reported: LedStripColor;
};

export type Luminescence = {
  __typename?: 'Luminescence';
  /** Whether the luminescence sensor reading is valid. */
  isValid: Scalars['Boolean'];
  /** The value of the luminescence sensor. */
  value: Scalars['Float'];
};

export type Media = {
  __typename?: 'Media';
  /** The date when the media was created. */
  createdAt: Scalars['DateTime'];
  /** The duration that the media will be displayed on screen. */
  duration: Scalars['Int'];
  /** The identifier of the media. */
  id: Scalars['ID'];
  /** Indicates if the duration of the media is default or custom. */
  isDefaultDuration: Scalars['Boolean'];
  /** The size of the media, in Bytes. */
  size: Scalars['BigInt'];
  /** The title of the media. */
  title: Scalars['String'];
  /** The MIME type of the media. */
  type: Scalars['String'];
};

export type MediaCreateRequestInput = {
  /** The identifier of the customer. */
  customerId: Scalars['ID'];
  /** The size of the media file. */
  size: Scalars['BigInt'];
  /** The title of the media. */
  title: Scalars['String'];
  /** The type of the media file. */
  type: Scalars['String'];
};

export type MediaCreateRequestPayload = {
  __typename?: 'MediaCreateRequestPayload';
  /** The identifier of the media. */
  mediaId: Scalars['ID'];
  /** The url where to upload the media. */
  uploadUrl: Scalars['String'];
};

export type MediaUpdateInput = {
  /** Duration for the media. */
  duration?: InputMaybe<Scalars['Int']>;
  /** Indicates if the current duration is default. */
  isDefaultDuration?: InputMaybe<Scalars['Boolean']>;
  /** The media IDs of the media to be updated. */
  mediaIds: Array<Scalars['ID']>;
  /** Id of the playlist that media IDs belong to. */
  playlistId: Scalars['String'];
};

export type MultiClaimCodeDocument = {
  __typename?: 'MultiClaimCodeDocument';
  /** The claim code. */
  code: Scalars['String'];
  /** The creation timestamp of the document. */
  createdAt: Scalars['DateTime'];
  /** The ID of the customer associated with this document. */
  customerId: Scalars['String'];
  /** The expiry date of the claim code, in ISO 8601 format. */
  expiry?: Maybe<Scalars['DateTime']>;
  /** The groups associated with this document. */
  groups?: Maybe<Array<Scalars['String']>>;
  /** The unique identifier of the document. */
  id: Scalars['ID'];
  /** The name of the document. */
  name?: Maybe<Scalars['String']>;
  /** The ID of the organization associated with this document. */
  organizationId: Scalars['String'];
  /** The prefix for the claim code. */
  prefix?: Maybe<Scalars['String']>;
  /** The site associated with this document. */
  site?: Maybe<Scalars['String']>;
  /** The current state of the claim code. */
  state?: Maybe<MultiClaimCodeStatus>;
  /** The number of times the claim code has been used. */
  usageCount?: Maybe<Scalars['Int']>;
};

export enum MultiClaimCodeStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE'
}

export type MultiClaimFilters = {
  groupIds?: InputMaybe<Array<Scalars['String']>>;
  siteIds?: InputMaybe<Array<Scalars['String']>>;
  validity?: InputMaybe<Array<Scalars['String']>>;
};

export type MultiClaimSlotAvailableInput = {
  /** CustomerId for which check the slot availability for multiClaim code creation. */
  customerId: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Generate multi claim code for a customer
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Installer, SuperAdmin
   */
  activateMultiClaimCode: MultiClaimCodeDocument;
  /**
   * Creates an API key.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, SuperAdmin
   */
  apiKeyCreate: ApiKeyCreatePayload;
  /**
   * Revokes an API key.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, SuperAdmin
   */
  apiKeyRevoke: ApiKeyRevokePayload;
  /**
   * Assign configuration for a list of displays
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, Guest, Installer, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  assignConfiguration: Scalars['String'];
  /**
   * Mutation to Pair multiple ZTE enrolment to a customer
   * Requires any of the following roles: Owner, ServiceAdminZteFull, SuperAdminUserManagement, SuperAdmin
   */
  bulkPairZteEnrolmentToCustomer: ZteBulkEnrolmentPairPayload;
  /**
   * Mutation to unpair multiple ZTE enrolments
   * Requires any of the following roles: Owner, ServiceAdminZteFull, SuperAdminUserManagement, SuperAdmin
   */
  bulkUnpairZteEnrolments: ZteBulkUnpairPayload;
  /**
   * clone a display configuration from configuration id.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  cloneDisplayConfiguration: CloneConfigurationPayload;
  /**
   * Adds a group to a configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationAddGroup: ConfigurationModel;
  /**
   * Set the control state for the ports controls of the configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationBulkUpdatePortsControl: ConfigurationModel;
  /**
   * Deletes a group from a configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationDeleteGroup: ConfigurationModel;
  /**
   * Adds a group to a configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationRename: ConfigurationModel;
  /**
   * Updates the Android component of the firmware.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateAndroidFirmware: ConfigurationModel;
  /**
   * Changes the autoRestart of a configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateAutoRestart: ConfigurationModel;
  /**
   * Changes the battery power management state of a configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateBatteryPowerManagement: ConfigurationModel;
  /**
   * Changes the bookmarks on configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateBookmarksAll: ConfigurationModel;
  /**
   * Change the brightness for configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateBrightness: ConfigurationModel;
  /**
   * Change the autobrightness for configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateBrightnessV2: ConfigurationModel;
  /**
   * Changes the burn-in refresh schedule of a Tableau platform configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateBurnInRefresh: ConfigurationModel;
  /**
   * Changes the contentSourceApps on configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateContentSourceApps: ConfigurationModel;
  /**
   * Sets the default content source to an app. This is the app that will be selected whenever the display turns on.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateDefaultAppContentSource: ConfigurationModel;
  /**
   * Sets the default content source to a bookmark. This is the bookmark that will be selected whenever the display turns on.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateDefaultBookmarkContentSource: ConfigurationModel;
  /**
   * Sets the default content source to an input. This is the input that will be selected whenever the display turns on.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateDefaultInputContentSource: ConfigurationModel;
  /**
   * Sets the default content source to a playlist. This is the playlist that will be selected whenever the display turns on.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateDefaultPlaylistContentSource: ConfigurationModel;
  /**
   * Changes the firmware update flag state of configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateFirmwareToLatestFlag: ConfigurationModel;
  /**
   * Set the control state for the infra-red controls of the configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateInfraRedControl: ConfigurationModel;
  /**
   * Set the control state for the keyboard controls of the configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateKeyboardControl: ConfigurationModel;
  /**
   * Changes the color of the LED strip of a configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateLedStripColor: ConfigurationModel;
  /**
   * Changes the orientation of a configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateOrientation: ConfigurationModel;
  /**
   * Changes the playlist of a configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdatePlaylistContentSource: ConfigurationModel;
  /**
   * Changes the power state of a configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdatePower: ConfigurationModel;
  /**
   * Changes the power schedule of a configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdatePowerSchedule: ConfigurationModel;
  /**
   * Changes the schedule of a configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateSchedule: ConfigurationModel;
  /**
   * Set signal detection ON or OFF for a configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateSignalDetection: ConfigurationModel;
  /**
   * Updates the site of a configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateSite: ConfigurationModel;
  /**
   * Change the time zone for multiple displays
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateTimeZone: ConfigurationModel;
  /**
   * Changes the volume level of a configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateVolumeLevel: ConfigurationModel;
  /**
   * Changes the maximum volume limit of the configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateVolumeLimitMax: ConfigurationModel;
  /**
   * Changes the minimum volume limit of the configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateVolumeLimitMin: ConfigurationModel;
  /**
   * Changes the volume mute state of configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationUpdateVolumeMute: ConfigurationModel;
  /**
   * create a configuration and capture profile from the display
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  createDisplayConfiguration: ConfigurationModel;
  /**
   * Create a draft configuration from configuration id.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  createDraftConfiguration: ConfigurationModel;
  /**
   * Creates a new customer.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, SuperAdmin
   * @deprecated Use 'customerCreateNew' instead.
   */
  customerCreate: Customer;
  /**
   * Creates a new customer.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, SuperAdmin
   */
  customerCreateNew: Customer;
  /**
   * Deletes a customer.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, SuperAdmin
   */
  customerDelete: CustomerDeletePayload;
  /**
   * Updates a customer.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, SuperAdmin
   * @deprecated Use 'customerUpdateNew' instead.
   */
  customerUpdate: Customer;
  /**
   * Updates a customer.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, SuperAdmin
   */
  customerUpdateNew: Customer;
  /**
   * Approve or reject an admin access request received by the caller's own organization.
   * Requires any of the following roles: Owner, Admin, SuperAdmin
   */
  decideOrgAdminAccessRequest: ServiceAdminOrgAccessRequestDocument;
  /**
   * Delete configuration for a customer
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  deleteConfiguration: Scalars['String'];
  /**
   * Delete multi claim code for a customer
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Installer, SuperAdmin
   */
  deleteMultiClaimCode: Scalars['String'];
  /**
   * Aborts a job.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayAbortJob: DisplayAbortJobPayload;
  /**
   * Adds a group to a display.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayAddGroup: Display;
  /**
   * Resolves multiple alerts. The alerts will no longer be visible.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, SuperAdmin
   */
  displayAlertBulkResolve: DisplayAlertBulkResolvePayload;
  /**
   * Adds groups to a list of displays.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkAddGroups: DisplayBulkAddGroupsPayload;
  /**
   * Apply recommended power settings a list of displays
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkApplyRecommendedPowerSettings: DisplayBulkApplyRecommendedPowerSettingsPayload;
  /**
   * Apply recommended settings a list of displays
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkApplyRecommendedSettings: DisplayBulkApplyRecommendedSettingsPayload;
  /**
   * Clears the data of a list of displays. Data cleared includes bookmarks, playlists and screenshots.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkClearData: DisplayBulkClearDataPayload;
  /**
   * Reboot all the displays in a list.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkReboot: DisplayBulkRebootPayload;
  /**
   * Remove groups to a list of displays.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkRemoveGroups: DisplayBulkRemoveGroupsPayload;
  /**
   * Request an app installation / update for multiple displays
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, SuperAdmin
   */
  displayBulkRequestAppInstallation: DisplayBulkRequestAppInstallationPayload;
  /**
   * Set the agent release channel for the displays
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateAgentReleaseChannel: DisplayBulkUpdateAgentReleaseChannelPayload;
  /**
   * Updates the Android component of the firmware.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, ServiceAdminFirmwareFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateAndroidFirmware: DisplayBulkUpdateAndroidFirmwarePayload;
  /**
   * Changes the content source of a display between one of bookmarks, applications, playlists or display inputs.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateAppContentSource: DisplayBulkUpdateContentSourcePayload;
  /**
   * Changes the autoRestart of a display.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateAutoRestart: DisplayBulkUpdateAutoRestartPayload;
  /**
   * Changes the battery power management state of multiple displays.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateBatteryPowerManagement: DisplayBulkUpdateBatteryPowerManagementPayload;
  /**
   * Changes the content source of a display between one of bookmarks, applications, playlists or display inputs.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateBookmarkContentSource: DisplayBulkUpdateContentSourcePayload;
  /**
   * Change the bookmarks for a list of displays
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateBookmarksAll: DisplayBulkUpdateBookmarksAllPayload;
  /**
   * Change the brightness for a set of displays.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateBrightness: DisplayBulkUpdateBrightnessPayload;
  /**
   * Change the brightness for a set of displays.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateBrightnessV2: DisplayBulkUpdateBrightnessV2Payload;
  /**
   * Changes the burn-in refresh schedule of multiple displays. Tableau platform only.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateBurnInRefresh: DisplayBulkUpdateBurnInRefreshPayload;
  /**
   * Sets the default content source to an app. This is the app that will be selected whenever the display turns on.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateDefaultAppContentSource: DisplayBulkUpdateDefaultContentSourcePayload;
  /**
   * Sets the default content source to a bookmark. This is the bookmark that will be selected whenever the display turns on.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateDefaultBookmarkContentSource: DisplayBulkUpdateDefaultContentSourcePayload;
  /**
   * Sets the default content source to an input. This is the input that will be selected whenever the display turns on.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateDefaultInputContentSource: DisplayBulkUpdateDefaultContentSourcePayload;
  /**
   * Sets the default content source to a playlist. This is the playlist that will be selected whenever the display turns on.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateDefaultPlaylistContentSource: DisplayBulkUpdateDefaultContentSourcePayload;
  /**
   * Set the control state for the infra-red controls of the displays.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateInfraRedControl: DisplayBulkUpdateInfraRedControlPayload;
  /**
   * Changes the content source of a display between one of bookmarks, applications, playlists or display inputs.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateInputContentSource: DisplayBulkUpdateContentSourcePayload;
  /**
   * Set the control state for the keyboard controls of the displays.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateKeyboardControl: DisplayBulkUpdateKeyboardControlPayload;
  /**
   * Changes the color of the LED strip of a display.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateLedStripColor: DisplayBulkUpdateLedStripColorPayload;
  /**
   * Synchronizes a playlist for a set of displays.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdatePlaylist: DisplayBulkUpdatePlaylistPayload;
  /**
   * Changes the content source of a display between one of bookmarks, applications, playlists or display inputs.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdatePlaylistContentSource: DisplayBulkUpdateContentSourcePayload;
  /**
   * Set the control state for the ports controls of the displays.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdatePortsControl: DisplayBulkUpdatePortsControlPayload;
  /**
   * Change the power for a list of displays
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdatePower: DisplayBulkUpdatePowerPayload;
  /**
   * Synchronizes a power schedule for a set of displays.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdatePowerSchedule: DisplayBulkUpdatePowerSchedulePayload;
  /**
   * Assigns a schedule to a set of displays, or removes it when no schedule is given.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateSchedule: DisplayBulkUpdateSchedulePayload;
  /**
   * Set signal detection ON or OFF for a list of displays.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateSignalDetection: DisplayBulkUpdateSignalDetectionPayload;
  /**
   * Updates the site for a list of displays.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateSite: DisplayBulkUpdateSitePayload;
  /**
   * Change the time zone for multiple displays
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateTimeZone: DisplayBulkUpdateTimeZonePayload;
  /**
   * Change the mute value and the volume level, min, and max for a set of displays.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayBulkUpdateVolume: DisplayBulkUpdateVolumePayload;
  /**
   * Capture the screenshot of the display
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayCaptureScreenshot: DisplayCapturescreenshotPayload;
  /**
   * Claims a display to a customer.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Installer, SuperAdmin
   */
  displayClaim: DisplayClaimPayload;
  /**
   * Deletes a group from a display.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayDeleteGroup: Display;
  /**
   * Request an app installation for the display
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, SuperAdmin
   */
  displayRequestAppInstallation: DisplayRequestAppInstallationPayload;
  /**
   * Request an app uninstallation from the display
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, SuperAdmin
   */
  displayRequestAppUninstallation: DisplayRequestAppUninstallationPayload;
  /**
   * Retry an app installation for the display
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, SuperAdmin
   */
  displayRetryRequestAppInstallation: DisplayRetryRequestAppInstallationPayload;
  /**
   * Retry to remove an app installation from the display
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, SuperAdmin
   */
  displayRetryRequestAppUninstallation: DisplayRetryRequestAppUninstallationPayload;
  /**
   * Unclaims a display from a customer.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Installer, ServiceAdminDeviceService, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayUnclaim: DisplayUnclaimPayload;
  /**
   * Updates a display.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayUpdateAlias: Display;
  /**
   * Changes the autoRestart of a display.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayUpdateAutoRestart: DisplayUpdateAutoRestartPayload;
  /**
   * Changes the bookmarks configurations on the display.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayUpdateBookmarksAll: DisplayUpdateBookmarksAllPayload;
  /**
   * Changes the orientation of a display.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayUpdateOrientation: DisplayUpdateOrientationPayload;
  /**
   * Synchronizes a playlist with a display.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayUpdatePlaylist: DisplayUpdatePlaylistPayload;
  /**
   * Changes the power of a display.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayUpdatePower: DisplayUpdatePowerPayload;
  /**
   * Updates the site of a display.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayUpdateSite: Display;
  /**
   * Changes the volume level of a display.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayUpdateVolumeLevel: DisplayUpdateVolumeLevelPayload;
  /**
   * Changes the maximum volume limit of the display.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayUpdateVolumeLimitMax: DisplayUpdateVolumeLimitMaxPayload;
  /**
   * Changes the minimum volume limit of the display.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayUpdateVolumeLimitMin: DisplayUpdateVolumeLimitMinPayload;
  /**
   * Changes the volume mute state of a display.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayUpdateVolumeMute: DisplayUpdateVolumeMutePayload;
  /**
   * Request to upload a file to TP Vision's cloud storage.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, ServiceAdminOrgManagementFull, SuperAdminUserManagement, SuperAdmin
   */
  fileUploadRequest: FileUploadRequestPayload;
  /**
   * Updates the Android component of the firmware.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, ServiceAdminFirmwareFull, SuperAdminUserManagement, SuperAdmin
   */
  firmwareUpdateAndroid: FirmwareUpdateAndroidPayload;
  /**
   * Generate multi claim code for a customer
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Installer, SuperAdmin
   */
  generateMultiClaimCode: MultiClaimCodeDocument;
  /**
   * Creates a new group within a customer.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, SuperAdmin
   */
  groupCreate: GroupCreatePayload;
  /**
   * Request to upload media to the TP Vision's cloud storage.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, SuperAdmin
   */
  mediaCreateRequest: MediaCreateRequestPayload;
  /**
   * Updates media details.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, SuperAdmin
   */
  mediaUpdate: Array<Media>;
  /**
   * Updates notification emails for a customer.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, SuperAdmin
   */
  notificationEmailUpdate: NotificationSettingsModel;
  /**
   * Updates notification settings for a customer.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, SuperAdmin
   */
  notificationSettingsUpdate: NotificationSettingsModel;
  /**
   * Updates notification status for a customer.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, SuperAdmin
   */
  notificationStatusUpdate: NotificationSettingsModel;
  /**
   * Request time-bound elevated access to another organization.
   * Requires any of the following roles: ServiceAdminZteView, ServiceAdminZteFull, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, ServiceAdminFirmwareView, ServiceAdminFirmwareFull, ServiceAdminOrgManagementView, ServiceAdminOrgManagementFull, SuperAdminUserManagement, SuperAdmin
   */
  orgAccessRequestCreate: ServiceAdminOrgAccessRequestDocument;
  /**
   * Updates a organization.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, ServiceAdminOrgManagementFull, SuperAdminUserManagement, SuperAdmin
   */
  organizationUpdate: Organization;
  /**
   * Creates a new playlist for a customer.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, SuperAdmin
   */
  playlistCreate: PlaylistCreatePayload;
  /**
   * Duplicates a new playlist for a customer.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, SuperAdmin
   */
  playlistDuplicate: PlaylistDuplicatePayload;
  /**
   * Removes all displays from a playlist.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  playlistRemoveDisplays: PlaylistRemoveDisplaysPayload;
  /**
   * Synchronizes all displays for a playlist.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  playlistSyncDisplays: PlaylistSyncDisplaysPayload;
  /**
   * Mutation to update a playlist.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, SuperAdmin
   */
  playlistUpdate: PlaylistUpdatePayload;
  /**
   * Deletes the playlists.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, SuperAdmin
   */
  playlistsDelete: PlaylistsDeletePayload;
  /**
   * Creates a new power schedule for a customer.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, SuperAdmin
   */
  powerScheduleCreate: PowerScheduleCreatePayload;
  /**
   * Removes all displays from a power schedule.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  powerScheduleRemoveDisplays: PowerScheduleRemoveDisplaysPayload;
  /**
   * Synchronizes all displays for a power schedule.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  powerScheduleSyncDisplays: PowerScheduleSyncDisplaysPayload;
  /**
   * Updates a power schedule.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, SuperAdmin
   */
  powerScheduleUpdate: PowerScheduleUpdatePayload;
  /**
   * Deletes the power schedules.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, SuperAdmin
   */
  powerSchedulesDelete: PowerSchedulesDeletePayload;
  /**
   * publish a configuration from configuration id.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  publishConfiguration: PublishConfigurationPayload;
  /**
   * Revoke an approved, unexpired admin access request received by the caller's own organization. The request becomes REVOKED and the admin loses access immediately.
   * Requires any of the following roles: Owner, Admin, SuperAdmin
   */
  revokeOrgAdminAccessRequest: ServiceAdminOrgAccessRequestDocument;
  /**
   * Creates a new schedule for a customer.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, SuperAdmin
   */
  scheduleCreate: ScheduleCreatePayload;
  /**
   * Duplicates an existing schedule, including all of its time slots.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, SuperAdmin
   */
  scheduleDuplicate: ScheduleDuplicatePayload;
  /**
   * Removes a schedule from all the displays currently holding it.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  scheduleRemoveDisplays: ScheduleRemoveDisplaysPayload;
  /**
   * Synchronizes all displays for a schedule.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  scheduleSyncDisplays: ScheduleSyncDisplaysPayload;
  /**
   * Updates a schedule.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, SuperAdmin
   */
  scheduleUpdate: ScheduleUpdatePayload;
  /**
   * Deletes the schedules.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, SuperAdmin
   */
  schedulesDelete: SchedulesDeletePayload;
  /** Sends password reset link to user email. */
  selfChangePwd: ChangePasswordStatus;
  /** Updates self user profile. */
  selfProfileUpdate: SelfProfileUpdatePayload;
  /**
   * Delete a device log capture request. A still-running request is first driven through Stopping/Stopped before it and its S3 object are actually removed — see `deleted` on the response.
   * Requires any of the following roles: ServiceAdminZteFull, ServiceAdminDeviceService, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  serviceAdminDeleteDeviceLogs: ServiceAdminDeviceLogDeletePayload;
  /**
   * Start a duration-bound debug log capture on a device.
   * Requires any of the following roles: ServiceAdminZteFull, ServiceAdminDeviceService, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  serviceAdminEnableDeviceLogs: ServiceAdminDeviceLog;
  /**
   * Stop an in-progress device log capture request.
   * Requires any of the following roles: ServiceAdminZteFull, ServiceAdminDeviceService, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  serviceAdminStopDeviceLogs: ServiceAdminDeviceLog;
  /**
   * Global Search: enables or disables ProStore developer access for any organization that's connected to ProStore — the same toggle the admin portal offers.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, ServiceAdminOrgManagementFull, SuperAdminUserManagement, SuperAdmin
   */
  serviceAdminToggleProStoreDeveloperAccess: Scalars['Boolean'];
  /**
   * Global Search: invites a new user into any organization, without an access grant for it.
   * Requires any of the following roles: SuperAdminUserManagement, SuperAdmin
   */
  serviceAdminUserCreate: User;
  /**
   * Global Search: deletes any organization's user, the Owner included, without an access grant for that organization. They will not be able to login anymore with their credentials.
   * Requires any of the following roles: SuperAdminUserManagement, SuperAdmin
   */
  serviceAdminUserDelete: UserDeletePayload;
  /**
   * Global Search: re-sends the invitation e-mail to a user of any organization who has not signed in yet.
   * Requires any of the following roles: SuperAdminUserManagement, SuperAdmin
   */
  serviceAdminUserResendInvite: Scalars['Boolean'];
  /**
   * Global Search: updates any organization's user's email and organization roles, without an access grant for that organization. Changing the email sends an invitation email to the new address. An organization can only have one Owner.
   * Requires any of the following roles: SuperAdminUserManagement, SuperAdmin
   */
  serviceAdminUserUpdate: User;
  /**
   * Creates a site.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, SuperAdmin
   */
  siteCreate: SiteCreatePayload;
  /**
   * Deletes a site.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, SuperAdmin
   */
  siteDelete: SiteDeletePayload;
  /**
   * Updates a site.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, SuperAdmin
   */
  siteUpdate: Site;
  /**
   * Register a new domain for the organization
   * Requires any of the following roles: Owner, SuperAdmin
   */
  ssoDomainCreate: Sso;
  /**
   * Deletes an existing SSO domain for the organization.
   * Requires any of the following roles: Owner, SuperAdmin
   */
  ssoDomainDelete: Scalars['Boolean'];
  /**
   * Publish SSO OIDC provider configuration
   * Requires any of the following roles: Owner, SuperAdmin
   */
  ssoProviderOidcPublish: Sso;
  /**
   * Upsert a new OIDC SSO provider configuration
   * Requires any of the following roles: Owner, SuperAdmin
   */
  ssoProviderOidcUpsert: OidcProvider;
  /**
   * Generates an entityId for a SAML SSO provider.
   * Requires any of the following roles: Owner, SuperAdmin
   */
  ssoProviderSamlGenerateEntityId: Sso;
  /**
   * Publish SSO SAML provider configuration
   * Requires any of the following roles: Owner, SuperAdmin
   */
  ssoProviderSamlPublish: Sso;
  /**
   * Upsert a new SAML SSO provider configuration
   * Requires any of the following roles: Owner, SuperAdmin
   */
  ssoProviderSamlUpsert: SamlProvider;
  /**
   * Revalidate an SSO session
   * Requires any of the following roles: Owner, SuperAdmin
   */
  ssoRevalidate: Scalars['Boolean'];
  /**
   * Sync configuration for all displays
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, Guest, Installer, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  syncAllDisplaysToConfiguration: Scalars['String'];
  /**
   * Unassign configuration for a list of displays
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  unassignConfiguration: Scalars['String'];
  /**
   * Update a customer default configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Operator, SuperAdmin
   */
  updateCustomerDefaultConfiguration: DefaultConfiguration;
  /**
   * Updates a subscription.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, SuperAdmin
   */
  updateSubscription: WaveSubscription;
  /**
   * Updates a subscription name.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, SuperAdmin
   */
  updateSubscriptionName: WaveSubscription;
  /**
   * Creates a new user for the organization of the current user.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, SuperAdminUserManagement, SuperAdmin
   */
  userCreate: User;
  /**
   * Deletes a user from the organization. They will also not be able to login anymore with their credentials.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, SuperAdminUserManagement, SuperAdmin
   */
  userDelete: UserDeletePayload;
  /**
   * Updates a user.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, SuperAdminUserManagement, SuperAdmin
   */
  userUpdate: UserUpdatePayload;
};


export type MutationActivateMultiClaimCodeArgs = {
  input: ActivateMultiClaimCodeInput;
};


export type MutationApiKeyCreateArgs = {
  input: ApiKeyCreateInput;
};


export type MutationApiKeyRevokeArgs = {
  input: ApiKeyRevokeInput;
};


export type MutationAssignConfigurationArgs = {
  input: DisplayBulkAssignConfigurationsInput;
};


export type MutationBulkPairZteEnrolmentToCustomerArgs = {
  input: ZteBulkEnrolmentPairInput;
};


export type MutationBulkUnpairZteEnrolmentsArgs = {
  input: ZteBulkUnpairInput;
};


export type MutationCloneDisplayConfigurationArgs = {
  configurationId: Scalars['String'];
  customerId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};


export type MutationConfigurationAddGroupArgs = {
  input: ConfigurationAddGroupInput;
};


export type MutationConfigurationBulkUpdatePortsControlArgs = {
  input: ConfigurationUpdatePortsControlInput;
};


export type MutationConfigurationDeleteGroupArgs = {
  input: ConfigurationDeleteGroupInput;
};


export type MutationConfigurationRenameArgs = {
  input: ConfigurationRenameInput;
};


export type MutationConfigurationUpdateAndroidFirmwareArgs = {
  input: ConfigurationUpdateAndroidFirmwareInput;
};


export type MutationConfigurationUpdateAutoRestartArgs = {
  input: ConfigurationUpdateAutoRestartInput;
};


export type MutationConfigurationUpdateBatteryPowerManagementArgs = {
  input: ConfigurationUpdateBatteryPowerManagementInput;
};


export type MutationConfigurationUpdateBookmarksAllArgs = {
  input: ConfigurationUpdateBookmarksAllInput;
};


export type MutationConfigurationUpdateBrightnessArgs = {
  input: ConfigurationUpdateBrightnessInput;
};


export type MutationConfigurationUpdateBrightnessV2Args = {
  input: ConfigurationUpdateBrightnessV2Input;
};


export type MutationConfigurationUpdateBurnInRefreshArgs = {
  input: ConfigurationUpdateBurnInRefreshInput;
};


export type MutationConfigurationUpdateContentSourceAppsArgs = {
  input: ConfigurationUpdateContentSourceAppsInput;
};


export type MutationConfigurationUpdateDefaultAppContentSourceArgs = {
  input: ConfigurationUpdateDefaultAppContentSourceInput;
};


export type MutationConfigurationUpdateDefaultBookmarkContentSourceArgs = {
  input: ConfigurationUpdateDefaultBookmarkContentSourceInput;
};


export type MutationConfigurationUpdateDefaultInputContentSourceArgs = {
  input: ConfigurationUpdateDefaultInputContentSourceInput;
};


export type MutationConfigurationUpdateDefaultPlaylistContentSourceArgs = {
  input: ConfigurationUpdateDefaultPlaylistContentSourceInput;
};


export type MutationConfigurationUpdateFirmwareToLatestFlagArgs = {
  input: ShouldUpdateToLatestFirmwareInput;
};


export type MutationConfigurationUpdateInfraRedControlArgs = {
  input: ConfigurationUpdateInfraRedControlInput;
};


export type MutationConfigurationUpdateKeyboardControlArgs = {
  input: ConfigurationUpdateKeyboardControlInput;
};


export type MutationConfigurationUpdateLedStripColorArgs = {
  input: ConfigurationUpdateLedStripColorInput;
};


export type MutationConfigurationUpdateOrientationArgs = {
  input: ConfigurationUpdateOrientationInput;
};


export type MutationConfigurationUpdatePlaylistContentSourceArgs = {
  input: ConfigurationUpdatePlaylistContentSourceInput;
};


export type MutationConfigurationUpdatePowerArgs = {
  input: ConfigurationUpdatePowerInput;
};


export type MutationConfigurationUpdatePowerScheduleArgs = {
  input: ConfigurationUpdatePowerScheduleInput;
};


export type MutationConfigurationUpdateScheduleArgs = {
  input: ConfigurationUpdateScheduleInput;
};


export type MutationConfigurationUpdateSignalDetectionArgs = {
  input: ConfigurationUpdateSignalDetectionInput;
};


export type MutationConfigurationUpdateSiteArgs = {
  input: ConfigurationUpdateSiteInput;
};


export type MutationConfigurationUpdateTimeZoneArgs = {
  input: ConfigurationUpdateTimeZoneInput;
};


export type MutationConfigurationUpdateVolumeLevelArgs = {
  input: ConfigurationUpdateVolumeLevelInput;
};


export type MutationConfigurationUpdateVolumeLimitMaxArgs = {
  input: ConfigurationUpdateVolumeLimitMaxInput;
};


export type MutationConfigurationUpdateVolumeLimitMinArgs = {
  input: ConfigurationUpdateVolumeLimitMinInput;
};


export type MutationConfigurationUpdateVolumeMuteArgs = {
  input: ConfigurationUpdateVolumeMuteInput;
};


export type MutationCreateDisplayConfigurationArgs = {
  input: CreateConfigurationInput;
};


export type MutationCreateDraftConfigurationArgs = {
  configurationId: Scalars['String'];
};


export type MutationCustomerCreateArgs = {
  input: CustomerCreateInput;
};


export type MutationCustomerCreateNewArgs = {
  input: CustomerCreateInputV2;
};


export type MutationCustomerDeleteArgs = {
  input: CustomerDeleteInput;
};


export type MutationCustomerUpdateArgs = {
  input: CustomerUpdateInput;
};


export type MutationCustomerUpdateNewArgs = {
  input: CustomerUpdateInputNew;
};


export type MutationDecideOrgAdminAccessRequestArgs = {
  decision: ServiceAdminOrgAccessRequestDecision;
  id: Scalars['ID'];
};


export type MutationDeleteConfigurationArgs = {
  input: DeleteConfigurationsInput;
};


export type MutationDeleteMultiClaimCodeArgs = {
  input: DeleteMultiClaimCodeInput;
};


export type MutationDisplayAbortJobArgs = {
  input: DisplayAbortJobInput;
};


export type MutationDisplayAddGroupArgs = {
  input: DisplayAddGroupInput;
};


export type MutationDisplayAlertBulkResolveArgs = {
  input: DisplayAlertBulkResolveInput;
};


export type MutationDisplayBulkAddGroupsArgs = {
  input: DisplayBulkAddGroupsInput;
};


export type MutationDisplayBulkApplyRecommendedPowerSettingsArgs = {
  input: DisplayBulkApplyRecommendedPowerSettingsInput;
};


export type MutationDisplayBulkApplyRecommendedSettingsArgs = {
  input: DisplayBulkApplyRecommendedSettingsInput;
};


export type MutationDisplayBulkClearDataArgs = {
  input: DisplayBulkClearDataInput;
};


export type MutationDisplayBulkRebootArgs = {
  input: DisplayBulkRebootInput;
};


export type MutationDisplayBulkRemoveGroupsArgs = {
  input: DisplayBulkRemoveGroupsInput;
};


export type MutationDisplayBulkRequestAppInstallationArgs = {
  input: DisplayBulkRequestAppInstallationInput;
};


export type MutationDisplayBulkUpdateAgentReleaseChannelArgs = {
  input: DisplayBulkUpdateAgentReleaseChannelInput;
};


export type MutationDisplayBulkUpdateAndroidFirmwareArgs = {
  input: DisplayBulkUpdateAndroidFirmwareInput;
};


export type MutationDisplayBulkUpdateAppContentSourceArgs = {
  input: DisplayBulkUpdateAppContentSourceInput;
};


export type MutationDisplayBulkUpdateAutoRestartArgs = {
  input: DisplayBulkUpdateAutoRestartInput;
};


export type MutationDisplayBulkUpdateBatteryPowerManagementArgs = {
  input: DisplayBulkUpdateBatteryPowerManagementInput;
};


export type MutationDisplayBulkUpdateBookmarkContentSourceArgs = {
  input: DisplayBulkUpdateBookmarkContentSourceInput;
};


export type MutationDisplayBulkUpdateBookmarksAllArgs = {
  input: DisplayBulkUpdateBookmarksAllInput;
};


export type MutationDisplayBulkUpdateBrightnessArgs = {
  input: DisplayBulkUpdateBrightnessInput;
};


export type MutationDisplayBulkUpdateBrightnessV2Args = {
  input: DisplayBulkUpdateBrightnessV2Input;
};


export type MutationDisplayBulkUpdateBurnInRefreshArgs = {
  input: DisplayBulkUpdateBurnInRefreshInput;
};


export type MutationDisplayBulkUpdateDefaultAppContentSourceArgs = {
  input: DisplayBulkUpdateDefaultAppContentSourceInput;
};


export type MutationDisplayBulkUpdateDefaultBookmarkContentSourceArgs = {
  input: DisplayBulkUpdateDefaultBookmarkContentSourceInput;
};


export type MutationDisplayBulkUpdateDefaultInputContentSourceArgs = {
  input: DisplayBulkUpdateDefaultInputContentSourceInput;
};


export type MutationDisplayBulkUpdateDefaultPlaylistContentSourceArgs = {
  input: DisplayBulkUpdateDefaultPlaylistContentSourceInput;
};


export type MutationDisplayBulkUpdateInfraRedControlArgs = {
  input: DisplayBulkUpdateInfraRedControlInput;
};


export type MutationDisplayBulkUpdateInputContentSourceArgs = {
  input: DisplayBulkUpdateInputContentSourceInput;
};


export type MutationDisplayBulkUpdateKeyboardControlArgs = {
  input: DisplayBulkUpdateKeyboardControlInput;
};


export type MutationDisplayBulkUpdateLedStripColorArgs = {
  input: DisplayBulkUpdateLedStripColorInput;
};


export type MutationDisplayBulkUpdatePlaylistArgs = {
  input: DisplayBulkUpdatePlaylistInput;
};


export type MutationDisplayBulkUpdatePlaylistContentSourceArgs = {
  input: DisplayBulkUpdatePlaylistContentSourceInput;
};


export type MutationDisplayBulkUpdatePortsControlArgs = {
  input: DisplayBulkUpdatePortsControlInput;
};


export type MutationDisplayBulkUpdatePowerArgs = {
  input: DisplayBulkUpdatePowerInput;
};


export type MutationDisplayBulkUpdatePowerScheduleArgs = {
  input: DisplayBulkUpdatePowerScheduleInput;
};


export type MutationDisplayBulkUpdateScheduleArgs = {
  input: DisplayBulkUpdateScheduleInput;
};


export type MutationDisplayBulkUpdateSignalDetectionArgs = {
  input: DisplayBulkUpdateSignalDetectionInput;
};


export type MutationDisplayBulkUpdateSiteArgs = {
  input: DisplayBulkUpdateSiteInput;
};


export type MutationDisplayBulkUpdateTimeZoneArgs = {
  input: DisplayBulkUpdateTimeZoneInput;
};


export type MutationDisplayBulkUpdateVolumeArgs = {
  input: DisplayBulkUpdateVolumeInput;
};


export type MutationDisplayCaptureScreenshotArgs = {
  input: DisplayCaptureScreenshotInput;
};


export type MutationDisplayClaimArgs = {
  input: DisplayClaimInput;
};


export type MutationDisplayDeleteGroupArgs = {
  input: DisplayDeleteGroupInput;
};


export type MutationDisplayRequestAppInstallationArgs = {
  input: DisplayRequestAppInstallationInput;
};


export type MutationDisplayRequestAppUninstallationArgs = {
  input: DisplayRequestAppUninstallationInput;
};


export type MutationDisplayRetryRequestAppInstallationArgs = {
  input: DisplayRetryRequestAppInstallationInput;
};


export type MutationDisplayRetryRequestAppUninstallationArgs = {
  input: DisplayRetryRequestAppUninstallationInput;
};


export type MutationDisplayUnclaimArgs = {
  input: DisplayUnclaimInput;
};


export type MutationDisplayUpdateAliasArgs = {
  input: DisplayUpdateAliasInput;
};


export type MutationDisplayUpdateAutoRestartArgs = {
  input: DisplayUpdateAutoRestartInput;
};


export type MutationDisplayUpdateBookmarksAllArgs = {
  input: DisplayUpdateBookmarksAllInput;
};


export type MutationDisplayUpdateOrientationArgs = {
  input: DisplayUpdateOrientationInput;
};


export type MutationDisplayUpdatePlaylistArgs = {
  input: DisplayUpdatePlaylistInput;
};


export type MutationDisplayUpdatePowerArgs = {
  input: DisplayUpdatePowerInput;
};


export type MutationDisplayUpdateSiteArgs = {
  input: DisplayUpdateSiteInput;
};


export type MutationDisplayUpdateVolumeLevelArgs = {
  input: DisplayUpdateVolumeLevelInput;
};


export type MutationDisplayUpdateVolumeLimitMaxArgs = {
  input: DisplayUpdateVolumeLimitMaxInput;
};


export type MutationDisplayUpdateVolumeLimitMinArgs = {
  input: DisplayUpdateVolumeLimitMinInput;
};


export type MutationDisplayUpdateVolumeMuteArgs = {
  input: DisplayUpdateVolumeMuteInput;
};


export type MutationFileUploadRequestArgs = {
  input: FileUploadRequestInput;
};


export type MutationFirmwareUpdateAndroidArgs = {
  input: FirmwareUpdateAndroidInput;
};


export type MutationGenerateMultiClaimCodeArgs = {
  input: GenerateMultiClaimCodeInput;
};


export type MutationGroupCreateArgs = {
  input: GroupCreateInput;
};


export type MutationMediaCreateRequestArgs = {
  input: MediaCreateRequestInput;
};


export type MutationMediaUpdateArgs = {
  input: MediaUpdateInput;
};


export type MutationNotificationEmailUpdateArgs = {
  input: NotificationEmailInput;
};


export type MutationNotificationSettingsUpdateArgs = {
  input: NotificationInput;
};


export type MutationNotificationStatusUpdateArgs = {
  input: NotificationStatusInput;
};


export type MutationOrgAccessRequestCreateArgs = {
  durationMinutes: Scalars['Int'];
  orgId: Scalars['ID'];
};


export type MutationOrganizationUpdateArgs = {
  input: OrganizationUpdateInput;
};


export type MutationPlaylistCreateArgs = {
  input: PlaylistCreateInput;
};


export type MutationPlaylistDuplicateArgs = {
  input: PlaylistDuplicateInput;
};


export type MutationPlaylistRemoveDisplaysArgs = {
  input: PlaylistRemoveDisplaysInput;
};


export type MutationPlaylistSyncDisplaysArgs = {
  input: PlaylistSyncDisplaysInput;
};


export type MutationPlaylistUpdateArgs = {
  input: PlaylistUpdateInput;
};


export type MutationPlaylistsDeleteArgs = {
  input: PlaylistsDeleteInput;
};


export type MutationPowerScheduleCreateArgs = {
  input: PowerScheduleCreateInput;
};


export type MutationPowerScheduleRemoveDisplaysArgs = {
  input: PowerScheduleRemoveDisplaysInput;
};


export type MutationPowerScheduleSyncDisplaysArgs = {
  input: PowerScheduleSyncDisplaysInput;
};


export type MutationPowerScheduleUpdateArgs = {
  input: PowerScheduleUpdateInput;
};


export type MutationPowerSchedulesDeleteArgs = {
  input: PowerSchedulesDeleteInput;
};


export type MutationPublishConfigurationArgs = {
  configurationId: Scalars['String'];
};


export type MutationRevokeOrgAdminAccessRequestArgs = {
  id: Scalars['ID'];
};


export type MutationScheduleCreateArgs = {
  input: ScheduleCreateInput;
};


export type MutationScheduleDuplicateArgs = {
  input: ScheduleDuplicateInput;
};


export type MutationScheduleRemoveDisplaysArgs = {
  input: ScheduleRemoveDisplaysInput;
};


export type MutationScheduleSyncDisplaysArgs = {
  input: ScheduleSyncDisplaysInput;
};


export type MutationScheduleUpdateArgs = {
  input: ScheduleUpdateInput;
};


export type MutationSchedulesDeleteArgs = {
  input: SchedulesDeleteInput;
};


export type MutationSelfProfileUpdateArgs = {
  input: SelfProfileUpdateInput;
};


export type MutationServiceAdminDeleteDeviceLogsArgs = {
  id: Scalars['ID'];
};


export type MutationServiceAdminEnableDeviceLogsArgs = {
  deviceId: Scalars['ID'];
  durationDays: Scalars['Int'];
  durationHours: Scalars['Int'];
};


export type MutationServiceAdminStopDeviceLogsArgs = {
  id: Scalars['ID'];
};


export type MutationServiceAdminToggleProStoreDeveloperAccessArgs = {
  enabled: Scalars['Boolean'];
  organizationId: Scalars['ID'];
};


export type MutationServiceAdminUserCreateArgs = {
  input: ServiceAdminUserCreateInput;
  organizationId: Scalars['ID'];
};


export type MutationServiceAdminUserDeleteArgs = {
  userId: Scalars['ID'];
};


export type MutationServiceAdminUserResendInviteArgs = {
  userId: Scalars['ID'];
};


export type MutationServiceAdminUserUpdateArgs = {
  input: ServiceAdminUserUpdateInput;
};


export type MutationSiteCreateArgs = {
  input: SiteCreateInput;
};


export type MutationSiteDeleteArgs = {
  input: SiteDeleteInput;
};


export type MutationSiteUpdateArgs = {
  input: SiteUpdateInput;
};


export type MutationSsoDomainCreateArgs = {
  input: SsoDomainCreateInput;
};


export type MutationSsoDomainDeleteArgs = {
  input: SsoDomainDeleteInput;
};


export type MutationSsoProviderOidcPublishArgs = {
  input: SsoProviderOidcPublishInput;
};


export type MutationSsoProviderOidcUpsertArgs = {
  input: SsoProviderOidcUpsertInput;
};


export type MutationSsoProviderSamlGenerateEntityIdArgs = {
  input: SsoProviderSamlGenerateEntityIdInput;
};


export type MutationSsoProviderSamlPublishArgs = {
  input: SsoProviderSamlPublishInput;
};


export type MutationSsoProviderSamlUpsertArgs = {
  input: SsoProviderSamlUpsertInput;
};


export type MutationSsoRevalidateArgs = {
  input: SsoRevalidateInput;
};


export type MutationSyncAllDisplaysToConfigurationArgs = {
  input: DisplayBulkSyncConfigurationsInput;
};


export type MutationUnassignConfigurationArgs = {
  input: DisplayBulkUnassignConfigurationsInput;
};


export type MutationUpdateCustomerDefaultConfigurationArgs = {
  input: UpdateDefaultConfigurationInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: SubscriptionUpdateInput;
};


export type MutationUpdateSubscriptionNameArgs = {
  input: SubscriptionNameUpdateInput;
};


export type MutationUserCreateArgs = {
  input: UserCreateInput;
};


export type MutationUserDeleteArgs = {
  input: UserDeleteInput;
};


export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
};

export type NetworkInterface = {
  __typename?: 'NetworkInterface';
  /** Indicates if it is the active network interface. */
  active: Scalars['Boolean'];
  /** The IP address of the network interface. */
  ip?: Maybe<Scalars['String']>;
  /** The MAC address of the network interface. */
  mac: Scalars['String'];
  /** The name of the network interface. */
  name: Scalars['String'];
  /** The SSID (name) of the Wi-Fi network when active. */
  ssid?: Maybe<Scalars['String']>;
};

export enum NetworkType {
  Ethernet = 'ETHERNET',
  Other = 'OTHER',
  Wifi = 'WIFI'
}

export enum NotificationAlertType {
  Daily = 'DAILY',
  DoNotAlert = 'DO_NOT_ALERT',
  ImmediateAndOnce = 'IMMEDIATE_AND_ONCE',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type NotificationEmailInput = {
  /** List of email addresses to send notifications to. */
  emailAddresses: Array<Scalars['String']>;
  /** The identifier of the notification. */
  id: Scalars['String'];
};

export type NotificationInput = {
  /** The identifier of the customer. */
  customerId: Scalars['String'];
  /** List of notification settings. */
  settings?: InputMaybe<Array<NotificationItemInput>>;
  status: NotificationStatus;
};

export type NotificationItem = {
  __typename?: 'NotificationItem';
  alertType: NotificationAlertType;
  notificationType: NotificationType;
  reminderType: NotificationReminderType;
  status: NotificationStatus;
};

export type NotificationItemInput = {
  alertType: NotificationAlertType;
  notificationType: NotificationType;
  reminderType: NotificationReminderType;
  status: NotificationStatus;
};

export enum NotificationReminderType {
  Daily = 'DAILY',
  DoNotRemind = 'DO_NOT_REMIND',
  Weekly = 'WEEKLY'
}

export type NotificationSettingsModel = {
  __typename?: 'NotificationSettingsModel';
  /** Timestamp when the notification settings were created. */
  createdAt: Scalars['DateTime'];
  /** The ID of the customer associated with these notification settings. */
  customerId: Scalars['String'];
  /** List of email addresses to send notifications to. */
  emailAddresses: Array<Scalars['String']>;
  /** The unique identifier for the notification settings. */
  id: Scalars['ID'];
  /** The notification settings details. */
  settings: Array<NotificationItem>;
  /** The status of the notification settings. */
  status: NotificationStatus;
  /** Timestamp when the notification settings were last updated. */
  updatedAt: Scalars['DateTime'];
};

export enum NotificationStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type NotificationStatusInput = {
  /** The identifier of the customer. */
  customerId: Scalars['String'];
  status: NotificationStatus;
};

export enum NotificationType {
  Battery = 'battery',
  BootOnSourceFailure = 'bootOnSourceFailure',
  ConfigurationOutOfSync = 'configurationOutOfSync',
  FirmwareUpdate = 'firmwareUpdate',
  IrRemoteUnlocked = 'irRemoteUnlocked',
  KeypadUnlocked = 'keypadUnlocked',
  NetworkDisconnected = 'networkDisconnected',
  SchedulerOutOfSync = 'schedulerOutOfSync',
  Temperature = 'temperature',
  UsbPortUnlocked = 'usbPortUnlocked'
}

/** Options specific to SSO OIDC */
export type OidcOptions = {
  __typename?: 'OidcOptions';
  /** OIDC authorization endpoint URL */
  authorizationEndpoint?: Maybe<Scalars['String']>;
  /** OIDC client identifier */
  clientId?: Maybe<Scalars['String']>;
  /** OIDC client secret (masked for security) */
  clientSecret?: Maybe<Scalars['String']>;
  /** OIDC discovery URL */
  discoveryUrl?: Maybe<Scalars['String']>;
  /** OIDC issuer URL */
  issuer?: Maybe<Scalars['String']>;
  /** OIDC JWKS URI */
  jwksUri?: Maybe<Scalars['String']>;
};

/** Represents an OIDC SSO provider configuration */
export type OidcProvider = SsoProviderInterface & {
  __typename?: 'OidcProvider';
  /** Display name for the SSO provider */
  displayName?: Maybe<Scalars['String']>;
  /** OIDC specific options */
  options: OidcOptions;
  /** The SSO provider strategy type */
  strategy: SsoProviderStrategy;
  /** Validation status of the SSO provider */
  validationStatus?: Maybe<SsoValidationStatus>;
};

export type Organization = {
  __typename?: 'Organization';
  /** Subscriptions that are available to the organization. */
  appSubscriptions: Array<OrganizationAppSubscription>;
  /** The avatar's URL of the the organization. */
  avatarUrl?: Maybe<Scalars['String']>;
  /** All customers of this organization. */
  customers: Array<Customer>;
  /** If developer access is enabled for this organization. */
  developerAccess: Scalars['Boolean'];
  displayAlerts: Array<DisplayAlert>;
  /** A human- and URL-friendly identifier of the organization. */
  handle: Scalars['String'];
  /** The identifier of the organization. */
  id: Scalars['ID'];
  /** The name of the organization. */
  name: Scalars['String'];
  /**
   * SSO configurations for the organization.
   * Requires any of the following roles: Owner, SuperAdmin
   */
  ssos: Array<Sso>;
  /** All users associated with this organization. */
  users: Array<User>;
  /** Wave Subscriptions that are available to the organization. */
  waveSubscriptions?: Maybe<Array<WaveSubscription>>;
};


export type OrganizationSsosArgs = {
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type OrganizationWaveSubscriptionsArgs = {
  isAssignable?: InputMaybe<Scalars['Boolean']>;
};

export type OrganizationAppSubscription = {
  __typename?: 'OrganizationAppSubscription';
  /** The available app versions for this subscription. */
  appVersions: Array<Scalars['String']>;
  /** The id of the application, as the display refers to it. */
  applicationId: Scalars['String'];
  /** The date that this subscription was created. */
  createdAt: Scalars['DateTime'];
  /** The displays with an installation of this subscription. */
  displays: Array<Display>;
  /** The url of the app icon of this subscription */
  iconUrl?: Maybe<Scalars['String']>;
  /** The identifier of this subscription */
  id: Scalars['ID'];
  /** The name of this subscription. */
  name: Scalars['String'];
  /** The date that this subscription was last updated. */
  updatedAt: Scalars['DateTime'];
  /** The current usage of the subscription. */
  usage: SubscriptionUsage;
};

export type OrganizationUpdateInput = {
  /** The avatar URL of the organization. */
  avatarUrl?: InputMaybe<Scalars['String']>;
};

export enum Orientation {
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT',
  PortraitAnticlock = 'PORTRAIT_ANTICLOCK'
}

export type OrientationState = {
  __typename?: 'OrientationState';
  /** The newly desired orientation state of the display. Cleared when successful, failed or timed out. */
  desired?: Maybe<Orientation>;
  /** The last reported orientation of the display. */
  reported: Orientation;
  /** The supported values for the orientation state of the display. */
  supportedValues: Array<Orientation>;
};

export type PartialCustomer = {
  __typename?: 'PartialCustomer';
  /** Amount of displays the customer has claimed. */
  displayCount: Scalars['Int'];
  /** Usage statistics for all displays associated with this customer. */
  displayUsage?: Maybe<UsageStatistics>;
  /** The identifier of the customer. */
  id: Scalars['ID'];
  /** The name of the customer. */
  name: Scalars['String'];
  /**
   * Wave Subscription the customer is linked to.
   * @deprecated Use waveSubscriptions instead.
   */
  waveSubscription?: Maybe<WaveSubscription>;
  /** Wave Subscriptions the customer is linked to. */
  waveSubscriptions?: Maybe<Array<WaveSubscription>>;
};

export type Playlist = {
  __typename?: 'Playlist';
  /** The configurations currently holding a reference to this playlist. */
  configurations: Array<ConfigurationModel>;
  /** The date when the playlist was created. */
  createdAt: Scalars['DateTime'];
  /** Default duration for the playlist. */
  defaultDuration: Scalars['Int'];
  /** The description of the playlist. */
  description?: Maybe<Scalars['String']>;
  /** The displays currently holding a reference to this playlist. */
  displays: Array<Display>;
  /** The identifier of the playlist. */
  id: Scalars['ID'];
  /** Is playlist used by any configuration. */
  isPlaylistUsedByAnyConfiguration: Scalars['Boolean'];
  /** Is playlist used by any schedule. */
  isPlaylistUsedByAnySchedule: Scalars['Boolean'];
  /** The list comprised only of uploaded media associated with the playlist. */
  media: Array<Media>;
  playlistType: PlaylistType;
  /** The total size of the playlist. */
  size: Scalars['BigInt'];
  /** The title of the playlist. */
  title: Scalars['String'];
};


export type PlaylistDisplaysArgs = {
  filter?: InputMaybe<PlaylistDisplayFilter>;
};

export type PlaylistContentSource = {
  __typename?: 'PlaylistContentSource';
  /** The id of the playlist. */
  playlistId: Scalars['ID'];
  /** The title of the playlist. */
  title?: Maybe<Scalars['String']>;
};

export type PlaylistCreateInput = {
  /** The ID of the customer. */
  customerId: Scalars['ID'];
  /** Default duration for the playlist. */
  defaultDuration?: InputMaybe<Scalars['Int']>;
  /** The description of the playlist. */
  description?: InputMaybe<Scalars['String']>;
  /** The media IDs of the media that will be part of the playlist. */
  mediaIds?: InputMaybe<Array<Scalars['ID']>>;
  playlistType?: InputMaybe<PlaylistType>;
  /** The playlist title. */
  title: Scalars['String'];
};

export type PlaylistCreatePayload = {
  __typename?: 'PlaylistCreatePayload';
  /** The playlist that was created.  */
  playlist: Playlist;
};

export type PlaylistDisplayFilter = {
  state?: InputMaybe<PlaylistDisplayState>;
};

export enum PlaylistDisplayState {
  OutOfSync = 'OUT_OF_SYNC',
  Removing = 'REMOVING',
  Synced = 'SYNCED',
  Syncing = 'SYNCING'
}

export type PlaylistDuplicateInput = {
  /** The ID of the customer. */
  sourcePlaylistId: Scalars['ID'];
  targetPlaylistContentType?: PlaylistType;
  /** The description of the target playlist. */
  targetPlaylistDescription?: InputMaybe<Scalars['String']>;
  /** The target playlist name. */
  targetPlaylistName: Scalars['String'];
};

export type PlaylistDuplicatePayload = {
  __typename?: 'PlaylistDuplicatePayload';
  /** The playlist that was duplicated.  */
  playlist: Playlist;
};

export type PlaylistRemoveDisplaysInput = {
  /** The identifier of the playlist. */
  playlistId: Scalars['ID'];
};

export type PlaylistRemoveDisplaysPayload = {
  __typename?: 'PlaylistRemoveDisplaysPayload';
  /** The removed displays. */
  displays: Array<Display>;
};

export type PlaylistSyncDisplaysInput = {
  /** The identifier of the playlist. */
  playlistId: Scalars['ID'];
};

export type PlaylistSyncDisplaysPayload = {
  __typename?: 'PlaylistSyncDisplaysPayload';
  /** The synced displays. */
  displays: Array<Display>;
};

export type PlaylistSyncFailed = DisplayPlaylistSync & {
  __typename?: 'PlaylistSyncFailed';
  /** The description of the playlist that is being synced to the display. */
  description?: Maybe<Scalars['String']>;
  /** A descriptive code that indicates why syncing has failed. */
  errorCode: Scalars['String'];
  /** The identifier of the playlist that is being synced to the display. */
  id: Scalars['ID'];
  /** The internal identifier for the sync job. */
  jobId: Scalars['String'];
  /** The total size of the playlist that is being synced to the display. */
  size: Scalars['BigInt'];
  /** The title of the playlist that is being synced to the display. */
  title: Scalars['String'];
};

export type PlaylistSyncing = DisplayPlaylistSync & {
  __typename?: 'PlaylistSyncing';
  /** The description of the playlist that is being synced to the display. */
  description?: Maybe<Scalars['String']>;
  /** The identifier of the playlist that is being synced to the display. */
  id: Scalars['ID'];
  /** A flag that indicates if the sync is planned and not currently in progress. */
  isPlanned: Scalars['Boolean'];
  /** A flag that indicates if the sync is removing the playlist. */
  isRemoving: Scalars['Boolean'];
  /** The internal identifier for the sync job. */
  jobId: Scalars['String'];
  /** A percentage amount that indicates the syncing progress. */
  progress: Scalars['Float'];
  /** The total size of the playlist that is being synced to the display. */
  size: Scalars['BigInt'];
  /** The title of the playlist that is being synced to the display. */
  title: Scalars['String'];
};

/** Types of supported playlist. */
export enum PlaylistType {
  Image = 'IMAGE',
  Mixed = 'MIXED'
}

export type PlaylistUpdateInput = {
  /** Default duration for the playlist. */
  defaultDuration?: InputMaybe<Scalars['Int']>;
  /** The new description of the playlist. */
  description?: InputMaybe<Scalars['String']>;
  /** The new media of the playlist. */
  mediaIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The identifier of the playlist to update. */
  playlistId: Scalars['ID'];
  /** The new title of the playlist. */
  title?: InputMaybe<Scalars['String']>;
};

export type PlaylistUpdatePayload = {
  __typename?: 'PlaylistUpdatePayload';
  /** The playlist that was updated. */
  playlist: Playlist;
};

export type PlaylistsDeleteInput = {
  /** The ids of the playlists to delete. */
  playlistIds: Array<Scalars['ID']>;
};

export type PlaylistsDeletePayload = {
  __typename?: 'PlaylistsDeletePayload';
  /** The deleted playlists. */
  playlistIds: Array<Scalars['ID']>;
};

export enum PortsControlLockState {
  Locked = 'LOCKED',
  Unlocked = 'UNLOCKED'
}

export type PortsControlState = {
  __typename?: 'PortsControlState';
  /** The newly desired state of the ports control for the display. Cleared when successful, failed or timed out. */
  desired?: Maybe<PortsControlLockState>;
  /** The last reported state of the ports control for the display. */
  reported: PortsControlLockState;
  /** The supported values for the control state of the display. */
  supportedValues: Array<PortsControlLockState>;
};

export enum Power {
  On = 'ON',
  Standby = 'STANDBY'
}

export type PowerSchedule = {
  __typename?: 'PowerSchedule';
  /** The configurations currently holding a reference to this power schedule. */
  configurations: Array<ConfigurationModel>;
  /** The date when the power schedule was created. */
  createdAt: Scalars['DateTime'];
  /** The description of the power schedule. */
  description?: Maybe<Scalars['String']>;
  /** The displays currently holding a reference to this power schedule. */
  displays: Array<Display>;
  /** The identifier of the power schedule. */
  id: Scalars['ID'];
  /** Is  power schedule used by any configuration. */
  isPowerScheduleUsedByAnyConfiguration: Scalars['Boolean'];
  /** The time blocks associated with the power schedule. */
  timeBlocks: Array<TimeBlock>;
  /** The title of the power schedule. */
  title: Scalars['String'];
};


export type PowerScheduleDisplaysArgs = {
  filter?: InputMaybe<PowerScheduleDisplayFilter>;
};

export type PowerScheduleCreateInput = {
  /** The ID of the customer. */
  customerId: Scalars['ID'];
  /** The description of the powerSchedule. */
  description?: InputMaybe<Scalars['String']>;
  /** The powerSchedule title. */
  title: Scalars['String'];
};

export type PowerScheduleCreatePayload = {
  __typename?: 'PowerScheduleCreatePayload';
  /** The powerSchedule that was created.  */
  powerSchedule: PowerSchedule;
};

export type PowerScheduleDisplayFilter = {
  state?: InputMaybe<PowerScheduleDisplayState>;
};

export enum PowerScheduleDisplayState {
  OutOfSync = 'OUT_OF_SYNC',
  Removing = 'REMOVING',
  Synced = 'SYNCED',
  Syncing = 'SYNCING'
}

export type PowerScheduleRemoveDisplaysInput = {
  /** The identifier of the power schedule. */
  powerScheduleId: Scalars['ID'];
};

export type PowerScheduleRemoveDisplaysPayload = {
  __typename?: 'PowerScheduleRemoveDisplaysPayload';
  /** The removed displays. */
  displays: Array<Display>;
};

export type PowerScheduleSyncDisplaysInput = {
  /** The identifier of the power schedule. */
  powerScheduleId: Scalars['ID'];
};

export type PowerScheduleSyncDisplaysPayload = {
  __typename?: 'PowerScheduleSyncDisplaysPayload';
  /** The synced displays. */
  displays: Array<Display>;
};

export type PowerScheduleUpdateAborted = PowerScheduleUpdateJob & {
  __typename?: 'PowerScheduleUpdateAborted';
  /** The date at which the job has been aborted. */
  abortedAt: Scalars['DateTime'];
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The id of the schedule. */
  scheduleId?: Maybe<Scalars['ID']>;
};

export type PowerScheduleUpdateCompleted = PowerScheduleUpdateJob & {
  __typename?: 'PowerScheduleUpdateCompleted';
  /** The date at which the job is completed. */
  completedAt: Scalars['DateTime'];
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The id of the schedule. */
  scheduleId?: Maybe<Scalars['ID']>;
};

export type PowerScheduleUpdateInProgress = PowerScheduleUpdateJob & {
  __typename?: 'PowerScheduleUpdateInProgress';
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The id of the schedule. */
  scheduleId?: Maybe<Scalars['ID']>;
};

export type PowerScheduleUpdateInput = {
  /** The description of the power schedule. */
  description?: InputMaybe<Scalars['String']>;
  /** The identifier of the power schedule. */
  powerScheduleId: Scalars['ID'];
  /** The time blocks associated with the power schedule. */
  timeBlocks?: InputMaybe<Array<TimeBlockInput>>;
  /** The new title of the power schedule. */
  title?: InputMaybe<Scalars['String']>;
};

export type PowerScheduleUpdateJob = {
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The id of the schedule. */
  scheduleId?: Maybe<Scalars['ID']>;
};

export type PowerScheduleUpdatePayload = {
  __typename?: 'PowerScheduleUpdatePayload';
  /** The power schedule that was updated. */
  powerSchedule: PowerSchedule;
};

export type PowerScheduleUpdateRejected = PowerScheduleUpdateJob & {
  __typename?: 'PowerScheduleUpdateRejected';
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The date at which the job is rejected. */
  rejectedAt: Scalars['DateTime'];
  /** The reason code for rejection. */
  rejectionCode: Scalars['String'];
  /** The id of the schedule. */
  scheduleId?: Maybe<Scalars['ID']>;
};

export type PowerSchedulesDeleteInput = {
  /** The ids of the power schedules to delete. */
  powerScheduleIds: Array<Scalars['ID']>;
};

export type PowerSchedulesDeletePayload = {
  __typename?: 'PowerSchedulesDeletePayload';
  /** The deleted power schedules. */
  powerScheduleIds: Array<Scalars['ID']>;
};

export type PowerSettings = {
  __typename?: 'PowerSettings';
  /** Indicates whether the power settings are recommended by WAVE. */
  recommended: Scalars['Boolean'];
  /** Indicates whether the signal detection is supported and its state. */
  signalDetection?: Maybe<Scalars['Boolean']>;
  /** A list of warnings in case the settings are not recommended. */
  warnings: Array<SettingWarning>;
};

export type PowerSettingsState = {
  __typename?: 'PowerSettingsState';
  /** The newly desired power settings of the display. Cleared when successful, rejected or timed out. */
  desired?: Maybe<PowerSettings>;
  /** The last reported power settings of the display. */
  reported: PowerSettings;
};

export type PowerState = {
  __typename?: 'PowerState';
  /** The newly desired power state of the display. Cleared when successful, failed or timed out. */
  desired?: Maybe<Power>;
  /** The last reported power of the display. */
  reported: Power;
  /** The date at which the power was last reported. */
  reportedAt: Scalars['DateTime'];
};

export type PowerStateStatistics = {
  __typename?: 'PowerStateStatistics';
  disconnected: Scalars['Int'];
  plannedOn: Scalars['Int'];
  plannedStandBy: Scalars['Int'];
  unplannedOn: Scalars['Int'];
  unplannedStandBy: Scalars['Int'];
};

export type PresenceStatistics = {
  __typename?: 'PresenceStatistics';
  connected: Scalars['Int'];
  disconnected: Scalars['Int'];
};

export type Profile = {
  __typename?: 'Profile';
  /** The display identifier for the profile. */
  displayId: Scalars['String'];
  /** Optional error code associated with the profile. */
  errorCode?: Maybe<Scalars['String']>;
  /** Unique profile key, if available. */
  profileKey?: Maybe<Scalars['String']>;
  /** Timestamp when the profile was created. */
  updatedAt: Scalars['DateTime'];
  /** Optional URL associated with the profile. */
  url?: Maybe<Scalars['String']>;
};

export type PublishConfigurationPayload = {
  __typename?: 'PublishConfigurationPayload';
  /** Configuration published. */
  configuration: ConfigurationModel;
};

export type Query = {
  __typename?: 'Query';
  /** The Admin-mode Activity Logs audit trail for one access request, newest first. Read-only: entries are written by the mutation write-path hook and can never be deleted. Only entries for an access request raised by the caller's own organization are returned, including the target organization's decisions on it. */
  activityLogs: ActivityLogsPayload;
  /**
   * A specific configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, Guest, Installer, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configuration?: Maybe<ConfigurationModel>;
  /**
   * Check whether configuration name for the customer already exists to create a new configuration.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, Guest, Installer, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  configurationNameExists: Scalars['Boolean'];
  /**
   * Retrieves one specific customer.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, Guest, Installer, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, ServiceAdminOrgManagementView, ServiceAdminOrgManagementFull, SuperAdmin
   */
  customer?: Maybe<Customer>;
  /**
   * Retrieves a customer by its handle
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, Guest, Installer, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, ServiceAdminOrgManagementView, ServiceAdminOrgManagementFull, SuperAdmin
   */
  customerByHandle?: Maybe<Customer>;
  /**
   * Returns what will be deleted or block deletion for a customer.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, SuperAdmin
   */
  customerDeletePreCheck: CustomerDeletePreCheckResult;
  /**
   * Retrieves one specific customer.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, SuperAdminUserManagement, SuperAdmin
   */
  customersByOrganization: QueryCustomersByOrganizationPayload;
  /**
   * A specific display.
   * Requires any of the following roles: WaveAdmin, ZteAdmin, Owner, Admin, Developer, Operator, Guest, Mfa, Installer, SsoUser, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  display?: Maybe<Display>;
  /**
   * Partial data of a display, which is identified by a display code.
   * Requires any of the following roles: WaveAdmin, ZteAdmin, Owner, Admin, Developer, Operator, Guest, Mfa, Installer, SsoUser, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  displayByCode?: Maybe<ClaimableDisplay>;
  /**
   * Query to get ZTE enrolments for an organization
   * Requires any of the following roles: Owner, ServiceAdminZteView, ServiceAdminZteFull, SuperAdminUserManagement, SuperAdmin
   */
  enrolmentsForOrganization: QueryEnrolmentsForOrganizationPayload;
  /**
   * The currently logged in user
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, Guest, Installer, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, ServiceAdminOrgManagementView, ServiceAdminOrgManagementFull, SuperAdminUserManagement, SuperAdmin
   */
  me: CurrentUser;
  /**
   * Check whether slot available for the customer to create a new multiclaimCode .
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Installer, SuperAdmin
   */
  multiClaimSlotAvailable: Scalars['Boolean'];
  /**
   * Access requests raised by the caller's organization — Admin-mode's Requests tab. Every service admin in the organization sees the requests their colleagues sent.
   * Requires any of the following roles: ServiceAdminZteView, ServiceAdminZteFull, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, ServiceAdminFirmwareView, ServiceAdminFirmwareFull, ServiceAdminOrgManagementView, ServiceAdminOrgManagementFull, SuperAdminUserManagement, SuperAdmin
   */
  myAccessRequests: Array<ServiceAdminOrgAccessRequestDocument>;
  /**
   * The organization currently being worked in — the caller's own org, or the org they hold an approved admin access grant for, if they've elevated into one.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, Guest, Installer, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, ServiceAdminOrgManagementView, ServiceAdminOrgManagementFull, SuperAdminUserManagement, SuperAdmin
   */
  organization: Organization;
  /**
   * Access requests received by the caller's own organization — Settings → Access Requests tab.
   * Requires any of the following roles: Owner, Admin, SuperAdmin
   */
  organizationAccessRequests: Array<ServiceAdminOrgAccessRequestDocument>;
  /**
   * A specific playlist.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, Guest, Installer, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, SuperAdmin
   */
  playlist?: Maybe<Playlist>;
  /**
   * A specific power schedule.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, Guest, Installer, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, SuperAdmin
   */
  powerSchedule?: Maybe<PowerSchedule>;
  /**
   * A specific schedule.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, Developer, Operator, Guest, Installer, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, SuperAdmin
   */
  schedule?: Maybe<Schedule>;
  /**
   * Device log capture requests — primarily filtered by the access request they are tied to.
   * Requires any of the following roles: ServiceAdminZteView, ServiceAdminZteFull, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, SuperAdminUserManagement, SuperAdmin
   */
  serviceAdminDeviceLogs: ServiceAdminDeviceLogPayload;
  /**
   * The New Admin picker: users belonging to an internal organization who do not yet hold a Service Admin role.
   * Requires any of the following roles: SuperAdminUserManagement, SuperAdmin
   */
  serviceAdminEligibleUsers: ServiceAdminEligibleUsersPayload;
  /**
   * Global Search: fuzzy, word-order-independent customer name search for Service Admins
   * Requires any of the following roles: ServiceAdminZteView, ServiceAdminZteFull, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, ServiceAdminFirmwareView, ServiceAdminFirmwareFull, ServiceAdminOrgManagementView, ServiceAdminOrgManagementFull, SuperAdminUserManagement, SuperAdmin
   */
  serviceAdminSearchCustomers: ServiceAdminCustomerSearchPayload;
  /**
   * Global Search: literal (non-fuzzy) device MAC address / serial number search for Service Admins
   * Requires any of the following roles: ServiceAdminZteView, ServiceAdminZteFull, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, ServiceAdminFirmwareView, ServiceAdminFirmwareFull, ServiceAdminOrgManagementView, ServiceAdminOrgManagementFull, SuperAdminUserManagement, SuperAdmin
   */
  serviceAdminSearchDevices: ServiceAdminDeviceSearchPayload;
  /**
   * Global Search: fuzzy, word-order-independent organization name search for Service Admins
   * Requires any of the following roles: ServiceAdminZteView, ServiceAdminZteFull, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, ServiceAdminFirmwareView, ServiceAdminFirmwareFull, ServiceAdminOrgManagementView, ServiceAdminOrgManagementFull, SuperAdminUserManagement, SuperAdmin
   */
  serviceAdminSearchOrganizations: ServiceAdminOrganizationSearchPayload;
  /**
   * Global Search: fuzzy, word-order-independent search across email/first name/last name for Service Admins
   * Requires any of the following roles: ServiceAdminZteView, ServiceAdminZteFull, ServiceAdminDeviceView, ServiceAdminDeviceService, ServiceAdminDeviceFull, ServiceAdminFirmwareView, ServiceAdminFirmwareFull, ServiceAdminOrgManagementView, ServiceAdminOrgManagementFull, SuperAdminUserManagement, SuperAdmin
   */
  serviceAdminSearchUsers: ServiceAdminUserSearchPayload;
  /**
   * The Admin profiles list: every user, across all organizations, holding at least one Service Admin role.
   * Requires any of the following roles: SuperAdminUserManagement, SuperAdmin
   */
  serviceAdminUsers: ServiceAdminUsersPayload;
  /**
   * A specific Wave Subscription.
   * Requires any of the following roles: WaveAdmin, Owner, Admin, SuperAdmin
   */
  waveSubscription?: Maybe<WaveSubscription>;
};


export type QueryActivityLogsArgs = {
  accessRequestId: Scalars['ID'];
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryConfigurationArgs = {
  customerId: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryConfigurationNameExistsArgs = {
  input: ConfigurationNameExistsInput;
};


export type QueryCustomerArgs = {
  id: Scalars['ID'];
};


export type QueryCustomerByHandleArgs = {
  handle: Scalars['String'];
};


export type QueryCustomerDeletePreCheckArgs = {
  customerId: Scalars['ID'];
};


export type QueryDisplayArgs = {
  id: Scalars['ID'];
};


export type QueryDisplayByCodeArgs = {
  displayCode: Scalars['String'];
};


export type QueryEnrolmentsForOrganizationArgs = {
  filter?: InputMaybe<ZteEnrolmentFiltersInput>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryMultiClaimSlotAvailableArgs = {
  input: MultiClaimSlotAvailableInput;
};


export type QueryMyAccessRequestsArgs = {
  filter?: InputMaybe<ServiceAdminOrgAccessRequestFilter>;
};


export type QueryOrganizationAccessRequestsArgs = {
  filter?: InputMaybe<ServiceAdminOrgAccessRequestFilter>;
};


export type QueryPlaylistArgs = {
  id: Scalars['ID'];
};


export type QueryPowerScheduleArgs = {
  id: Scalars['ID'];
};


export type QueryScheduleArgs = {
  id: Scalars['ID'];
};


export type QueryServiceAdminDeviceLogsArgs = {
  accessRequestId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
  deviceId?: InputMaybe<Scalars['ID']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ServiceAdminDeviceLogStatus>;
  targetOrganizationId?: InputMaybe<Scalars['ID']>;
};


export type QueryServiceAdminEligibleUsersArgs = {
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryServiceAdminSearchCustomersArgs = {
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchTerm: Scalars['String'];
};


export type QueryServiceAdminSearchDevicesArgs = {
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchTerm: Scalars['String'];
};


export type QueryServiceAdminSearchOrganizationsArgs = {
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchTerm: Scalars['String'];
};


export type QueryServiceAdminSearchUsersArgs = {
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchTerm: Scalars['String'];
};


export type QueryServiceAdminUsersArgs = {
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryWaveSubscriptionArgs = {
  id: Scalars['ID'];
};

export type QueryCustomersByOrganizationPayload = {
  __typename?: 'QueryCustomersByOrganizationPayload';
  /** The partial customers' data of the user's organization . */
  customers: Array<PartialCustomer>;
};

export type QueryEnrolmentsForOrganizationPayload = {
  __typename?: 'QueryEnrolmentsForOrganizationPayload';
  /** The total count of enrolments. */
  totalCount: Scalars['Int'];
  /** List of ZTE enrolments. */
  zteEnrolment: Array<ZteEnrolment>;
  /** Filters for ZTE */
  zteFilters: ZteFilters;
};

export type RebootJob = {
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The date at which the job is planned. In case the job is invoked immediately, the value is equal to createdAt. */
  plannedAt: Scalars['DateTime'];
};

export type RebootJobAborted = RebootJob & {
  __typename?: 'RebootJobAborted';
  /** The date at which the job has been aborted. */
  abortedAt: Scalars['DateTime'];
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The date at which the job is planned. In case the job is invoked immediately, the value is equal to createdAt. */
  plannedAt: Scalars['DateTime'];
};

export type RebootJobCompleted = RebootJob & {
  __typename?: 'RebootJobCompleted';
  /** The date at which the job is completed. */
  completedAt: Scalars['DateTime'];
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The date at which the job is planned. In case the job is invoked immediately, the value is equal to createdAt. */
  plannedAt: Scalars['DateTime'];
};

export type RebootJobInProgress = RebootJob & {
  __typename?: 'RebootJobInProgress';
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The date at which the job is planned. In case the job is invoked immediately, the value is equal to createdAt. */
  plannedAt: Scalars['DateTime'];
};

export type RebootJobPlanned = RebootJob & {
  __typename?: 'RebootJobPlanned';
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The date at which the job is planned. In case the job is invoked immediately, the value is equal to createdAt. */
  plannedAt: Scalars['DateTime'];
};

export type RebootState = {
  __typename?: 'RebootState';
  /** The last reboot job executed. */
  latestJob: RebootJob;
};

export type RecommendedSettings = {
  __typename?: 'RecommendedSettings';
  /** Indicates whether the settings are recommended by WAVE. */
  recommended: Scalars['Boolean'];
  /** A list of warnings in case the settings are not recommended. */
  warnings: Array<SettingWarning>;
};

export type RecommendedSettingsState = {
  __typename?: 'RecommendedSettingsState';
  /** The newly desired recommended settings of the display. Cleared when successful, rejected or timed out. */
  desired?: Maybe<RecommendedSettings>;
  /** The last reported recommended settings of the display. */
  reported: RecommendedSettings;
};

export enum ReleaseChannel {
  Alpha = 'ALPHA',
  Stable = 'STABLE'
}

export enum Role {
  Admin = 'Admin',
  Developer = 'Developer',
  Guest = 'Guest',
  Installer = 'Installer',
  Mfa = 'Mfa',
  Operator = 'Operator',
  Owner = 'Owner',
  SsoUser = 'SsoUser',
  WaveAdmin = 'WaveAdmin',
  ZteAdmin = 'ZteAdmin'
}

/** Options specific to SSO SAML */
export type SamlOptions = {
  __typename?: 'SamlOptions';
  /** SAML entity ID */
  entityId?: Maybe<Scalars['String']>;
  /** SAML sign-in endpoint URL */
  signInEndpoint?: Maybe<Scalars['String']>;
  /** SAML signing certificate (masked for security) */
  signingCert?: Maybe<Scalars['String']>;
};

/** Represents a SAML SSO provider configuration */
export type SamlProvider = SsoProviderInterface & {
  __typename?: 'SamlProvider';
  /** Display name for the SSO provider */
  displayName?: Maybe<Scalars['String']>;
  /** SAML specific options */
  options: SamlOptions;
  /** The SSO provider strategy type */
  strategy: SsoProviderStrategy;
  /** Validation status of the SSO provider */
  validationStatus?: Maybe<SsoValidationStatus>;
};

export type Scaler = {
  __typename?: 'Scaler';
  /** The version of the Scaler component of the firmware. */
  version: Scalars['FirmwareVersion'];
};

export type Schedule = {
  __typename?: 'Schedule';
  /** The configurations currently holding a reference to this schedule. */
  configurations: Array<ConfigurationModel>;
  /** The date when the schedule was created. */
  createdAt: Scalars['DateTime'];
  /** The description of the schedule. */
  description: Scalars['String'];
  /** The displays currently holding a reference to this schedule. */
  displays: Array<Display>;
  /** The identifier of the schedule. */
  id: Scalars['ID'];
  /** Whether the schedule is a legacy power schedule imported as default input source slots. */
  isLegacy: Scalars['Boolean'];
  /** Is the schedule used by any configuration. */
  isScheduleUsedByAnyConfiguration: Scalars['Boolean'];
  /** The time blocks associated with the schedule. */
  timeBlocks: Array<ScheduleTimeBlock>;
  /** The title of the schedule. */
  title: Scalars['String'];
};


export type ScheduleDisplaysArgs = {
  filter?: InputMaybe<ScheduleDisplayFilter>;
};

export type ScheduleCreateInput = {
  /** The ID of the customer. */
  customerId: Scalars['ID'];
  /** The description of the schedule. */
  description: Scalars['String'];
  /** The time slots to create the schedule with. Defaults to an empty schedule. */
  timeBlocks?: InputMaybe<Array<ScheduleTimeBlockInput>>;
  /** The schedule title. */
  title: Scalars['String'];
};

export type ScheduleCreatePayload = {
  __typename?: 'ScheduleCreatePayload';
  /** The schedule that was created. */
  schedule: Schedule;
};

export type ScheduleDisplayFilter = {
  state?: InputMaybe<ScheduleDisplayState>;
};

export enum ScheduleDisplayState {
  OutOfSync = 'OUT_OF_SYNC',
  Removing = 'REMOVING',
  Synced = 'SYNCED',
  Syncing = 'SYNCING'
}

export type ScheduleDuplicateInput = {
  /** The identifier of the schedule to duplicate. */
  scheduleId: Scalars['ID'];
  /** Title for the copy. Defaults to "<original title> (copy)". */
  title?: InputMaybe<Scalars['String']>;
};

export type ScheduleDuplicatePayload = {
  __typename?: 'ScheduleDuplicatePayload';
  /** The newly created copy of the schedule. */
  schedule: Schedule;
};

export type ScheduleRemoveDisplaysInput = {
  /** The identifier of the schedule. */
  scheduleId: Scalars['ID'];
};

export type ScheduleRemoveDisplaysPayload = {
  __typename?: 'ScheduleRemoveDisplaysPayload';
  /** The displays that were cleared. */
  displays: Array<Display>;
};

/** Warning or error for an out-of-sync schedule time slot. */
export type ScheduleSlotWarning = {
  __typename?: 'ScheduleSlotWarning';
  /** The 1-based index of the time slot in the schedule time blocks. */
  slotIndex: Scalars['Int'];
  /** Warning severity: WARNING if a lower-priority item is shown, ERROR if no scheduled item is shown. */
  warning: ScheduleSlotWarningSeverity;
};

export enum ScheduleSlotWarningSeverity {
  Error = 'ERROR',
  Warning = 'WARNING'
}

export type ScheduleSyncDisplaysInput = {
  /** The identifier of the schedule. */
  scheduleId: Scalars['ID'];
};

export type ScheduleSyncDisplaysPayload = {
  __typename?: 'ScheduleSyncDisplaysPayload';
  /** The synced displays. */
  displays: Array<Display>;
};

export type ScheduleTimeBlock = {
  __typename?: 'ScheduleTimeBlock';
  /** Whether the block schedules content or a setting. Content and settings blocks run on independent tracks and may overlap at the same priority. */
  category: TimeBlockCategory;
  /** The typed payload of the block (playlist id, brightness level, etc). */
  data: ScheduleTimeBlockData;
  /** The day of the week the block applies to. */
  day: Day;
  /** The time of the day, with format hh:mm, when the block ends. */
  end: Scalars['String'];
  /** The priority lane of the block. Blocks in different lanes may overlap; the display plays the highest priority. */
  priority: Scalars['Int'];
  /** The time of the day, with format hh:mm, when the block starts. */
  start: Scalars['String'];
  /** The content or setting the block schedules. */
  type: TimeBlockType;
};

/** The typed payload of a schedule time block. The populated field matches the block type: BRIGHTNESS→value, PLAYLIST→id+title+mediaType, APPS→applicationId, BOOKMARK→url, SOURCE→source. */
export type ScheduleTimeBlockData = {
  __typename?: 'ScheduleTimeBlockData';
  /** Application id (APPS blocks). */
  applicationId?: Maybe<Scalars['String']>;
  /** Playlist id (PLAYLIST blocks). */
  id?: Maybe<Scalars['String']>;
  /** Playlist media type (PLAYLIST blocks). */
  mediaType?: Maybe<Scalars['String']>;
  /** Input source (SOURCE / DEFAULT_INPUT_SOURCE). */
  source?: Maybe<Scalars['String']>;
  /** Playlist title (PLAYLIST blocks), resolved from the playlist id. */
  title?: Maybe<Scalars['String']>;
  /** Bookmark URL (BOOKMARK blocks). */
  url?: Maybe<Scalars['String']>;
  /** Brightness level 0-100 (BRIGHTNESS blocks). */
  value?: Maybe<Scalars['Int']>;
};

/** The typed payload of a schedule time block. Supply the field matching the block type: BRIGHTNESS→value, PLAYLIST→id+mediaType, APPS→applicationId, BOOKMARK→url, SOURCE→source. */
export type ScheduleTimeBlockDataInput = {
  /** Application id (APPS blocks). */
  applicationId?: InputMaybe<Scalars['String']>;
  /** Playlist id (PLAYLIST blocks). */
  id?: InputMaybe<Scalars['String']>;
  /** Playlist media type (PLAYLIST blocks). */
  mediaType?: InputMaybe<Scalars['String']>;
  /** Input source (SOURCE / DEFAULT_INPUT_SOURCE). */
  source?: InputMaybe<Scalars['String']>;
  /** Bookmark URL (BOOKMARK blocks). */
  url?: InputMaybe<Scalars['String']>;
  /** Brightness level 0-100 (BRIGHTNESS blocks). */
  value?: InputMaybe<Scalars['Int']>;
};

export type ScheduleTimeBlockInput = {
  /** The typed payload for the block. */
  data: ScheduleTimeBlockDataInput;
  day: Day;
  end: Scalars['String'];
  /** The priority lane of the block. */
  priority: Scalars['Int'];
  start: Scalars['String'];
  /** The content or setting the block schedules. */
  type: TimeBlockType;
};

export type ScheduleUpdateAborted = ScheduleUpdateJob & {
  __typename?: 'ScheduleUpdateAborted';
  /** The date at which the job has been aborted. */
  abortedAt: Scalars['DateTime'];
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The id of the schedule. */
  scheduleId?: Maybe<Scalars['ID']>;
};

export type ScheduleUpdateCompleted = ScheduleUpdateJob & {
  __typename?: 'ScheduleUpdateCompleted';
  /** The date at which the job is completed. */
  completedAt: Scalars['DateTime'];
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The id of the schedule. */
  scheduleId?: Maybe<Scalars['ID']>;
};

export type ScheduleUpdateInProgress = ScheduleUpdateJob & {
  __typename?: 'ScheduleUpdateInProgress';
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The id of the schedule. */
  scheduleId?: Maybe<Scalars['ID']>;
};

export type ScheduleUpdateInput = {
  /** The description of the schedule. */
  description?: InputMaybe<Scalars['String']>;
  /** The identifier of the schedule. */
  scheduleId: Scalars['ID'];
  /** The time blocks associated with the schedule. */
  timeBlocks?: InputMaybe<Array<ScheduleTimeBlockInput>>;
  /** The new title of the schedule. */
  title?: InputMaybe<Scalars['String']>;
};

export type ScheduleUpdateJob = {
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The id of the schedule. */
  scheduleId?: Maybe<Scalars['ID']>;
};

export type ScheduleUpdatePayload = {
  __typename?: 'ScheduleUpdatePayload';
  /** The schedule that was updated. */
  schedule: Schedule;
};

export type ScheduleUpdateRejected = ScheduleUpdateJob & {
  __typename?: 'ScheduleUpdateRejected';
  /** The date at which the job is created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the job. */
  id: Scalars['ID'];
  /** The date at which the job is rejected. */
  rejectedAt: Scalars['DateTime'];
  /** The reason code for rejection. */
  rejectionCode: Scalars['String'];
  /** The id of the schedule. */
  scheduleId?: Maybe<Scalars['ID']>;
};

export type SchedulesDeleteInput = {
  /** The ids of the schedules to delete. */
  scheduleIds: Array<Scalars['ID']>;
};

export type SchedulesDeletePayload = {
  __typename?: 'SchedulesDeletePayload';
  /** The deleted schedules. */
  scheduleIds: Array<Scalars['ID']>;
};

export type Screenshot = {
  /** The date at which the screenshot was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The URL of the screenshot. */
  url?: Maybe<Scalars['String']>;
};

export type ScreenshotEmpty = Screenshot & {
  __typename?: 'ScreenshotEmpty';
  /** The date at which the screenshot was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The URL of the screenshot. */
  url?: Maybe<Scalars['String']>;
};

export type ScreenshotPending = Screenshot & {
  __typename?: 'ScreenshotPending';
  /** The date at which the screenshot was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The URL of the screenshot. */
  url?: Maybe<Scalars['String']>;
};

export type ScreenshotRejected = Screenshot & {
  __typename?: 'ScreenshotRejected';
  /** The date at which the screenshot was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The code indicating the type of error that occurred. */
  errorCode: Scalars['String'];
  /** The date at which capturing the screenshot failed. */
  rejectedAt: Scalars['DateTime'];
  /** The URL of the screenshot. */
  url?: Maybe<Scalars['String']>;
};

export type ScreenshotResolved = Screenshot & {
  __typename?: 'ScreenshotResolved';
  /** The date at which the screenshot was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The URL of the screenshot. */
  url?: Maybe<Scalars['String']>;
};

export type SelfProfileUpdateInput = {
  /** The UI locale of the user. */
  locale?: InputMaybe<Scalars['String']>;
  /** The temperature unit of the user. */
  tempUnit?: InputMaybe<Scalars['String']>;
};

export type SelfProfileUpdatePayload = {
  __typename?: 'SelfProfileUpdatePayload';
  /** The user that was updated. */
  user: User;
};

export type ServiceAdminCustomerSearchPayload = {
  __typename?: 'ServiceAdminCustomerSearchPayload';
  results: Array<ServiceAdminCustomerSearchResult>;
  /** Total number of customers matching the search term. */
  totalCount: Scalars['Int'];
};

export type ServiceAdminCustomerSearchResult = {
  __typename?: 'ServiceAdminCustomerSearchResult';
  accessState: ServiceAdminGlobalSearchAccessState;
  createdAt: Scalars['DateTime'];
  /** Number of displays belonging to this customer. */
  displayCount: Scalars['Int'];
  handle: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Email of the customer's organization's earliest-created Owner. */
  onboardedAdminEmail?: Maybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  organizationName: Scalars['String'];
};

export type ServiceAdminDeviceLog = {
  __typename?: 'ServiceAdminDeviceLog';
  /** The ServiceAdminOrgAccessRequest this device log request is tied to — the primary way this list is queried. "home-organization" for a request raised against the caller's own org. */
  accessRequestId: Scalars['ID'];
  customerId: Scalars['ID'];
  customerName: Scalars['String'];
  deviceId: Scalars['ID'];
  endTime?: Maybe<Scalars['DateTime']>;
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logDurationDays: Scalars['Int'];
  logDurationHours: Scalars['Int'];
  /** Computed from the stored S3 key at read time — see deviceLogsUrl.ts. */
  logUrl?: Maybe<Scalars['String']>;
  organizationName: Scalars['String'];
  startTime: Scalars['DateTime'];
  startedByEmail: Scalars['String'];
  status: ServiceAdminDeviceLogStatus;
  targetOrganizationId: Scalars['ID'];
};

export type ServiceAdminDeviceLogDeletePayload = {
  __typename?: 'ServiceAdminDeviceLogDeletePayload';
  /** True once the record (and its S3 object) has actually been removed. False means a still-running request was driven into Stopping and will finish deleting once the agent's Stopped report arrives. */
  deleted: Scalars['Boolean'];
  record: ServiceAdminDeviceLog;
};

export type ServiceAdminDeviceLogPayload = {
  __typename?: 'ServiceAdminDeviceLogPayload';
  results: Array<ServiceAdminDeviceLog>;
  /** Total number of device log requests matching the filter. */
  totalCount: Scalars['Int'];
};

export enum ServiceAdminDeviceLogStatus {
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Ongoing = 'ONGOING',
  Starting = 'STARTING',
  Stopped = 'STOPPED',
  Stopping = 'STOPPING',
  Uploading = 'UPLOADING'
}

export type ServiceAdminDeviceSearchPayload = {
  __typename?: 'ServiceAdminDeviceSearchPayload';
  results: Array<ServiceAdminDeviceSearchResult>;
  /** Total number of devices matching the search term. */
  totalCount: Scalars['Int'];
};

export type ServiceAdminDeviceSearchResult = {
  __typename?: 'ServiceAdminDeviceSearchResult';
  accessState: ServiceAdminGlobalSearchAccessState;
  alias?: Maybe<Scalars['String']>;
  connected: Scalars['Boolean'];
  customerId: Scalars['ID'];
  customerName: Scalars['String'];
  id: Scalars['ID'];
  mac: Scalars['String'];
  organizationId: Scalars['ID'];
  organizationName: Scalars['String'];
  /** The last reported power state of the display, or null if it has not reported one yet. */
  power?: Maybe<Power>;
  serialNumber: Scalars['String'];
};

export type ServiceAdminEligibleUsersPayload = {
  __typename?: 'ServiceAdminEligibleUsersPayload';
  /** The total number of eligible users matching the filter, across all pages. */
  totalCount: Scalars['Int'];
  /** The page of users eligible to be promoted to Service Admin: belonging to an internal organization and not already holding a Service Admin role. */
  users: Array<User>;
};

export enum ServiceAdminGlobalSearchAccessState {
  Available = 'AVAILABLE',
  AwaitingApproval = 'AWAITING_APPROVAL',
  Expired = 'EXPIRED',
  NotRequested = 'NOT_REQUESTED',
  Rejected = 'REJECTED',
  Revoked = 'REVOKED'
}

export enum ServiceAdminOrgAccessRequestDecision {
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type ServiceAdminOrgAccessRequestDocument = {
  __typename?: 'ServiceAdminOrgAccessRequestDocument';
  /** Set only once the request has been approved. */
  accessExpiresAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  decidedAt?: Maybe<Scalars['DateTime']>;
  /** The id of the org owner who decided. */
  decidedBy?: Maybe<Scalars['String']>;
  /** The unique identifier of the request. */
  id: Scalars['ID'];
  /** How long access should last, once approved. */
  requestedDurationMinutes: Scalars['Int'];
  /** The admin who raised the request. Null when the user no longer exists. */
  requestingServiceAdmin?: Maybe<ServiceAdminOrgAccessRequestUser>;
  /** The id of the admin who raised the request. */
  requestingServiceAdminId: Scalars['String'];
  /** The organization id to which the admin belongs. */
  requestingServiceAdminOrganizationId: Scalars['String'];
  status: ServiceAdminOrgAccessRequestStatus;
  /** Number of displays across the target organization's customers. Null when the organization no longer exists. */
  targetOrganizationDisplayCount?: Maybe<Scalars['Int']>;
  /** The organization access is requested for. */
  targetOrganizationId: Scalars['String'];
  /** The name of the organization access is requested for. Null when the organization no longer exists. */
  targetOrganizationName?: Maybe<Scalars['String']>;
  /** The email of the first owner created in the target organization. Null when the organization has no owner. */
  targetOrganizationOwnerEmail?: Maybe<Scalars['String']>;
};

export enum ServiceAdminOrgAccessRequestFilter {
  All = 'ALL',
  Approved = 'APPROVED',
  Awaiting = 'AWAITING',
  Expired = 'EXPIRED',
  Rejected = 'REJECTED',
  Revoked = 'REVOKED'
}

export enum ServiceAdminOrgAccessRequestStatus {
  Approved = 'APPROVED',
  Awaiting = 'AWAITING',
  Expired = 'EXPIRED',
  Rejected = 'REJECTED',
  Revoked = 'REVOKED'
}

export type ServiceAdminOrgAccessRequestUser = {
  __typename?: 'ServiceAdminOrgAccessRequestUser';
  /** The email address of the user. */
  email: Scalars['String'];
  /** The last name of the user. */
  familyName?: Maybe<Scalars['String']>;
  /** The first name of the user. */
  givenName?: Maybe<Scalars['String']>;
};

export type ServiceAdminOrganizationSearchPayload = {
  __typename?: 'ServiceAdminOrganizationSearchPayload';
  results: Array<ServiceAdminOrganizationSearchResult>;
  /** Total number of organizations matching the search term. */
  totalCount: Scalars['Int'];
};

export type ServiceAdminOrganizationSearchResult = {
  __typename?: 'ServiceAdminOrganizationSearchResult';
  /** The caller's access state for this organization — drives "Go to org" / "Request access" / etc. */
  accessState: ServiceAdminGlobalSearchAccessState;
  createdAt: Scalars['DateTime'];
  /** If ProStore developer access is enabled for this organization. */
  developerAccess: Scalars['Boolean'];
  /** Number of displays across the organization's customers. */
  displayCount: Scalars['Int'];
  handle: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Email of the org's earliest-created Owner — there's no stored createdBy/onboardedBy on the organization itself, so this is the closest available proxy for who onboarded it. */
  onboardedAdminEmail?: Maybe<Scalars['String']>;
  /** If this organization is connected to ProStore. */
  proStoreConnected: Scalars['Boolean'];
};

/** Cross-organization Admin Serviceability role. At most one role per access area can be held. */
export enum ServiceAdminRole {
  ServiceAdminDeviceFull = 'ServiceAdminDeviceFull',
  ServiceAdminDeviceService = 'ServiceAdminDeviceService',
  ServiceAdminDeviceView = 'ServiceAdminDeviceView',
  ServiceAdminFirmwareFull = 'ServiceAdminFirmwareFull',
  ServiceAdminFirmwareView = 'ServiceAdminFirmwareView',
  ServiceAdminOrgManagementFull = 'ServiceAdminOrgManagementFull',
  ServiceAdminOrgManagementView = 'ServiceAdminOrgManagementView',
  ServiceAdminZteFull = 'ServiceAdminZteFull',
  ServiceAdminZteView = 'ServiceAdminZteView',
  SuperAdmin = 'SuperAdmin',
  SuperAdminUserManagement = 'SuperAdminUserManagement'
}

export type ServiceAdminUserCreateInput = {
  /** The email address of the new user. An invitation e-mail will be sent to this address. */
  email: Scalars['String'];
  /** The last name of the new user. */
  familyName: Scalars['String'];
  /** The first name of the new user. */
  givenName: Scalars['String'];
  /** The organization roles of the new user. */
  roles: Array<Role>;
};

export type ServiceAdminUserSearchPayload = {
  __typename?: 'ServiceAdminUserSearchPayload';
  results: Array<ServiceAdminUserSearchResult>;
  /** Total number of users matching the search term. */
  totalCount: Scalars['Int'];
};

export type ServiceAdminUserSearchResult = {
  __typename?: 'ServiceAdminUserSearchResult';
  /** The caller's access state for this user's organization — drives the "Go to org" action. */
  accessState: ServiceAdminGlobalSearchAccessState;
  email: Scalars['String'];
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  organizationId: Scalars['ID'];
  organizationName: Scalars['String'];
  roles: Array<Role>;
  /** ACTIVE once signup is complete (password set, has logged in at least once); PENDING otherwise. */
  status: ServiceAdminUserSearchStatus;
};

export enum ServiceAdminUserSearchStatus {
  Active = 'ACTIVE',
  Pending = 'PENDING'
}

export type ServiceAdminUserUpdateInput = {
  /** The new email address of the user. */
  email: Scalars['String'];
  /** The organization roles that replace the current ones. Roles that cannot be managed from Global Search (e.g. Mfa) are kept as they are. */
  roles: Array<Role>;
  /** The identifier of the user. */
  userId: Scalars['ID'];
};

export type ServiceAdminUsersPayload = {
  __typename?: 'ServiceAdminUsersPayload';
  /** The total number of users matching the filter, across all pages. */
  totalCount: Scalars['Int'];
  /** The page of users holding at least one Service Admin role, newest first. */
  users: Array<User>;
};

export type SettingWarning = {
  __typename?: 'SettingWarning';
  /** A unique code identifying the warning. */
  code: Scalars['String'];
  /** The full description of the warning. */
  description: Scalars['String'];
  /** The severity of the warning. */
  severity: SettingWarningSeverity;
};

export enum SettingWarningSeverity {
  High = 'HIGH',
  Low = 'LOW',
  Moderate = 'MODERATE'
}

export type Shadow = {
  __typename?: 'Shadow';
  contentSourceApps?: Maybe<ShadowDictionaryField>;
  contentSourceDefault?: Maybe<ShadowField>;
  contentSourceInputs?: Maybe<ShadowDictionaryField>;
  contentSourcePlaylists?: Maybe<ShadowDictionaryField>;
  keyboardControl?: Maybe<ShadowField>;
  portsControl?: Maybe<ShadowField>;
  power?: Maybe<ShadowField>;
  powerSettings?: Maybe<ShadowField>;
};

export type ShadowDictionaryField = {
  __typename?: 'ShadowDictionaryField';
  /** Schema definition for dictionary entries. */
  entrySchema?: Maybe<Scalars['JSON']>;
  /** Indicates this is a dictionary-style shadow field. */
  type: Scalars['String'];
  /** Timestamp of last update. */
  updatedAt: Scalars['DateTime'];
  /** A dictionary (key-value) map of entries. */
  value: Scalars['JSON'];
};

export type ShadowField = {
  __typename?: 'ShadowField';
  /** Schema definition for composite fields. */
  schema?: Maybe<Scalars['JSON']>;
  /** Type of the shadow field, e.g., composite or string. */
  type: Scalars['String'];
  /** Last updated timestamp of the shadow field. */
  updatedAt: Scalars['DateTime'];
  /** Validation schema such as supported values. */
  validation?: Maybe<Scalars['JSON']>;
  /** The value stored for this shadow field. */
  value: Scalars['JSON'];
};

export type ShouldUpdateToLatestFirmwareInput = {
  /** The identifier of the configuration. */
  configurationId: Scalars['ID'];
  /** Indicates if the configuration should update to the latest firmware. */
  shouldUpdateToLatestFirmware: Scalars['Boolean'];
};

export type SignalDetectionState = {
  __typename?: 'SignalDetectionState';
  /** The newly desired signal detection state of the display. Cleared when successful, failed or timed out. */
  desired?: Maybe<Scalars['Boolean']>;
  /** The last reported signal detection state of the display. */
  reported: Scalars['Boolean'];
};

export type Site = {
  __typename?: 'Site';
  /** The address of the site. */
  address?: Maybe<Scalars['String']>;
  /** The identifier of the site. */
  id: Scalars['ID'];
  /** Indicates whether the site is used in any configuration. */
  isSiteUsedByAnyConfiguration: Scalars['Boolean'];
  /** The name of the site. */
  name: Scalars['String'];
};

export type SiteCreateInput = {
  /** The address of the site. */
  address?: InputMaybe<Scalars['String']>;
  /** The customer to which to add the site. */
  customerId: Scalars['ID'];
  /** The name of the site. */
  name: Scalars['String'];
};

export type SiteCreatePayload = {
  __typename?: 'SiteCreatePayload';
  /** The customer associated with the site. */
  customer?: Maybe<Customer>;
  /** The site that was created. */
  site?: Maybe<Site>;
};

export type SiteDeleteInput = {
  /** The identifier of the site. */
  siteId: Scalars['ID'];
};

export type SiteDeletePayload = {
  __typename?: 'SiteDeletePayload';
  /** The site that was deleted. */
  siteId: Scalars['ID'];
};

export type SiteUpdateInput = {
  /** The address of the site. */
  address?: InputMaybe<Scalars['String']>;
  /** The name that will be given to the site. */
  name: Scalars['String'];
  /** The identifier of the site. */
  siteId: Scalars['ID'];
};

export type SourceRecord = {
  __typename?: 'SourceRecord';
  count: Scalars['Int'];
  source: Scalars['String'];
};

/** Represents a SSO for an organization */
export type Sso = {
  __typename?: 'Sso';
  /** Domain associated with the SSO */
  domain: Scalars['String'];
  /** Unique identifier for the SSO */
  id: Scalars['ID'];
  /** The SSO provider configuration */
  provider?: Maybe<SsoProvider>;
  /** Verification status of the domain */
  verificationStatus: DomainVerificationStatus;
};

export type SsoDomainCreateInput = {
  /** The domain to register for SSO. */
  domain: Scalars['String'];
};

export type SsoDomainDeleteInput = {
  /** The unique identifier of the SSO domain to delete */
  id: Scalars['ID'];
};

/** Union type representing all SSO provider configurations */
export type SsoProvider = OidcProvider | SamlProvider;

/** Interface representing a SSO provider configuration */
export type SsoProviderInterface = {
  /** Display name for the SSO provider */
  displayName?: Maybe<Scalars['String']>;
  /** The SSO provider strategy type */
  strategy: SsoProviderStrategy;
  /** Validation status of the SSO provider */
  validationStatus?: Maybe<SsoValidationStatus>;
};

export type SsoProviderOidcPublishInput = {
  /** OIDC authorization endpoint */
  authorizationEndpoint?: InputMaybe<Scalars['String']>;
  /** OIDC client ID */
  clientId?: InputMaybe<Scalars['String']>;
  /** OIDC client secret */
  clientSecret?: InputMaybe<Scalars['String']>;
  /** OIDC discovery URL */
  discoveryUrl?: InputMaybe<Scalars['String']>;
  /** OIDC display name */
  displayName?: InputMaybe<Scalars['String']>;
  /** The ID of the SSO */
  id: Scalars['ID'];
  /** OIDC issuer URL */
  issuer?: InputMaybe<Scalars['String']>;
  /** OIDC JWKS URI */
  jwksUri?: InputMaybe<Scalars['String']>;
};

export type SsoProviderOidcUpsertInput = {
  /** OIDC authorization endpoint */
  authorizationEndpoint?: InputMaybe<Scalars['String']>;
  /** OIDC client ID */
  clientId?: InputMaybe<Scalars['String']>;
  /** OIDC client secret */
  clientSecret?: InputMaybe<Scalars['String']>;
  /** OIDC discovery URL */
  discoveryUrl?: InputMaybe<Scalars['String']>;
  /** OIDC display name */
  displayName?: InputMaybe<Scalars['String']>;
  /** The ID of the SSO Domain */
  id: Scalars['ID'];
  /** OIDC issuer URL */
  issuer?: InputMaybe<Scalars['String']>;
  /** OIDC JWKS URI */
  jwksUri?: InputMaybe<Scalars['String']>;
};

export type SsoProviderSamlGenerateEntityIdInput = {
  /** The ID of the SSO provider to generate entityId for */
  id: Scalars['ID'];
};

export type SsoProviderSamlPublishInput = {
  /** SAML display name */
  displayName?: InputMaybe<Scalars['String']>;
  /** The ID of the SSO */
  id: Scalars['ID'];
  /** The SAML sign-in endpoint URL. */
  signInEndpoint?: InputMaybe<Scalars['String']>;
  /** The SAML signing certificate. */
  signingCert?: InputMaybe<Scalars['String']>;
};

export type SsoProviderSamlUpsertInput = {
  /** SAML display name */
  displayName?: InputMaybe<Scalars['String']>;
  /** The ID of the SSO Domain */
  id: Scalars['ID'];
  /** The SAML sign-in endpoint URL. */
  signInEndpoint?: InputMaybe<Scalars['String']>;
  /** The SAML signing certificate. */
  signingCert?: InputMaybe<Scalars['String']>;
};

/** Enumeration of supported SSO providers */
export enum SsoProviderStrategy {
  Oidc = 'oidc',
  Samlp = 'samlp'
}

export type SsoRevalidateInput = {
  /** The ID of the SSO Domain */
  id: Scalars['ID'];
};

/** Enumeration of SSO validation statuses */
export enum SsoValidationStatus {
  Completed = 'completed',
  Failed = 'failed',
  Pending = 'pending'
}

export type SubscriptionNameUpdateInput = {
  /** The new name of the subscription. */
  name: Scalars['String'];
  /** The ID of the subscription to update. */
  subscriptionId: Scalars['ID'];
};

export type SubscriptionUpdateInput = {
  /** The IDs of the customers to assign to the subscription. */
  customerIds: Array<Scalars['ID']>;
  /** The ID of the subscription to update. */
  subscriptionId: Scalars['ID'];
};

export type SubscriptionUpdatePayload = {
  __typename?: 'SubscriptionUpdatePayload';
  /** The updated subscription. */
  subscription: WaveSubscription;
};

export type SubscriptionUsage = {
  __typename?: 'SubscriptionUsage';
  /** The amount of assignments used. */
  current: Scalars['Int'];
  /** The amount of available assignments. When `null`, there is no limit to the amount of available assignments */
  max?: Maybe<Scalars['Int']>;
};

export enum SwitchType {
  Off = 'OFF',
  On = 'ON'
}

export type Target = {
  __typename?: 'Target';
  /** The target for brightness trait (HOST, GUEST, or BOTH). */
  brightness?: Maybe<Scalars['String']>;
  /** The target for infraRedControl trait (HOST, GUEST, or BOTH). */
  infraRedControl?: Maybe<Scalars['String']>;
  /** The target for keyboardControl trait (HOST, GUEST, or BOTH). */
  keyboardControl?: Maybe<Scalars['String']>;
  /** The target for mute trait (HOST, GUEST, or BOTH). */
  mute?: Maybe<Scalars['String']>;
  /** The target for power trait (HOST, GUEST, or BOTH). */
  power?: Maybe<Scalars['String']>;
  /** The target for reboot trait (HOST, GUEST, or BOTH). */
  reboot?: Maybe<Scalars['String']>;
  /** The target for screenshot trait (HOST, GUEST, or BOTH). */
  screenshot?: Maybe<Scalars['String']>;
  /** The target for volumeLevel trait (HOST, GUEST, or BOTH). */
  volumeLevel?: Maybe<Scalars['String']>;
  /** The target for volumeMax trait (HOST, GUEST, or BOTH). */
  volumeMax?: Maybe<Scalars['String']>;
  /** The target for volumeMin trait (HOST, GUEST, or BOTH). */
  volumeMin?: Maybe<Scalars['String']>;
};

export type Temperature = {
  __typename?: 'Temperature';
  /** The temperature value as a string (for presence type) */
  degrees?: Maybe<Scalars['String']>;
  /** Whether sensor is present */
  isSensorPresent?: Maybe<Scalars['Boolean']>;
  /** The id of the sensor */
  sensorId?: Maybe<Scalars['String']>;
  /** The temperature unit. */
  unit: Scalars['String'];
  /** The numeric value of the temperature sensor (for sensor type) */
  value?: Maybe<Scalars['Float']>;
};

export type TemperatureThreshold = {
  __typename?: 'TemperatureThreshold';
  /** Maximum critical temperature threshold value */
  max: Scalars['Float'];
  /** Warning temperature threshold value */
  maxWarning: Scalars['Float'];
};

export type TimeBlock = {
  __typename?: 'TimeBlock';
  /** The day of the week when the schedule has to be applied. */
  day: Day;
  /** The time of the day, with format hh:mm, when the display will go on standby.. */
  end: Scalars['String'];
  /** The time of the day, with format hh:mm, when the display will go online. */
  start: Scalars['String'];
};

export enum TimeBlockCategory {
  Content = 'CONTENT',
  Settings = 'SETTINGS'
}

export type TimeBlockInput = {
  day: Day;
  end: Scalars['String'];
  start: Scalars['String'];
};

export enum TimeBlockType {
  Apps = 'APPS',
  Bookmark = 'BOOKMARK',
  Brightness = 'BRIGHTNESS',
  DefaultInputSource = 'DEFAULT_INPUT_SOURCE',
  Playlist = 'PLAYLIST',
  Source = 'SOURCE'
}

export type TimeZoneState = {
  __typename?: 'TimeZoneState';
  /** The newly desired time zone, if any. */
  desired?: Maybe<Scalars['String']>;
  /** The last configured time zone. */
  reported: Scalars['String'];
  /** The supported values for the time zones of the display. */
  supportedValues: Array<Scalars['String']>;
};

export type UpdateDefaultConfigurationInput = {
  /** Customer handle of customer for which default configuration will be created. */
  customerHandle: Scalars['String'];
  /** List of platform and configuration ID pairs associated with this default configuration. */
  defaultConfigurations: Array<DefaultConfigurationMapInput>;
  /** ID of multi-claim for which default configuration will be created. */
  multiClaimId?: InputMaybe<Scalars['String']>;
  /** Type of the default configuration. */
  type: DefaultConfigurationType;
};

export type UsageStatistics = {
  __typename?: 'UsageStatistics';
  contentSource: ContentSourceStatistics;
  powerState: PowerStateStatistics;
  presence: PresenceStatistics;
  warnings: WarningStatistics;
};

export type User = {
  __typename?: 'User';
  /** When the user was created. */
  createdAt: Scalars['DateTime'];
  /** The customer ids the user has access to. */
  customerIds?: Maybe<Array<Scalars['String']>>;
  /** The email address of the user. */
  email: Scalars['String'];
  /** The last name of the user. */
  familyName: Scalars['String'];
  /** The first name of the user. */
  givenName: Scalars['String'];
  /** The identifier of the user. */
  id: Scalars['ID'];
  /** When the user last signed in. Null until their first sign-in is recorded. */
  lastLogin?: Maybe<Scalars['DateTime']>;
  /** The UI language of the user. */
  locale?: Maybe<Scalars['String']>;
  /** The organization roles of the user. */
  roles: Array<Role>;
  /** The Service Admin roles of the user. Empty when the user is not a Service Admin. */
  serviceAdminRoles: Array<ServiceAdminRole>;
  /** The sub identifier of the user. */
  sub: Scalars['ID'];
  /** The temperature unit of the user. */
  tempUnit?: Maybe<Scalars['String']>;
};

export type UserCreateInput = {
  /** The customer ids the user has access to. */
  customerIds?: InputMaybe<Array<Scalars['String']>>;
  /** The email address of the new user. An invitation e-mail will be sent to this address. */
  email: Scalars['String'];
  /** The last name of the new user. */
  familyName?: InputMaybe<Scalars['String']>;
  /** The first name of the new user. */
  givenName?: InputMaybe<Scalars['String']>;
  /** The roles of the new user. */
  roles: Array<Role>;
};

export type UserDeleteInput = {
  /** The identifier of the user. */
  userId: Scalars['ID'];
};

export type UserDeletePayload = {
  __typename?: 'UserDeletePayload';
  /** The identifier of the user that was deleted. */
  userId: Scalars['String'];
};

export type UserUpdateInput = {
  /** The customer ids the user has access to. */
  customerIds?: InputMaybe<Array<Scalars['String']>>;
  /** The last name of the new user. */
  familyName: Scalars['String'];
  /** The first name of the new user. */
  givenName: Scalars['String'];
  /** The roles that will be given to the user. */
  roles: Array<Role>;
  /** The Service Admin roles that will be given to the user, replacing the current ones. Left unchanged when omitted. Only SuperAdmin and SuperAdminUserManagement may change them, and only SuperAdmin may grant or revoke SuperAdmin. */
  serviceAdminRoles?: InputMaybe<Array<ServiceAdminRole>>;
  /** The identifier of the user. */
  userId: Scalars['ID'];
};

export type UserUpdatePayload = {
  __typename?: 'UserUpdatePayload';
  /** The user that was updated. */
  user: User;
};

export type Volume = {
  __typename?: 'Volume';
  /** Indicates whether the display is muted or not. */
  isMuted?: Maybe<VolumeMuteState>;
  /** The volume level of the display */
  level?: Maybe<VolumeLevelState>;
  /** The volume limits of the display */
  limits?: Maybe<VolumeLimitState>;
};

export type VolumeLevelState = {
  __typename?: 'VolumeLevelState';
  /** The newly desired volume level of the display. Cleared when successful, failed or timed out. */
  desired?: Maybe<Scalars['Int']>;
  /** The last reported volume level of the display */
  reported: Scalars['Int'];
};

export type VolumeLimit = {
  __typename?: 'VolumeLimit';
  /** The newly desired volume limit of the display. Cleared when successful, failed or timed out. */
  desired?: Maybe<Scalars['Int']>;
  /** The last reported volume limit of the display */
  reported: Scalars['Int'];
};

export type VolumeLimitState = {
  __typename?: 'VolumeLimitState';
  /** The maximum volume limit of the display, `null` if the display doesn't support a maximum limit. */
  max?: Maybe<VolumeLimit>;
  /** The minimum volume limit of the display, `null` if the display doesn't support a minimum limit. */
  min?: Maybe<VolumeLimit>;
};

export type VolumeMuteState = {
  __typename?: 'VolumeMuteState';
  /** The newly desired mute state of the display. Cleared when successful, failed or timed out. */
  desired?: Maybe<Scalars['Boolean']>;
  /** The last reported mute state of the display. */
  reported: Scalars['Boolean'];
};

export type Warning = {
  __typename?: 'Warning';
  key: Scalars['String'];
  label: Scalars['String'];
};

export type WarningStatistics = {
  __typename?: 'WarningStatistics';
  emptyShadowWarnings: Scalars['Int'];
  outOfSyncPlaylistWarnings: Scalars['Int'];
  outOfSyncPowerScheduleWarnings: Scalars['Int'];
  outOfSyncScheduleWarnings: Scalars['Int'];
  playlistSyncFailedWarnings: Scalars['Int'];
  powerScheduleSyncFailedWarnings: Scalars['Int'];
  recommendedSettingsWarnings: Scalars['Int'];
  scheduleSyncFailedWarnings: Scalars['Int'];
  undefinedRecommendedSettingsWarnings: Scalars['Int'];
};

export type WaveSubscription = {
  __typename?: 'WaveSubscription';
  /** Indicates if the subscription is assignable to a customer. */
  assignable: Scalars['Boolean'];
  /** The date that this subscription was created. */
  createdAt: Scalars['DateTime'];
  /** The customers linked to the subscription. */
  customers: Array<PartialCustomer>;
  /** The identifier of this subscription */
  id: Scalars['ID'];
  /** The name of this subscription. */
  name: Scalars['String'];
  /** The product identifier in the AppDirect Marketplace. */
  productId: Scalars['String'];
  /** The status of the subscription. */
  status: WaveSubscriptionStatus;
  /** The date that this subscription was last updated. */
  updatedAt: Scalars['DateTime'];
  /** The current usage of the subscription. */
  usage: SubscriptionUsage;
  /** The name of this subscription. */
  userGivenName?: Maybe<Scalars['String']>;
  /** The date that this subscription will expire. */
  validUntil: Scalars['DateTime'];
};

export enum WaveSubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED'
}

export type ZteBatchFilter = {
  __typename?: 'ZteBatchFilter';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ZteBulkEnrolmentPairInput = {
  /** The identifier of the customer to Pair the enrolment to. */
  customerId: Scalars['ID'];
  /** The identifier of the ZTE enrolment. */
  enrolmentIds: Array<Scalars['ID']>;
};

export type ZteBulkEnrolmentPairPayload = {
  __typename?: 'ZteBulkEnrolmentPairPayload';
  /** The list of ZTE enrolments that were Paired to the customer. */
  enrolments: Array<ZteEnrolment>;
};

export type ZteBulkUnpairInput = {
  /** The identifiers of the ZTE enrolments to unpair. */
  enrolmentIds: Array<Scalars['ID']>;
};

export type ZteBulkUnpairPayload = {
  __typename?: 'ZteBulkUnpairPayload';
  /** The list of ZTE enrolments that were unpaired. */
  enrolments: Array<ZteEnrolment>;
};

export type ZteCustomerFilter = {
  __typename?: 'ZteCustomerFilter';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ZteEnrolment = {
  __typename?: 'ZteEnrolment';
  /** The alias of the Zte device */
  alias?: Maybe<Scalars['String']>;
  /** The date and time when the enrolment was assigned to a customer. */
  assignedAt?: Maybe<Scalars['DateTime']>;
  /** The batchId of the Zte device */
  batchId?: Maybe<Scalars['String']>;
  /** The batchName of the Zte device */
  batchName?: Maybe<Scalars['String']>;
  /** The date and time when the enrolment was created. */
  createdAt: Scalars['DateTime'];
  /** The identifier of the customer assigned to this enrolment. */
  customerId?: Maybe<Scalars['ID']>;
  /** The customer assigned to this ZTE enrolment. */
  customerName?: Maybe<Scalars['String']>;
  /** The firmware version of the ZTE device. */
  firmwareVersion?: Maybe<Scalars['String']>;
  /** The unique identifier of the ZTE enrolment. */
  id: Scalars['ID'];
  /** The MAC address of the ZTE device. */
  macAddress?: Maybe<Scalars['String']>;
  /** The model of the ZTE device. */
  modelNumber?: Maybe<Scalars['String']>;
  /** The serial number of the ZTE device. */
  serialNumber?: Maybe<Scalars['String']>;
  /** The current status of the ZTE enrolment. */
  status: Scalars['String'];
};

export type ZteEnrolmentFiltersInput = {
  /** Filter by batch name associated with the enrolment. */
  batchName?: InputMaybe<Array<Scalars['String']>>;
  /** Filter by customer name associated with the enrolment. */
  customerName?: InputMaybe<Array<Scalars['String']>>;
  /** Filter by model number of the ZTE device. */
  modelNumber?: InputMaybe<Array<Scalars['String']>>;
  /** Filter by state of the enrolment. */
  status?: InputMaybe<Array<ZteEnrolmentStatus>>;
};

export enum ZteEnrolmentStatus {
  Claimed = 'CLAIMED',
  Paired = 'PAIRED',
  Unpaired = 'UNPAIRED'
}

export type ZteFilters = {
  __typename?: 'ZteFilters';
  batches: Array<ZteBatchFilter>;
  customers: Array<ZteCustomerFilter>;
  modelNumbers: Array<Scalars['String']>;
};
